var Ii = Object.defineProperty;
var Ai = (e, t, n) => t in e ? Ii(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var pe = (e, t, n) => Ai(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as U, ref as _, createElementBlock as I, openBlock as g, mergeProps as ve, mergeModels as ie, useModel as fe, computed as k, withKeys as gt, normalizeClass as F, createElementVNode as R, createBlock as P, createCommentVNode as A, withModifiers as Qt, toDisplayString as Q, resolveComponent as Ei, isRef as Mi, toValue as q, getCurrentScope as go, onScopeDispose as yo, onMounted as bn, nextTick as zi, watch as le, getCurrentInstance as wn, hasInjectionContext as xo, inject as Fi, toRef as gn, readonly as Ni, customRef as $i, shallowRef as Ie, watchEffect as Oi, unref as M, useAttrs as yn, resolveDynamicComponent as at, withCtx as Y, Comment as Li, Text as Di, Fragment as et, useSlots as Ue, createVNode as ae, renderSlot as H, createTextVNode as Co, shallowReadonly as $e, useTemplateRef as Re, withDirectives as Ae, Transition as ko, normalizeStyle as Rn, useId as Fe, vModelCheckbox as To, vModelText as So, createSlots as Io, vShow as Ao, renderList as Yt, onBeforeUnmount as Ri, Teleport as Pi } from "vue";
const Vi = "groover", Hi = 1746441930, Bi = {
  charts: {
    body: '<path fill="currentColor" d="M14.968 7.08q0-.215.093-.413.094-.198.265-.35.173-.152.397-.235c.148-.054.307-.082.468-.082h5.587c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.23.203-.54.317-.864.317H16.19c-.16 0-.32-.028-.468-.082a1.2 1.2 0 01-.397-.235c-.113-.1-.203-.22-.265-.35a1 1 0 01-.093-.414m6.81 7.563H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316m0-4.36H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316M10.603 8.16H7.635v6.907c0 .58-.194 1.147-.559 1.629a3.26 3.26 0 01-1.489 1.08 3.7 3.7 0 01-1.917.167 3.47 3.47 0 01-1.698-.803 2.85 2.85 0 01-.908-1.501 2.62 2.62 0 01.189-1.695 3.04 3.04 0 011.221-1.316 3.64 3.64 0 011.844-.494c.295.004.589.043.873.116V7.08c0-.287.128-.562.358-.765S6.089 6 6.413 6h4.19c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.229.203-.54.317-.864.317"/>',
    width: 24,
    height: 24
  },
  "groover-plus": {
    body: '<g fill="currentColor"><path fill-opacity="15.5%" d="m11.395 23.685-9.771-8.802-1.265-1.265a1.227 1.227 0 010-1.735L11.873.36c.257-.257.615-.387.978-.354l10.035.913A1.226 1.226 0 0124 2.14v9.586c0 .316-.122.62-.34.848L13.1 23.62a1.225 1.225 0 01-1.705.064"/><path d="M19.323 5.881H21.6v1.473h-2.277v2.254h-1.445V7.354H15.6V5.881h2.278V3.603h1.445zM14.222 17.74l-.258-1.225h-.032c-.725 1.048-1.901 1.5-3.303 1.5-1.547 0-2.868-.532-3.802-1.532-1.064-1.129-1.595-2.677-1.595-4.467 0-3.402 2.159-6.014 5.72-6.014 3.012 0 4.913 1.564 5.284 4.128H12.98c-.177-.742-.87-1.355-1.9-1.355-1.612 0-2.434 1.355-2.434 3.241s.935 3.29 2.562 3.29c1.225 0 1.82-.661 2.03-1.435h-1.53v-2.387h4.752v6.257z"/></g>',
    width: 24,
    height: 24
  },
  "groover-plus-logo": {
    body: '<path fill="currentColor" d="M20.55 5.32h3.321v2.147H20.55v3.283h-2.108V7.467h-3.32V5.32h3.32V2h2.108zM13.11 22.6l-.375-1.785h-.047C11.63 22.342 9.915 23 7.87 23c-2.256 0-4.182-.775-5.545-2.232C.776 19.123 0 16.868 0 14.259c0-4.957 3.148-8.763 8.341-8.763 4.394 0 7.166 2.279 7.707 6.015h-4.746c-.259-1.081-1.27-1.974-2.773-1.974-2.35 0-3.548 1.973-3.548 4.722s1.363 4.794 3.736 4.794c1.786 0 2.655-.964 2.96-2.091H9.445v-3.478h6.932v9.117z"/>',
    width: 24,
    height: 24
  },
  logo: {
    body: '<path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M101.447 30.545c0 13.948-6.004 25.907-14.596 31.045a3 3 0 01-1.539.41h-15.73a3.03 3.03 0 01-1.539-.41c-4.795-2.869-8.789-7.881-11.375-14.162a.35.35 0 00-.67.056c-1.407 5.836-3.529 10.54-6.08 13.472a3.05 3.05 0 01-2.299 1.04H40.04a3.03 3.03 0 01-2.309-1.05c-3.224-3.73-5.765-10.33-7.052-18.411-.066-.42-.658-.4-.703.02-.815 7.662-2.41 13.995-4.431 17.792-.538 1.008-1.574 1.65-2.704 1.65h-3.499a3.05 3.05 0 01-2.697-1.626c-1.803-3.366-3.266-8.725-4.136-15.234-.056-.43-.673-.41-.714.021-.552 6.235-1.443 11.392-2.552 14.782C8.837 61.18 7.66 62 6.362 62h-.264c-1.352 0-2.53-.82-2.936-2.07C1.266 54.14 0 43.155 0 30.545c-.01-11.9 1.11-22.341 2.826-28.352A3.05 3.05 0 015.752 0h.87a3.06 3.06 0 012.937 2.203c.956 3.366 1.726 8.116 2.222 13.717.031.431.659.442.714.021.78-5.835 2.035-10.75 3.585-14.127C16.597.708 17.675 0 18.874 0h4.424c1.2 0 2.278.697 2.784 1.793 1.772 3.875 3.159 9.756 3.904 16.74.045.42.638.431.704.021 1.165-7.341 3.377-13.475 6.181-17.328A3.01 3.01 0 0139.323 0h9.042c.967 0 1.879.441 2.45 1.23 2.147 2.945 3.96 7.24 5.19 12.378a.353.353 0 00.673.056c2.299-5.58 5.697-10.15 9.791-13.121A3 3 0 0168.22 0H86.7c.627 0 1.245.179 1.75.553 7.722 5.612 13.002 16.93 13.002 29.992"/>',
    width: 101.45,
    height: 62
  },
  "opportunity-advice": {
    body: '<g fill="currentColor"><path d="M25.386 25.526a2.49 2.49 0 002.489-2.489v-9.55a2.49 2.49 0 00-2.489-2.49H12.492a2.49 2.49 0 00-2.49 2.49v9.55a2.49 2.49 0 002.49 2.49h.375v3.262c0 .23.139.444.358.53a.57.57 0 00.63-.12l3.672-3.673zm-11.358-.577a.58.58 0 00-.578-.578h-.952c-.734 0-1.334-.6-1.334-1.334v-9.55c0-.734.6-1.335 1.334-1.335h12.894c.734 0 1.334.601 1.334 1.334v9.551c0 .734-.6 1.334-1.334 1.334h-8.095a.6.6 0 00-.22.046.6.6 0 00-.19.127l-2.853 2.853v-2.442z"/><path d="M33.505 18.643H29.21a.58.58 0 00-.578.577c0 .318.26.578.578.578h4.296c.733 0 1.334.6 1.334 1.334v9.55c0 .734-.6 1.335-1.334 1.335h-.953a.58.58 0 00-.577.577v2.443l-2.853-2.853a.55.55 0 00-.19-.127.6.6 0 00-.22-.046h-8.095c-.734 0-1.334-.6-1.334-1.334v-3.823a.58.58 0 00-.578-.577.58.58 0 00-.577.577v3.823a2.49 2.49 0 002.489 2.489h7.859l3.672 3.672a.581.581 0 00.988-.41v-3.262h.375A2.49 2.49 0 0036 30.677v-9.551a2.49 2.49 0 00-2.489-2.489z"/><path d="M32.553 27.715H21.09a.58.58 0 00-.577.577c0 .318.26.578.577.578h11.463a.58.58 0 00.577-.578.58.58 0 00-.578-.577m-3.343-1.235h3.343a.58.58 0 00.578-.578.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577m-.001-2.385h3.343a.58.58 0 00.578-.577.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577M12.273 9.549a.58.58 0 00.577-.578V6.39a.58.58 0 00-.577-.577.58.58 0 00-.578.577v2.58c0 .318.26.578.578.578M7.815 7.995a.575.575 0 10-.814.814l1.825 1.825a.59.59 0 00.82 0 .575.575 0 000-.814L7.82 7.995zm.155 4.701H5.39a.58.58 0 00-.578.577c0 .318.26.578.577.578h2.582a.58.58 0 00.577-.578.58.58 0 00-.577-.577m10.971 8.748 2.223 1.172a.6.6 0 00.272.064.578.578 0 00.572-.676l-.428-2.477 1.802-1.756a.58.58 0 00-.324-.987l-2.489-.364-1.114-2.252c-.196-.393-.843-.393-1.034 0l-1.114 2.252-2.489.364a.58.58 0 00-.468.393.58.58 0 00.145.594l1.801 1.756-.427 2.477a.58.58 0 00.231.566.59.59 0 00.606.046l2.224-1.172zm-2.795-3.684 1.629-.237a.56.56 0 00.433-.318l.727-1.478.728 1.478a.58.58 0 00.433.318l1.628.237-1.178 1.149a.58.58 0 00-.167.514l.277 1.622-1.455-.768a.59.59 0 00-.537 0l-1.455.768.277-1.622a.57.57 0 00-.167-.514l-1.178-1.15z"/></g>'
  },
  "opportunity-article": {
    body: '<g fill="currentColor"><path d="M33.848 5.839H8.155A3.156 3.156 0 005.004 8.99v24.202a3.156 3.156 0 003.152 3.151h25.692A3.156 3.156 0 0037 33.194V8.99a3.16 3.16 0 00-3.152-3.152M8.155 6.899h25.691c1.153 0 2.091.94 2.091 2.092v1.48H6.064v-1.48c0-1.154.938-2.092 2.09-2.092m25.693 28.387H8.155a2.093 2.093 0 01-2.092-2.092V11.531H35.94v21.662a2.094 2.094 0 01-2.091 2.093"/><path d="M8.677 9.423h1.862a.53.53 0 100-1.06H8.677a.53.53 0 100 1.06m4.535 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m4.537 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m15.791 4.025H8.46a.53.53 0 00-.53.53v5.77c0 .293.238.53.53.53h25.084a.53.53 0 00.53-.53V13.98a.53.53 0 00-.532-.531m-.528 5.77H8.99v-4.71h24.022zm.528 6.017h-7.165a.53.53 0 00-.53.53v7.164c0 .293.237.53.53.53h7.165a.53.53 0 00.53-.53l.001-7.164a.53.53 0 00-.531-.53m-.529 7.166H26.91v-6.105h6.105zm.529-9.984H8.46a.53.53 0 100 1.06h25.084a.53.53 0 10-.002-1.06M22.84 25.617H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.203H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.199H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06"/></g>'
  },
  "opportunity-audio-interview": {
    body: '<g fill="currentColor"><path d="M12.886 17.76a.66.66 0 00.065-.931 3.9 3.9 0 01-.953-2.567c0-.948.339-1.86.953-2.567a.66.66 0 10-.996-.865 5.23 5.23 0 00-1.275 3.432c0 1.267.452 2.485 1.275 3.432a.656.656 0 00.93.064zm17.203-6.93a.66.66 0 00-.995.866c.614.707.953 1.619.953 2.567s-.34 1.86-.953 2.567a.66.66 0 00.996.866 5.23 5.23 0 001.276-3.432 5.23 5.23 0 00-1.276-3.432z"/><path d="M32.094 9.114a.66.66 0 10-1.001.859 6.58 6.58 0 011.588 4.29 6.58 6.58 0 01-1.588 4.29.66.66 0 001.001.86 7.906 7.906 0 000-10.298M9.361 14.263c0-1.576.564-3.098 1.587-4.29a.66.66 0 00-1-.859 7.9 7.9 0 00-1.906 5.149c0 1.89.678 3.719 1.906 5.149a.659.659 0 101-.86 6.58 6.58 0 01-1.587-4.29zm19.571 6.952a.66.66 0 00-.659.66 4.813 4.813 0 01-4.808 4.807H18.58a4.813 4.813 0 01-4.808-4.808.659.659 0 10-1.317 0A6.133 6.133 0 0018.579 28h1.784v2.637h-3.296a1.98 1.98 0 00-1.977 1.977 1.98 1.98 0 001.977 1.978h7.91a1.98 1.98 0 001.977-1.978 1.98 1.98 0 00-1.977-1.977h-3.296V28h1.783a6.133 6.133 0 006.127-6.126.66.66 0 00-.66-.659m-3.296 11.399a.66.66 0 01-.66.659h-7.91a.66.66 0 010-1.318h7.91a.66.66 0 01.66.659"/><path d="M18.579 25.363h4.886a3.493 3.493 0 003.489-3.49V10.397a3.493 3.493 0 00-3.489-3.489h-4.887a3.493 3.493 0 00-3.488 3.49v11.477a3.493 3.493 0 003.488 3.489m0-17.139h4.886c1.198 0 2.172.974 2.172 2.17v1.125h-1.978a.659.659 0 100 1.318h1.978v2.636h-1.978a.658.658 0 100 1.317h1.978v2.637h-1.978a.659.659 0 100 1.317h1.978v1.125a2.174 2.174 0 01-2.172 2.171h-4.887a2.173 2.173 0 01-2.17-2.171v-1.125h1.978a.66.66 0 000-1.317h-1.978V16.79h1.978a.66.66 0 000-1.317h-1.978v-2.636h1.978a.66.66 0 000-1.318h-1.978v-1.124c0-1.198.974-2.17 2.17-2.17"/></g>'
  },
  "opportunity-channel": {
    body: '<g fill="currentColor" stroke="currentColor" stroke-width=".1"><path d="M6.526 29.012H35.78l.003.004h.02c.56 0 1.011-.455 1.011-1.011V8.019c0-.56-.455-1.01-1.01-1.01H6.526c-.56 0-1.01.455-1.01 1.01v19.982c0 .56.454 1.011 1.01 1.011Zm29.12-20.84v19.677H6.68V8.172z"/><path d="M17.614 22.685h.05v-.005a.6.6 0 00.24-.076l7.094-4.094a.584.584 0 000-1.008l-7.093-4.094a.584.584 0 00-.873.504v8.192c0 .21.113.4.29.504h.001a.6.6 0 00.29.077Zm.581-7.769 5.349 3.09-5.349 3.09zm-4.763 19.549H36.23a.581.581 0 100-1.163H13.432a.581.581 0 100 1.163Zm-7.335 0h3.215a.581.581 0 100-1.163H6.097a.581.581 0 100 1.163Z"/><path d="M8.734 33.883a2.64 2.64 0 002.638 2.637 2.643 2.643 0 002.638-2.637 2.643 2.643 0 00-2.638-2.638 2.643 2.643 0 00-2.638 2.638Zm1.164-.004c0-.812.661-1.474 1.474-1.474s1.474.662 1.474 1.474c0 .813-.662 1.474-1.474 1.474a1.476 1.476 0 01-1.474-1.474Z"/></g>'
  },
  "opportunity-detailed-feedback": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M33.011 24.616A1.397 1.397 0 0034.4 23.22v-7.905a1.396 1.396 0 00-1.388-1.397H19.573a1.397 1.397 0 00-1.388 1.397V25.96c.32-.043.961-.37 1.575-.682.662-.338 1.295-.66 1.64-.66zm-5.049-5.349-3.64-2.115v4.23zm.75-.261a.303.303 0 010 .522l-4.521 2.627a.3.3 0 01-.169.052.3.3 0 01-.3-.302v-5.276a.3.3 0 01.041-.15.3.3 0 01.41-.11zm-2.12 6.215v7.275A1.503 1.503 0 0125.1 34H10.67a1.505 1.505 0 01-1.494-1.504V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59zm-.6-11.909V7.384a.9.9 0 00-.893-.898H10.67a.9.9 0 00-.893.899v25.111a.9.9 0 00.893.9h14.429a.9.9 0 00.893-.899V25.22H21.4c-.206 0-.776.29-1.372.594-.72.368-1.476.753-1.908.753-.337 0-.537-.15-.537-.516V15.314a2 2 0 01.584-1.412c.362-.365.86-.59 1.405-.59zM15.748 9.014a.302.302 0 010-.605h4.27a.302.302 0 010 .605z"/><path fill="currentColor" fill-rule="evenodd" d="M33.778 23.995c.199-.2.32-.474.32-.776v-7.905a1.096 1.096 0 00-1.087-1.097H19.573a1.1 1.1 0 00-1.088 1.097v10.241q.113-.045.253-.109c.27-.123.577-.28.885-.436l.008-.004c.326-.167.656-.335.949-.461.282-.122.579-.229.82-.229h11.611c.299 0 .57-.123.767-.32m-15.293 1.881a1.5 1.5 0 01-.3.082V15.315a1.397 1.397 0 011.388-1.397H33.01a1.396 1.396 0 011.388 1.397v7.906a1.397 1.397 0 01-1.388 1.396H21.4c-.345 0-.978.323-1.64.66h-.001c-.458.234-.931.476-1.275.6m7.244 7.256a.9.9 0 01-.63.263H10.67a.9.9 0 01-.893-.899V7.384a.9.9 0 01.893-.898h14.429a.9.9 0 01.893.899v5.927h-6.42c-.544 0-1.042.225-1.404.59a2 2 0 00-.584 1.412v10.738c0 .366.2.516.537.516.432 0 1.187-.385 1.907-.752h.001c.596-.304 1.166-.595 1.372-.595h4.59v7.275a.9.9 0 01-.262.636m-.038-7.61v6.974a.6.6 0 01-.592.6H10.67a.6.6 0 01-.593-.599V7.383a.6.6 0 01.593-.598h14.429a.6.6 0 01.593.599v5.627h-6.12c-.629 0-1.201.26-1.617.678a2.3 2.3 0 00-.671 1.624v10.738c0 .236.066.46.24.618.17.153.39.198.597.198.284 0 .631-.12.964-.263.342-.146.718-.337 1.074-.519l.007-.003c.299-.153.584-.298.82-.406a4 4 0 01.296-.122c.076-.027.11-.032.117-.034h4.292m-1.368-9.413c.088.051 4.703 2.763 4.758 2.857a.603.603 0 01-.219.821L24.35 22.41a.602.602 0 01-.927-.505v-5.282a.6.6 0 01.08-.294m.689 5.826 4.52-2.627a.303.303 0 000-.522l-4.538-2.638a.3.3 0 00-.41.11.3.3 0 00-.041.151v5.276a.302.302 0 00.469.25m.132-6.046a.6.6 0 00-.82.22ZM9.616 33.559a1.5 1.5 0 01-.44-1.063V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59h-6.419v7.274A1.503 1.503 0 0125.1 34H10.67c-.41 0-.783-.169-1.054-.441m17.276-8.038v6.975c0 .496-.201.947-.525 1.273a1.8 1.8 0 01-1.268.531H10.67a1.806 1.806 0 01-1.794-1.804V7.384a1.803 1.803 0 011.794-1.803h14.429a1.806 1.806 0 011.794 1.804v5.627h6.118c.63 0 1.203.26 1.616.677.415.418.673.993.673 1.625v7.906a2.3 2.3 0 01-.671 1.623 2.28 2.28 0 01-1.618.678zm-2.57-8.369v4.23l3.64-2.115zm.3.521 2.743 1.594-2.742 1.593zM15.75 9.315a.602.602 0 010-1.205h4.27a.602.602 0 010 1.205zm-.3-.602c0 .167.135.302.3.302h4.27a.302.302 0 000-.605h-4.27c-.165 0-.3.136-.3.303" clip-rule="evenodd"/><path fill="currentColor" d="M19 31a1 1 0 11-2 0 1 1 0 012 0"/></g>'
  },
  "opportunity-dj-set": {
    body: '<g fill="currentColor"><path d="M18.616 13.769a7.23 7.23 0 107.23 7.23 7.243 7.243 0 00-7.23-7.23m0 13.184a5.954 5.954 0 115.953-5.954 5.96 5.96 0 01-5.953 5.954"/><path d="M18.616 18.447a2.553 2.553 0 100 5.105 2.553 2.553 0 000-5.105m0 3.829a1.276 1.276 0 110-2.553 1.276 1.276 0 010 2.553"/><path d="M34.92 7.478h-1.972a2.086 2.086 0 00-2.08 2.086v4.352a2.08 2.08 0 002.08 2.08h.344v1.06a2.73 2.73 0 01-1.276 2.22A13.438 13.438 0 1032.138 21v-.293l.638-.383a3.83 3.83 0 001.831-3.267v-1.06h.351A2.08 2.08 0 0037 13.916V9.564a2.087 2.087 0 00-2.08-2.086M18.616 33.245A12.245 12.245 0 1130.804 20.01l-1.276.779a2.074 2.074 0 10.65 1.097l.639-.395a12.25 12.25 0 01-12.201 11.754M28.96 22.339a.804.804 0 11-1.608 0 .804.804 0 011.608 0m6.764-8.423a.81.81 0 01-.804.804h-1.972a.804.804 0 01-.804-.804V9.564a.804.804 0 01.804-.81h1.972a.81.81 0 01.804.81z"/><path d="M21.213 12.149a.639.639 0 10-.364 1.225c.602.179 1.18.427 1.723.74a.64.64 0 00.32.083.64.64 0 00.555-.32.64.64 0 00-.236-.867 9.4 9.4 0 00-1.998-.861"/><path d="M13.339 12.48a.64.64 0 00.319-.083 9.93 9.93 0 019.91 0 .64.64 0 00.867-.236.64.64 0 00-.197-.867 11.3 11.3 0 00-8.462-1.143c-.964.257-1.891.639-2.756 1.136a.638.638 0 00.319 1.187zm5.277 17.74a.638.638 0 000-1.276 7.9 7.9 0 01-3.95-1.06.639.639 0 10-.638 1.104 9.17 9.17 0 004.588 1.232"/><path d="M23.6 29.601a9.93 9.93 0 01-9.91 0 .638.638 0 00-.639 1.104c.855.497 1.771.881 2.725 1.142a11.2 11.2 0 008.462-1.142.638.638 0 00-.639-1.104"/></g>'
  },
  "opportunity-live-events": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M35.878 22.982a.32.32 0 00.322-.323V18.1a.32.32 0 00-.322-.323h-3.223l-.334-.718c-.072-.168-.263-.227-.43-.156a1.627 1.627 0 01-2.148-.801 1.64 1.64 0 01-.048-1.256c.155-.407.442-.718.836-.898a.28.28 0 00.167-.18.3.3 0 00-.012-.25L28.764 9.39a.31.31 0 00-.43-.155L23.048 11.7h-.012L5.383 19.907a.33.33 0 00-.155.431l1.91 4.127c.071.168.262.228.43.156a1.624 1.624 0 012.147.802c.18.394.203.837.06 1.244-.143.406-.441.73-.835.92a.33.33 0 00-.155.432l1.91 4.14c.035.07.095.143.178.167.036.011.072.023.108.023a.24.24 0 00.13-.035l1.875-.874h22.892a.32.32 0 00.322-.323V26.56a.32.32 0 00-.322-.323c-.895 0-1.611-.73-1.611-1.627s.727-1.627 1.61-1.627m-24.742 8.602L9.488 28.02a2.24 2.24 0 00.883-1.125 2.3 2.3 0 00-.072-1.735 2.25 2.25 0 00-2.697-1.22l-1.647-3.565 17.067-7.956.43.921c.06.12.167.192.287.192a.24.24 0 00.13-.036c.156-.072.228-.263.156-.431l-.43-.921 4.727-2.202 1.659 3.566a2.23 2.23 0 00-.883 1.1 2.25 2.25 0 00.071 1.759 2.284 2.284 0 002.697 1.22l1.66 3.566-4.727 2.2-.43-.92a.32.32 0 00-.43-.156c-.154.072-.226.263-.154.43l.43.922zm22.486-6.975a2.27 2.27 0 001.934 2.25v3.935H14.37l14.394-6.7h.012l.012-.011 5.3-2.465c.071-.036.143-.096.166-.18a.37.37 0 00-.011-.25l-1.29-2.764h2.602v3.936a2.27 2.27 0 00-1.933 2.249"/><path fill="currentColor" d="M24.695 14.5a.31.31 0 00-.43-.155.33.33 0 00-.155.43l.56 1.22c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.156-.43zm1.23 2.656a.31.31 0 00-.43-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.155-.431zm1.215 2.643a.32.32 0 00-.429-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.191.287.191a.24.24 0 00.132-.035.33.33 0 00.155-.431zm-7.196 2.058 1.456-2.62a.31.31 0 00-.048-.37.31.31 0 00-.37-.072l-2.71 1.256-2.04-2.201a.31.31 0 00-.37-.072.306.306 0 00-.18.335l.359 2.979-2.71 1.268a.306.306 0 00-.178.335.304.304 0 00.262.275l2.936.574.358 2.98c.012.143.12.25.263.274h.06c.119 0 .226-.06.286-.167l1.456-2.62 2.936.574a.33.33 0 00.346-.155.31.31 0 00-.047-.371zM18.63 23.33a.33.33 0 00-.346.155l-1.086 1.962-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64z"/><path fill="currentColor" fill-rule="evenodd" d="M31.891 16.904c.167-.071.358-.012.43.156l.334.718h3.223a.32.32 0 01.322.323v4.558a.32.32 0 01-.322.323c-.883 0-1.611.73-1.611 1.627s.716 1.627 1.61 1.627c.18 0 .323.144.323.323v4.558a.32.32 0 01-.322.323H12.986l-1.874.874a.24.24 0 01-.131.035.4.4 0 01-.108-.023c-.083-.024-.143-.096-.179-.168l-1.91-4.14a.33.33 0 01.156-.43 1.624 1.624 0 00.775-2.166 1.624 1.624 0 00-2.148-.801c-.167.072-.358.012-.43-.156l-1.91-4.127a.33.33 0 01.156-.43L23.035 11.7h.012l5.288-2.464a.31.31 0 01.43.155l1.92 4.128a.3.3 0 01.013.25.28.28 0 01-.167.18c-.394.18-.68.49-.836.898-.155.406-.131.861.048 1.256a1.627 1.627 0 002.148.801m-1.966-.885a1.43 1.43 0 001.883.703l.005-.002c.25-.108.567-.025.69.258l.28.6h3.095a.52.52 0 01.522.523v4.558c0 .29-.233.523-.522.523-.772 0-1.411.64-1.411 1.427 0 .788.628 1.427 1.41 1.427.29 0 .523.233.523.523v4.558c0 .29-.233.524-.522.524H13.03l-1.822.85a.45.45 0 01-.227.059.5.5 0 01-.165-.032l-.003-.001a.5.5 0 01-.298-.27l-.003-.005-1.911-4.144a.53.53 0 01.253-.691c.348-.17.608-.453.733-.807a1.46 1.46 0 00-.054-1.094 1.424 1.424 0 00-1.883-.703l-.004.002c-.251.108-.568.025-.691-.258l-1.911-4.13a.53.53 0 01.255-.692m24.625-3.706a1.44 1.44 0 01-.042-1.1c.137-.36.386-.63.73-.786a.48.48 0 00.274-.296.5.5 0 00-.016-.397l-1.923-4.131a.51.51 0 00-.699-.254L23.003 11.5h-.012L5.3 19.725m5.073 7.17a2.23 2.23 0 01-.883 1.124l1.647 3.565 17.08-7.956-.43-.921a.33.33 0 01.155-.43.32.32 0 01.43.155l.43.92 4.726-2.2-1.66-3.566a2.284 2.284 0 01-2.697-1.22 2.25 2.25 0 01-.072-1.759c.168-.454.478-.837.884-1.1l-1.66-3.566-4.726 2.202.43.921a.33.33 0 01-.155.43.24.24 0 01-.131.037.32.32 0 01-.287-.192l-.43-.921-17.067 7.956 1.647 3.565a2.25 2.25 0 012.697 1.22 2.3 2.3 0 01.072 1.735m-2.658-3.193a2.45 2.45 0 012.768 1.374 2.5 2.5 0 01.079 1.885c-.162.45-.447.842-.82 1.125l1.492 3.231L27.95 23.53l-.347-.745a.53.53 0 01.252-.69.52.52 0 01.698.25l.345.74 4.364-2.032-1.505-3.232a2.49 2.49 0 01-2.766-1.37l-.001-.001a2.45 2.45 0 01-.078-1.914c.162-.44.447-.819.818-1.098l-1.503-3.231-4.364 2.032.348.745a.53.53 0 01-.242.685.44.44 0 01-.229.061.52.52 0 01-.465-.302l-.002-.005-.345-.74L6.22 20.471zm21.062.393h-.012l-14.394 6.7h21.186v-3.937a2.27 2.27 0 01-1.934-2.249 2.27 2.27 0 011.934-2.25v-3.935h-2.602l1.289 2.763a.37.37 0 01.011.252c-.023.083-.095.143-.167.18l-5.299 2.464zm.129.154c-.022.01-.229.122-.229.122l-13.4 6.223h20.08v-3.568a2.47 2.47 0 01-1.934-2.417c0-1.188.834-2.177 1.934-2.417v-3.568h-2.088l1.159 2.484m.02.386a.5.5 0 01-.27.303l-.005.003-5.267 2.45m-4.795-9.475a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.431.24.24 0 01-.13.036.32.32 0 01-.287-.191zm1.075 1.552a.44.44 0 01-.228.06.52.52 0 01-.465-.302l-.003-.005-.563-1.226a.53.53 0 01.252-.69.51.51 0 01.7.255l.55 1.223a.53.53 0 01-.243.685m.716 2.324-.561-1.22a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.43.24.24 0 01-.13.037.32.32 0 01-.287-.192m.514.331a.53.53 0 00.242-.685l-.55-1.222a.51.51 0 00-.699-.256.53.53 0 00-.252.69l.563 1.226.003.006c.088.177.26.302.465.302a.44.44 0 00.228-.06m.907.733.001.001.55 1.224a.53.53 0 01-.242.685.44.44 0 01-.228.06.52.52 0 01-.465-.301l-.003-.006-.563-1.225a.53.53 0 01.252-.69.52.52 0 01.698.252m-.611-.072a.32.32 0 01.43.155l.549 1.22a.33.33 0 01-.155.431.24.24 0 01-.132.036.32.32 0 01-.286-.191l-.561-1.22a.33.33 0 01.155-.431m-5.729-.848a.31.31 0 01.37.071c.096.096.12.252.048.371l-1.456 2.62 2.065 2.202a.306.306 0 01.047.37.33.33 0 01-.346.156l-2.936-.574-1.456 2.62a.32.32 0 01-.286.168h-.06a.305.305 0 01-.263-.276l-.358-2.979-2.936-.574a.305.305 0 01-.262-.275.306.306 0 01.179-.335l2.709-1.268-.358-2.98a.306.306 0 01.179-.334.31.31 0 01.37.072l2.04 2.2zm-2.661 1.013-1.941-2.093a.51.51 0 00-.6-.12m2.54 2.213 2.58-1.196a.51.51 0 01.598.117.51.51 0 01.075.608l-1.383 2.49 1.962 2.092a.51.51 0 01.076.614.53.53 0 01-.55.25l-.006-.001-2.794-.547-1.385 2.493a.52.52 0 01-.461.27h-.077l-.016-.002a.505.505 0 01-.429-.452l-.34-2.83-2.79-.547a.505.505 0 01-.426-.447.506.506 0 01.294-.542l2.577-1.206-.34-2.831a.506.506 0 01.294-.546m2.89 5.537 1.598.305-1.1-1.19a.51.51 0 01-.077-.61l.787-1.42-1.47.685a.51.51 0 01-.604-.118l-1.11-1.19.19 1.614a.506.506 0 01-.293.544l-1.47.685 1.59.312a.505.505 0 01.425.452l.19 1.605.788-1.425a.53.53 0 01.55-.25zm-1.47 2.314-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64-2.196-.419a.33.33 0 00-.346.155z" clip-rule="evenodd"/><path fill="currentColor" d="M34.204 21.818c.352-.198.293-.558.22-.714l-2.388.714-3.486 2.607c1.738-.786 5.303-2.41 5.654-2.607"/></g>'
  },
  "opportunity-management-deal": {
    body: '<g fill="currentColor"><path d="M14.14 35.264h-3.533a1.735 1.735 0 01-1.767-1.766V8.767C8.84 7.765 9.606 7 10.607 7h14.132c1 0 1.766.765 1.766 1.767V12.3c0 .353-.235.588-.589.588-.353 0-.588-.235-.588-.588V8.767c0-.354-.236-.59-.59-.59h-14.13c-.354 0-.59.236-.59.59v24.73c0 .354.236.59.59.59h3.533c.353 0 .588.235.588.588 0 .354-.235.59-.588.59"/><path d="M22.972 36.442a11.183 11.183 0 01-11.188-11.188 11.183 11.183 0 0111.188-11.188A11.183 11.183 0 0134.16 25.254a11.183 11.183 0 01-11.188 11.188m0-21.198a10 10 0 00-10.01 10.01c0 5.535 4.475 10.01 10.01 10.01s10.01-4.475 10.01-10.01-4.475-10.01-10.01-10.01m-2.709-4.711h-5.24c-.825 0-1.531-.53-1.708-1.354L12.785 7h9.775l-.53 2.179c-.236.824-.942 1.354-1.767 1.354m-5.947-2.355.177.706c.059.236.294.471.589.471h5.24c.295 0 .53-.176.59-.47l.117-.707z"/><path d="M19.145 33.203a2.916 2.916 0 01-2.945-2.944 2.916 2.916 0 012.945-2.945 2.916 2.916 0 012.944 2.945 2.916 2.916 0 01-2.944 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .766 1.766 1.767 1.766a1.735 1.735 0 001.766-1.766 1.735 1.735 0 00-1.766-1.767m7.655 1.767a2.916 2.916 0 01-2.945-2.944A2.916 2.916 0 0126.8 24.37a2.916 2.916 0 012.945 2.944 2.916 2.916 0 01-2.945 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .765 1.766 1.766 1.766a1.735 1.735 0 001.767-1.766 1.735 1.735 0 00-1.767-1.767"/><path d="M22.089 30.259H20.91v-9.245l8.833-2.767v9.068h-1.178v-7.42l-6.477 1.944z"/></g>'
  },
  "opportunity-permanent-social-media-share": {
    body: '<g fill="currentColor"><path d="M13.089 14.625a.62.62 0 00.62-.621v-1.76c0-.932.76-1.69 1.69-1.69h4.935a.62.62 0 00.622-.622.62.62 0 00-.622-.621h-4.968a2.915 2.915 0 00-2.897 2.897v1.76c.033.38.274.657.62.657m15.045 6.52a.62.62 0 00-.621.621v9.524H13.71v-2.38a.62.62 0 00-.62-.622.62.62 0 00-.622.621v5.14a2.915 2.915 0 002.897 2.898H25.82a2.915 2.915 0 002.898-2.897l.001-12.284c0-.345-.241-.621-.586-.621M25.856 35.74H15.368c-.931 0-1.69-.76-1.69-1.69v-1.553h13.835v1.553c0 .93-.76 1.69-1.657 1.69"/><path d="M21.924 33.496H19.3a.62.62 0 00-.621.621c0 .346.276.622.621.622h2.623a.62.62 0 00.621-.622.62.62 0 00-.621-.62M34.377 5.895h-9.522a2.62 2.62 0 00-2.623 2.623v7.314a2.63 2.63 0 002.553 2.623v2.38c0 .241.138.448.38.552a.6.6 0 00.241.035c.138 0 .31-.068.414-.172l3.037-2.83h5.52A2.62 2.62 0 0037 15.799v-7.28a2.62 2.62 0 00-2.623-2.623m1.415 9.937a1.4 1.4 0 01-1.415 1.415l-5.761-.001a.64.64 0 00-.414.172l-2.208 2.035v-1.587a.62.62 0 00-.621-.622h-.553a1.4 1.4 0 01-1.415-1.415l.002-7.311a1.4 1.4 0 011.415-1.415h9.523a1.4 1.4 0 011.415 1.415l-.002 7.314zM15.816 28.527a.7.7 0 00.241-.07.61.61 0 00.346-.552v-2.139a2.63 2.63 0 002.552-2.622v-4.59a2.62 2.62 0 00-2.623-2.622l-9.487.001a2.62 2.62 0 00-2.622 2.623v4.588a2.62 2.62 0 002.622 2.622h5.556l3.037 2.623c.102.103.24.138.378.138m-.587-3.348v1.449L13.02 24.73a.52.52 0 00-.38-.137l-5.796-.002c-.793-.033-1.415-.654-1.415-1.448v-4.59a1.4 1.4 0 011.415-1.415h9.524a1.4 1.4 0 011.415 1.415l-.001 4.59a1.4 1.4 0 01-1.416 1.415h-.552c-.31 0-.586.275-.586.62"/><path d="M32.825 8.862c-.931-.655-2.347-.553-3.243.276a2.47 2.47 0 00-1.966-.725c-.725.068-1.415.449-1.83 1.035-.654.931-.517 2.45.346 3.313l3.037 3.036a.64.64 0 00.413.173.64.64 0 00.414-.173l3.14-3.14a2.47 2.47 0 00.725-1.966c-.035-.726-.415-1.382-1.036-1.83m-.518 2.966-2.725 2.692-2.623-2.623c-.448-.45-.552-1.277-.207-1.725a1.4 1.4 0 01.966-.553h.104c.345 0 .655.137.931.38l.45.449a.64.64 0 00.413.172.57.57 0 00.414-.172l.38-.38c.449-.449 1.276-.553 1.725-.208.31.242.517.553.553.967 0 .346-.138.725-.38 1.001m-24.703 8.25h8.004a.62.62 0 00.621-.622.62.62 0 00-.621-.621H7.605a.62.62 0 00-.622.621c.035.345.277.622.622.622m8.591 2.173a.62.62 0 00-.622-.621l-7.97.001a.62.62 0 00-.62.622c0 .345.276.62.62.62h8.005c.31-.034.586-.31.586-.622"/></g>'
  },
  "opportunity-publishing-deal": {
    body: '<g fill="currentColor"><path d="M21.22 33.364a6.203 6.203 0 006.199-6.199 6.203 6.203 0 00-6.199-6.199 6.203 6.203 0 00-6.199 6.2 6.2 6.2 0 006.199 6.198m0-11.27a5.08 5.08 0 015.072 5.071 5.08 5.08 0 01-5.072 5.072 5.08 5.08 0 01-5.072-5.072 5.08 5.08 0 015.072-5.071"/><path d="M9.386 19.84v15.604L8 37.163c-.276.338-.327.8-.14 1.195.185.394.58.642 1.013.642H33.58a1.12 1.12 0 001.014-.637c.192-.394.14-.85-.13-1.189l-1.408-1.78V19.84c0-.93-.761-1.69-1.691-1.69H11.077c-.93 0-1.69.76-1.69 1.69m24.198 18.033H8.874l1.363-1.69h22l1.342 1.69zM31.928 19.84v15.215H10.513V19.84c0-.31.254-.564.564-.564h20.287c.31 0 .564.254.564.564"/><path d="M19.23 29.9a.56.56 0 00.553.022l4.508-2.254a.563.563 0 000-1.003l-4.508-2.255a.57.57 0 00-.547.023.56.56 0 00-.265.479v4.508c0 .197.102.378.265.48zm.863-4.075 2.682 1.341-2.682 1.341zm1.69-11.057V6.315l.677.901.901-.676-1.69-2.254c-.215-.282-.688-.282-.902 0l-1.69 2.254.901.676.676-.901v8.453zm4.582.327 3.601-7.016.192 1.11 1.11-.191-.474-2.779a.56.56 0 00-.298-.405.54.54 0 00-.502 0l-2.536 1.234.496 1.014 1.015-.496-3.601 7.016 1.003.513zm9.991-4.255-2.79.39.159 1.115 1.115-.158-3.595 3.579.795.8 3.595-3.579-.163 1.116 1.115.164.406-2.79a.56.56 0 00-.158-.479.58.58 0 00-.479-.163zM14.982 7.042l-2.536-1.234a.555.555 0 00-.8.406l-.474 2.778 1.11.191.192-1.11 3.6 7.016 1.004-.513-3.601-7.016 1.014.496.496-1.014zm-9.378 3.956a.56.56 0 00-.157.479l.405 2.79 1.116-.164-.163-1.116 3.595 3.579.795-.8-3.596-3.579 1.116.158.158-1.116-2.79-.389a.55.55 0 00-.479.164zm24.069 21.803H30.8v1.127h-1.127zm-2.254 0h1.127v1.127h-1.127zm-15.779 0h3.381v1.127H11.64z"/></g>'
  },
  "opportunity-radio-broadcast": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="M8.518 31.872A1.73 1.73 0 017 30.152V19.089a14.43 14.43 0 014.237-10.214 14.48 14.48 0 0110.23-4.231h.066c3.837 0 7.517 1.521 10.23 4.231A14.43 14.43 0 0136 19.09v11.065c0 .882-.66 1.611-1.518 1.72v2.03a.58.58 0 01-.578.576h-2.033v2.03c0 .318-.26.577-.578.577h-4.066a1.734 1.734 0 01-1.735-1.734v-8.117c0-.958.776-1.734 1.735-1.734h4.066c.319 0 .578.259.578.577v2.03h2.033c.32 0 .578.258.578.58v2a.58.58 0 00.362-.535V19.089c0-3.524-1.403-6.904-3.9-9.398a13.33 13.33 0 00-9.411-3.893h-.066c-3.53 0-6.914 1.402-9.411 3.893a13.28 13.28 0 00-3.9 9.398v11.063c0 .243.15.45.362.537v-2c0-.322.259-.58.578-.58h2.033v-2.03c0-.318.26-.577.578-.577h4.066c.959 0 1.735.776 1.735 1.734v8.117c0 .958-.776 1.734-1.735 1.734h-4.066a.58.58 0 01-.578-.577v-2.03H9.096a.58.58 0 01-.578-.577zm23.353 1.452h1.454v-4.059H31.87zm-1.158 2.609v-9.274h-3.486c-.32 0-.58.258-.58.577v8.117c0 .321.26.58.58.58zM11.13 29.265H9.675v4.059h1.454zm1.158 4.638v2.03h3.486a.58.58 0 00.58-.58v-8.117a.58.58 0 00-.58-.577h-3.486zm8.635-11.7a5.784 5.784 0 01-5.209-5.75.578.578 0 011.158 0 4.63 4.63 0 004.629 4.624 4.63 4.63 0 004.63-4.623.578.578 0 011.157 0 5.784 5.784 0 01-5.209 5.75v1.377a7.3 7.3 0 012.412.604.577.577 0 11-.465 1.059c-1.584-.692-3.273-.699-5.07.009a.579.579 0 01-.425-1.077 8.7 8.7 0 012.392-.584zm4.527-10.646v4.899a3.944 3.944 0 01-3.948 3.942H21.5a3.944 3.944 0 01-3.948-3.942v-4.899a3.944 3.944 0 013.948-3.94h.002a3.944 3.944 0 013.948 3.94m-1.158 0a2.787 2.787 0 00-2.79-2.786H21.5a2.787 2.787 0 00-2.79 2.786v4.899a2.787 2.787 0 002.79 2.786h.002a2.787 2.787 0 002.79-2.786zm-3.949 5.169a.578.578 0 110-1.156h2.327a.578.578 0 110 1.156zm.02-2.753a.579.579 0 010-1.156h2.328a.578.578 0 010 1.156zm-.02-2.754a.578.578 0 110-1.154h2.327c.32 0 .58.258.58.577s-.26.577-.58.577z" clip-rule="evenodd"/>'
  },
  "opportunity-record-deal": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="m15.09 23.218 9.334-2.075v6.583a3.501 3.501 0 00-5.833 2.608c0 1.931 1.567 3.5 3.5 3.5 1.931 0 3.5-1.569 3.5-3.5v-14a.584.584 0 00-.71-.57l-10.5 2.333a.584.584 0 00-.457.57v10.225A3.501 3.501 0 008.09 31.5a3.5 3.5 0 007 0zM13.924 31.5a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m10.5-1.167a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m0-10.384V17.06l-9.334 2.075v2.888zm.583-11.782a7.59 7.59 0 017.583 7.583.584.584 0 001.167 0c0-4.829-3.921-8.75-8.75-8.75a.584.584 0 000 1.167m0 2.916a4.67 4.67 0 014.667 4.667.583.583 0 001.166 0 5.835 5.835 0 00-5.833-5.833.584.584 0 000 1.166m0 2.917c.966 0 1.75.784 1.75 1.75a.583.583 0 001.167 0 2.92 2.92 0 00-2.917-2.917.584.584 0 000 1.167" clip-rule="evenodd"/>'
  },
  "opportunity-share-to-my-team": {
    body: '<path fill="currentColor" d="M35.218 21.003c-.642 0-1.263.227-1.76.64a2.85 2.85 0 00-.968 1.626h-4.743c.28-.993.31-2.042.089-3.05a6.2 6.2 0 00-1.354-2.723l3.369-5.388a4.1 4.1 0 003.06.175 4.2 4.2 0 002.353-2 4.32 4.32 0 00.377-3.097 4.25 4.25 0 00-1.803-2.523 4.1 4.1 0 00-3.01-.59 4.17 4.17 0 00-2.595 1.663 4.306 4.306 0 00.677 5.764l-3.247 5.197a6.02 6.02 0 00-4.071-1.352 6.04 6.04 0 00-3.94 1.71l-3.34-3.4a3.4 3.4 0 00.844-2.286 3.4 3.4 0 00-.899-2.265 3.266 3.266 0 00-4.46-.331 3.38 3.38 0 00-1.211 2.107c-.13.833.05 1.685.508 2.387a3.3 3.3 0 001.96 1.409 3.26 3.26 0 002.38-.313l3.484 3.547a6.3 6.3 0 00-1.18 3.636 6.3 6.3 0 001.136 3.65l-6.012 3.569a4.15 4.15 0 00-2.935-.958 4.17 4.17 0 00-2.788 1.34A4.32 4.32 0 004 32.063a4.32 4.32 0 001.124 2.922 4.17 4.17 0 002.78 1.355 4.15 4.15 0 002.941-.943 4.3 4.3 0 001.517-2.732 4.34 4.34 0 00-.724-3.05l5.978-3.55a6.1 6.1 0 002.016 1.309v4.964a1.7 1.7 0 00-1.123.049c-.36.142-.661.403-.86.74a1.79 1.79 0 00.258 2.15l1.725 1.816v.34c0 .15.059.295.163.401a.55.55 0 00.394.166h8.906c.147 0 .289-.06.393-.166a.57.57 0 00.163-.4v-9.632c0-.328-.093-.65-.269-.924a1.7 1.7 0 00-.72-.627 1.64 1.64 0 00-1.794.285 1.65 1.65 0 00-.838-.408 6.2 6.2 0 001.279-1.726h5.181a2.85 2.85 0 00.72 1.396c.364.387.83.66 1.34.788a2.74 2.74 0 001.548-.063c.5-.17.941-.48 1.275-.895a2.88 2.88 0 00.359-3.006 2.8 2.8 0 00-1.027-1.18 2.75 2.75 0 00-1.487-.439m-6.68-12.748c0-.616.18-1.219.516-1.731a3.07 3.07 0 011.374-1.148 3 3 0 011.769-.177c.594.12 1.14.417 1.567.853s.72.99.838 1.595a3.17 3.17 0 01-.174 1.8 3.1 3.1 0 01-1.128 1.4 3 3 0 01-1.7.524c-.812 0-1.59-.33-2.164-.913a3.15 3.15 0 01-.898-2.203M11.84 13.638a2.2 2.2 0 01-1.237-.382 2.26 2.26 0 01-.82-1.017 2.3 2.3 0 01-.127-1.31 2.3 2.3 0 01.61-1.16 2.2 2.2 0 011.14-.62 2.2 2.2 0 011.286.129c.407.171.754.462 1 .834a2.296 2.296 0 01-.278 2.862 2.2 2.2 0 01-1.574.664m-3.618 21.53a3 3 0 01-1.7-.526 3.1 3.1 0 01-1.128-1.399 3.17 3.17 0 01-.175-1.8c.118-.604.41-1.16.838-1.595a3.05 3.05 0 011.568-.853 3 3 0 011.768.177c.56.236 1.038.635 1.374 1.148a3.156 3.156 0 01-.381 3.934 3.04 3.04 0 01-2.164.913m18.09-7.366v1.7c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v9.065h-7.792a.57.57 0 00-.157-.393l-1.887-1.99a.64.64 0 01-.006-.882.62.62 0 01.865-.04l.184.248a.56.56 0 00.621.194.56.56 0 00.275-.206.57.57 0 00.105-.33v-9.066a.56.56 0 01.062-.248l.588-.299c.128.02.245.087.33.188.084.1.132.227.133.36v5.099c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v1.7c0 .15.059.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7c0-.15.06-.295.163-.4a.55.55 0 01.788 0 .57.57 0 01.163.4m-5.566-4.995V20.22l2.651 1.35-2.262 1.15a1.6 1.6 0 00-.39.087m3.228 3.379a1.66 1.66 0 00-1.002.013v-1.797a1.7 1.7 0 00-.431-1.13l2.35-1.192a.56.56 0 00.308-.508.57.57 0 00-.308-.507L20.438 18.8a.55.55 0 00-.734.23.6.6 0 00-.072.274v4.533q.002.105.042.2-.04.18-.042.366v1.737a5.07 5.07 0 01-2.322-2.41 5.2 5.2 0 01-.34-3.357 5.12 5.12 0 011.793-2.84 4.96 4.96 0 013.142-1.081 4.96 4.96 0 013.118 1.149 5.12 5.12 0 011.733 2.878 5.2 5.2 0 01-.41 3.35 5.06 5.06 0 01-2.372 2.358m11.244-.65c-.33 0-.654-.1-.928-.287a1.7 1.7 0 01-.615-.763 1.73 1.73 0 01.362-1.852 1.64 1.64 0 011.82-.368c.305.128.565.346.749.625a1.72 1.72 0 01-.208 2.147 1.66 1.66 0 01-1.18.497"/>'
  },
  "opportunity-spotify-playlist": {
    body: '<g fill="currentColor"><path d="M7.236 22.068a.6.6 0 01-.596-.545 5 5 0 01-.016-.42c0-6.516 5.3-11.816 11.816-11.816a.6.6 0 110 1.2c-5.852 0-10.616 4.76-10.616 10.617q-.002.154.008.308a.6.6 0 01-.54.652h-.056zM18.44 23.79a2.683 2.683 0 01-2.68-2.68 2.685 2.685 0 012.68-2.68 2.685 2.685 0 012.68 2.68 2.685 2.685 0 01-2.68 2.68m0-4.16c-.816 0-1.48.664-1.48 1.48s.664 1.48 1.48 1.48 1.48-.664 1.48-1.48-.664-1.48-1.48-1.48"/><path d="M18.446 27.374a6.276 6.276 0 01-6.268-6.268 6.276 6.276 0 016.268-6.268 6.276 6.276 0 016.268 6.268 6.276 6.276 0 01-6.268 6.268m0-11.332a5.075 5.075 0 00-5.068 5.068 5.07 5.07 0 005.068 5.068 5.07 5.07 0 005.068-5.068 5.07 5.07 0 00-5.068-5.068m7.31 18.12a.6.6 0 01-.268-1.136 13.85 13.85 0 006.604-9.588.6.6 0 01.692-.493.6.6 0 01.492.692 15.05 15.05 0 01-6.928 10.273c-.088.06-.204.132-.316.188a.6.6 0 01-.268.064z"/><path d="M18.447 36.157c-8.296 0-15.049-6.748-15.049-15.048S10.151 6.061 18.447 6.061c7.388 0 13.78 5.504 14.872 12.8a.603.603 0 01-.504.684.603.603 0 01-.684-.504c-1.004-6.716-6.888-11.78-13.684-11.78-7.636 0-13.849 6.212-13.849 13.848s6.213 13.848 13.849 13.848c1.008 0 1.992-.104 2.928-.312a.6.6 0 11.26 1.172c-1.02.228-2.096.34-3.188.34"/><path d="M26.03 34.43a.6.6 0 01-.6-.6V20.434c0-.28.196-.524.472-.584l11.976-2.64c.18-.04.364.004.504.12s.224.284.224.468v12.924a.6.6 0 11-1.2 0V18.546L26.63 20.922v12.912a.6.6 0 01-.6.6z"/><path d="M23.73 37.54c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.6c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m11.979 1.49c-1.6 0-2.9-1.301-2.9-2.901s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.601c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m-9.679-4.331a.6.6 0 01-.12-1.188l11.977-2.436a.6.6 0 01.24 1.176L26.15 25.485a.6.6 0 01-.12.012"/></g>'
  },
  "opportunity-springboard-selection": {
    body: '<g fill="currentColor"><path d="M16.468 32.811a2.461 2.461 0 01-1.74-4.197 2.459 2.459 0 111.74 4.197m0-3.851a1.39 1.39 0 00-.985 2.376 1.39 1.39 0 002.377-.985 1.394 1.394 0 00-1.392-1.391"/><path d="M18.393 30.885a.533.533 0 01-.533-.533v-8.298a.533.533 0 111.066 0v8.298a.533.533 0 01-.533.533m5.717-.45a2.458 2.458 0 110-4.916 2.458 2.458 0 010 4.916m0-3.85a1.392 1.392 0 100 2.783 1.392 1.392 0 000-2.783"/><path d="M26.035 28.51a.534.534 0 01-.534-.534v-8.298a.534.534 0 011.067 0v8.299a.533.533 0 01-.533.533"/><path d="M18.393 22.588a.534.534 0 01-.158-1.043l7.642-2.375a.534.534 0 11.316 1.018l-7.642 2.376a.5.5 0 01-.158.024m0 2.994a.532.532 0 01-.158-1.043l7.642-2.375a.533.533 0 11.316 1.018l-7.642 2.377a.6.6 0 01-.158.023m-6.104-12.049h-1.067a1.96 1.96 0 01-1.955-1.955V6.956A1.96 1.96 0 0111.222 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955m-1.067-7.466a.89.89 0 00-.889.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466h-1.067a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0120.467 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.956 1.955m-1.067-7.466a.89.89 0 00-.89.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.89-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466H29.71a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0129.711 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955M29.71 6.067a.89.89 0 00-.889.889v4.622a.89.89 0 00.889.889h1.067a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89z"/><path d="M19.044 10.334h-5.333a.534.534 0 010-1.067h5.333a.533.533 0 010 1.067"/><path d="M35.044 37H6.956A1.96 1.96 0 015 35.045V11.223a1.96 1.96 0 011.956-1.956H9.8a.533.533 0 010 1.067H6.956a.89.89 0 00-.89.889v23.822a.89.89 0 00.89.889h28.088a.89.89 0 00.89-.89v-23.82a.89.89 0 00-.89-.89H32.2a.534.534 0 010-1.066h2.844A1.96 1.96 0 0137 11.223v23.822A1.96 1.96 0 0135.044 37"/><path d="M28.289 10.334h-5.334a.534.534 0 010-1.067h5.334a.533.533 0 010 1.067m8.178 6.222H5.533a.533.533 0 010-1.067h30.934a.533.533 0 010 1.067"/></g>'
  },
  "opportunity-sync-deal": {
    body: '<g fill="currentColor"><path d="M32.49 10.656H22.138l3.642-3.641a.594.594 0 10-.84-.84l-4.09 4.085-4.087-4.087a.594.594 0 10-.84.84l3.641 3.642H9.51c-2.95 0-5.349 2.4-5.349 5.349V32.15c0 2.95 2.4 5.35 5.35 5.35h22.98c2.95 0 5.35-2.4 5.35-5.35V16.005c0-2.95-2.4-5.35-5.35-5.35m4.161 21.495a4.165 4.165 0 01-4.16 4.16H9.509a4.165 4.165 0 01-4.16-4.16V16.005a4.165 4.165 0 014.16-4.16h22.982a4.165 4.165 0 014.16 4.16z"/><path d="M28.231 14.222H9.212c-.983 0-1.783.813-1.783 1.813v15.987c0 1 .8 1.813 1.783 1.813h19.019c.983 0 1.783-.813 1.783-1.813V16.035c0-1-.8-1.813-1.783-1.813m.594 17.8c0 .344-.266.624-.594.624H9.212c-.328 0-.594-.28-.594-.624V16.035c0-.344.266-.624.594-.624h19.019c.328 0 .594.28.594.624zm4.427-4.823c-1.148 0-2.08.933-2.08 2.08s.933 2.08 2.08 2.08 2.08-.933 2.08-2.08-.933-2.08-2.08-2.08m0 2.971a.892.892 0 11.001-1.784.892.892 0 01-.001 1.785m1.486-7.034h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.774h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.773h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.19"/><path d="M17.788 26.982a.604.604 0 01-.602-.602v-4.32a.601.601 0 01.952-.49l3.026 2.16a.603.603 0 010 .978l-3.026 2.162a.6.6 0 01-.35.113m.602-3.755v1.983l1.389-.99z"/></g>'
  },
  "opportunity-temporary-social-media-share": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="m24.369 20.283-4.474-3.217a.37.37 0 00-.378-.03.36.36 0 00-.2.319v6.433a.357.357 0 00.364.358q.116 0 .214-.069l4.474-3.216a.356.356 0 000-.578m-4.325 2.801V18.06l3.495 2.513z"/><path fill="currentColor" d="M27.853 7.19H14.147c-1.077 0-1.954.864-1.954 1.925v24.77c0 1.061.877 1.925 1.954 1.925h13.706c1.077 0 1.954-.864 1.954-1.925V9.115c0-1.061-.877-1.925-1.954-1.925m-14.934 4.324h16.162v17.914H12.919zm1.228-3.608h13.706a1.22 1.22 0 011.228 1.21v1.682H12.919V9.115c0-.667.551-1.21 1.228-1.21m13.706 27.188H14.147a1.22 1.22 0 01-1.228-1.21v-3.74h16.162v3.74a1.22 1.22 0 01-1.228 1.21"/><path fill="currentColor" d="M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m0-19.209c-3.397 0-6.16 2.723-6.16 6.07s2.763 6.07 6.16 6.07 6.162-2.723 6.162-6.07-2.764-6.07-6.162-6.07m0 11.425c-2.997 0-5.435-2.402-5.435-5.355 0-2.952 2.438-5.354 5.435-5.354s5.436 2.402 5.436 5.354S23.997 25.95 21 25.95"/><path fill="currentColor" fill-rule="evenodd" d="M19.517 17.036a.37.37 0 01.378.03l4.474 3.217a.356.356 0 010 .578l-4.474 3.216a.37.37 0 01-.378.03.36.36 0 01-.2-.319v-6.433a.36.36 0 01.2-.32m-.088 7.24a.55.55 0 01-.304-.488v-6.433c0-.206.117-.395.304-.489a.56.56 0 01.58.046l4.473 3.217m-4.473 4.102 4.473-3.217Zm-.58.046a.56.56 0 00.58-.046m.035-1.147 3.495-2.512-3.495-2.513zm.193-.374 2.974-2.138-2.974-2.139zM14.147 7h13.706C29.037 7 30 7.949 30 9.115v24.77C30 35.05 29.037 36 27.853 36H14.147C12.963 36 12 35.051 12 33.885V9.115C12 7.95 12.963 7 14.147 7m14.74 4.704H13.113v17.534h15.776zm-1.034-3.608H14.147c-.57 0-1.035.457-1.035 1.02v1.492h15.776V9.115a1.03 1.03 0 00-1.035-1.02M14.147 34.904h13.706c.57 0 1.035-.457 1.035-1.02v-3.55H13.112v3.55c0 .563.465 1.02 1.035 1.02m4.857-2.217c0-1.077.897-1.95 1.996-1.95 1.1 0 1.996.873 1.996 1.95 0 1.078-.897 1.951-1.996 1.951s-1.996-.873-1.996-1.95m1.112 0c0 .47.394.856.884.856s.884-.387.884-.856-.394-.855-.884-.855-.884.386-.884.855m-5.47-12.093c0-3.452 2.85-6.26 6.354-6.26s6.355 2.808 6.355 6.26-2.85 6.26-6.355 6.26c-3.504 0-6.354-2.808-6.354-6.26m1.112 0c0 2.848 2.352 5.165 5.242 5.165s5.243-2.317 5.243-5.165S23.89 15.43 21 15.43s-5.242 2.317-5.242 5.164M14.147 7.19h13.706c1.077 0 1.954.864 1.954 1.925v24.77c0 1.061-.877 1.925-1.954 1.925H14.147c-1.077 0-1.954-.864-1.954-1.925V9.115c0-1.061.877-1.925 1.954-1.925m-1.228 4.324v17.914h16.162V11.514zm14.934-3.608H14.147a1.22 1.22 0 00-1.228 1.21v1.682h16.162V9.115a1.22 1.22 0 00-1.228-1.21M14.147 35.094h13.706a1.22 1.22 0 001.228-1.21v-3.74H12.919v3.74c0 .668.551 1.21 1.228 1.21M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m-6.16-13.139c0-3.347 2.763-6.07 6.16-6.07s6.162 2.723 6.162 6.07-2.764 6.07-6.162 6.07c-3.397 0-6.16-2.723-6.16-6.07m.725 0c0 2.953 2.438 5.355 5.435 5.355s5.436-2.402 5.436-5.355c0-2.952-2.439-5.354-5.436-5.354s-5.435 2.402-5.435 5.354" clip-rule="evenodd"/><path fill="currentColor" d="M24.709 20.772c.18-.412-.299-.706-.478-.824-.18-.118-4.603 4.004-4.603 4.004l-.21.324.569-.03c1.415-1.03 4.423-2.973 4.722-3.474"/></g>'
  },
  "smile-meter-0": {
    body: '<path fill="currentColor" d="M12.813 15.89c-.391.352-.977.352-1.329-.038A1.97 1.97 0 0010 15.187c-.742 0-1.25.352-1.523.665-.352.39-.938.39-1.329.039-.39-.352-.39-.938-.039-1.328A3.94 3.94 0 0110 13.313c1.328 0 2.305.664 2.852 1.25.351.39.351.976-.04 1.328M5.625 9.876c0-.312.117-.625.352-.86l-1.211-.39c-.313-.117-.47-.469-.391-.82a.654.654 0 01.82-.39l3.75 1.25c.313.116.47.468.39.82-.116.312-.468.468-.82.39l-.39-.156v.156c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25V9.72l-.43.156c-.351.078-.703-.078-.82-.39-.078-.352.078-.704.39-.82l3.75-1.25a.654.654 0 01.82.39c.08.351-.077.703-.39.82l-1.21.39c.234.196.39.547.39.86M0 10.5C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10m10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-1": {
    body: '<path fill="currentColor" d="M5.586 16.086c-.469-.156-.742-.703-.547-1.211C5.703 13 7.734 11.75 10 11.75c2.227 0 4.258 1.25 4.922 3.125.195.508-.078 1.055-.547 1.21-.508.196-1.055-.077-1.21-.546-.352-1.016-1.563-1.914-3.165-1.914-1.64 0-2.852.898-3.203 1.914-.156.469-.703.742-1.211.547m2.539-7.461c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-2": {
    body: '<path fill="currentColor" d="M5.625 8.625c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m-1.562 4.688a.95.95 0 01.937.937c0 .547-.43.938-.937.938H7.187c-.546 0-.937-.391-.937-.938 0-.508.39-.937.938-.937zM20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10m-10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-3": {
    body: '<path fill="currentColor" d="M10 14.25c1.445 0 2.46-.664 3.047-1.29a.933.933 0 011.328-.077c.39.351.39.937.04 1.328A5.93 5.93 0 0110 16.125c-2.11 0-3.594-.977-4.453-1.914-.352-.39-.352-.977.039-1.328a.933.933 0 011.328.078C7.5 13.586 8.516 14.25 10 14.25M8.125 8.625c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-4": {
    body: '<path fill="currentColor" d="M13.633 12.57c.742-.195 1.406.47.976 1.094-.937 1.484-2.656 2.461-4.648 2.461-1.953 0-3.672-.977-4.648-2.46-.391-.626.273-1.29 1.015-1.095 1.133.274 2.344.39 3.633.39 1.328 0 2.539-.116 3.672-.39M8.477 9.445s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.625-1.875.39-.508.937-.937 1.562-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118m6.25 0s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.624-1.875.391-.508.938-.937 1.563-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  }
}, ji = 42, Ui = 42, Wi = {
  prefix: Vi,
  lastModified: Hi,
  icons: Bi,
  width: ji,
  height: Ui
};
/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.1.0
*/
const Eo = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), yt = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), rt = Object.freeze({
  ...Eo,
  ...yt
}), Xt = Object.freeze({
  ...rt,
  body: "",
  hidden: !1
}), _i = Object.freeze({
  width: null,
  height: null
}), Mo = Object.freeze({
  // Dimensions
  ..._i,
  // Transformations
  ...yt
});
function Ki(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (n === "") {
    const i = parseInt(e);
    return isNaN(i) ? 0 : o(i);
  } else if (n !== e) {
    let i = 0;
    switch (n) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let r = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(r) ? 0 : (r = r / i, r % 1 === 0 ? o(r) : 0);
    }
  }
  return t;
}
const qi = /[\s,]+/;
function Gi(e, t) {
  t.split(qi).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
const zo = {
  ...Mo,
  preserveAspectRatio: ""
};
function Pn(e) {
  const t = {
    ...zo
  }, n = (o, i) => e.getAttribute(o) || i;
  return t.width = n("width", null), t.height = n("height", null), t.rotate = Ki(n("rotate", "")), Gi(t, n("flip", "")), t.preserveAspectRatio = n("preserveAspectRatio", n("preserveaspectratio", "")), t;
}
function Qi(e, t) {
  for (const n in zo)
    if (e[n] !== t[n])
      return !0;
  return !1;
}
const Xe = /^[a-z0-9]+(-[a-z0-9]+)*$/, lt = (e, t, n, o = "") => {
  const i = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    o = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const s = i.pop(), l = i.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: i.length > 0 ? i[0] : o,
      prefix: l,
      name: s
    };
    return t && !bt(c) ? null : c;
  }
  const r = i[0], a = r.split("-");
  if (a.length > 1) {
    const s = {
      provider: o,
      prefix: a.shift(),
      name: a.join("-")
    };
    return t && !bt(s) ? null : s;
  }
  if (n && o === "") {
    const s = {
      provider: o,
      prefix: "",
      name: r
    };
    return t && !bt(s, n) ? null : s;
  }
  return null;
}, bt = (e, t) => e ? !!((e.provider === "" || e.provider.match(Xe)) && (t && e.prefix === "" || e.prefix.match(Xe)) && e.name.match(Xe)) : !1;
function Yi(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Vn(e, t) {
  const n = Yi(e, t);
  for (const o in Xt)
    o in yt ? o in e && !(o in n) && (n[o] = yt[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function Xi(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  function r(a) {
    if (n[a])
      return i[a] = [];
    if (!(a in i)) {
      i[a] = null;
      const s = o[a] && o[a].parent, l = s && r(s);
      l && (i[a] = [s].concat(l));
    }
    return i[a];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(r), i;
}
function Zi(e, t, n) {
  const o = e.icons, i = e.aliases || /* @__PURE__ */ Object.create(null);
  let r = {};
  function a(s) {
    r = Vn(
      o[s] || i[s],
      r
    );
  }
  return a(t), n.forEach(a), Vn(e, r);
}
function Fo(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((i) => {
    t(i, null), n.push(i);
  });
  const o = Xi(e);
  for (const i in o) {
    const r = o[i];
    r && (t(i, Zi(e, i, r)), n.push(i));
  }
  return n;
}
const Ji = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Eo
};
function Vt(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function No(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Vt(e, Ji))
    return null;
  const n = t.icons;
  for (const i in n) {
    const r = n[i];
    if (!i.match(Xe) || typeof r.body != "string" || !Vt(
      r,
      Xt
    ))
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const i in o) {
    const r = o[i], a = r.parent;
    if (!i.match(Xe) || typeof a != "string" || !n[a] && !o[a] || !Vt(
      r,
      Xt
    ))
      return null;
  }
  return t;
}
const xt = /* @__PURE__ */ Object.create(null);
function ea(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function be(e, t) {
  const n = xt[e] || (xt[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = ea(e, t));
}
function xn(e, t) {
  return No(t) ? Fo(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function ta(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
function na(e, t) {
  let n = [];
  return (typeof e == "string" ? [e] : Object.keys(xt)).forEach((i) => {
    (typeof i == "string" && typeof t == "string" ? [t] : Object.keys(xt[i] || {})).forEach((a) => {
      const s = be(i, a);
      n = n.concat(
        Object.keys(s.icons).map(
          (l) => (i !== "" ? "@" + i + ":" : "") + a + ":" + l
        )
      );
    });
  }), n;
}
let tt = !1;
function $o(e) {
  return typeof e == "boolean" && (tt = e), tt;
}
function nt(e) {
  const t = typeof e == "string" ? lt(e, !0, tt) : e;
  if (t) {
    const n = be(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function Oo(e, t) {
  const n = lt(e, !0, tt);
  if (!n)
    return !1;
  const o = be(n.provider, n.prefix);
  return ta(o, n.name, t);
}
function Hn(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), tt && !t && !e.prefix) {
    let i = !1;
    return No(e) && (e.prefix = "", Fo(e, (r, a) => {
      a && Oo(r, a) && (i = !0);
    })), i;
  }
  const n = e.prefix;
  if (!bt({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = be(t, n);
  return !!xn(o, e);
}
function Bn(e) {
  return !!nt(e);
}
function oa(e) {
  const t = nt(e);
  return t ? {
    ...rt,
    ...t
  } : null;
}
function ia(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((i, r) => i.provider !== r.provider ? i.provider.localeCompare(r.provider) : i.prefix !== r.prefix ? i.prefix.localeCompare(r.prefix) : i.name.localeCompare(r.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((i) => {
    if (o.name === i.name && o.prefix === i.prefix && o.provider === i.provider)
      return;
    o = i;
    const r = i.provider, a = i.prefix, s = i.name, l = n[r] || (n[r] = /* @__PURE__ */ Object.create(null)), c = l[a] || (l[a] = be(r, a));
    let u;
    s in c.icons ? u = t.loaded : a === "" || c.missing.has(s) ? u = t.missing : u = t.pending;
    const d = {
      provider: r,
      prefix: a,
      name: s
    };
    u.push(d);
  }), t;
}
function Lo(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((i) => i.id !== t));
  });
}
function aa(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, i = e.prefix;
    t.forEach((r) => {
      const a = r.icons, s = a.pending.length;
      a.pending = a.pending.filter((l) => {
        if (l.prefix !== i)
          return !0;
        const c = l.name;
        if (e.icons[c])
          a.loaded.push({
            provider: o,
            prefix: i,
            name: c
          });
        else if (e.missing.has(c))
          a.missing.push({
            provider: o,
            prefix: i,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), a.pending.length !== s && (n || Lo([e], r.id), r.callback(
        a.loaded.slice(0),
        a.missing.slice(0),
        a.pending.slice(0),
        r.abort
      ));
    });
  }));
}
let ra = 0;
function la(e, t, n) {
  const o = ra++, i = Lo.bind(null, n, o);
  if (!t.pending.length)
    return i;
  const r = {
    id: o,
    icons: t,
    callback: e,
    abort: i
  };
  return n.forEach((a) => {
    (a.loaderCallbacks || (a.loaderCallbacks = [])).push(r);
  }), i;
}
const Zt = /* @__PURE__ */ Object.create(null);
function jn(e, t) {
  Zt[e] = t;
}
function Jt(e) {
  return Zt[e] || Zt[""];
}
function sa(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((i) => {
    const r = typeof i == "string" ? lt(i, t, n) : i;
    r && o.push(r);
  }), o;
}
var ca = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function ua(e, t, n, o) {
  const i = e.resources.length, r = e.random ? Math.floor(Math.random() * i) : e.index;
  let a;
  if (e.random) {
    let E = e.resources.slice(0);
    for (a = []; E.length > 1; ) {
      const z = Math.floor(Math.random() * E.length);
      a.push(E[z]), E = E.slice(0, z).concat(E.slice(z + 1));
    }
    a = a.concat(E);
  } else
    a = e.resources.slice(r).concat(e.resources.slice(0, r));
  const s = Date.now();
  let l = "pending", c = 0, u, d = null, f = [], h = [];
  typeof o == "function" && h.push(o);
  function v() {
    d && (clearTimeout(d), d = null);
  }
  function y() {
    l === "pending" && (l = "aborted"), v(), f.forEach((E) => {
      E.status === "pending" && (E.status = "aborted");
    }), f = [];
  }
  function w(E, z) {
    z && (h = []), typeof E == "function" && h.push(E);
  }
  function m() {
    return {
      startTime: s,
      payload: t,
      status: l,
      queriesSent: c,
      queriesPending: f.length,
      subscribe: w,
      abort: y
    };
  }
  function x() {
    l = "failed", h.forEach((E) => {
      E(void 0, u);
    });
  }
  function C() {
    f.forEach((E) => {
      E.status === "pending" && (E.status = "aborted");
    }), f = [];
  }
  function T(E, z, j) {
    const X = z !== "success";
    switch (f = f.filter((W) => W !== E), l) {
      case "pending":
        break;
      case "failed":
        if (X || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (z === "abort") {
      u = j, x();
      return;
    }
    if (X) {
      u = j, f.length || (a.length ? L() : x());
      return;
    }
    if (v(), C(), !e.random) {
      const W = e.resources.indexOf(E.resource);
      W !== -1 && W !== e.index && (e.index = W);
    }
    l = "completed", h.forEach((W) => {
      W(j);
    });
  }
  function L() {
    if (l !== "pending")
      return;
    v();
    const E = a.shift();
    if (E === void 0) {
      if (f.length) {
        d = setTimeout(() => {
          v(), l === "pending" && (C(), x());
        }, e.timeout);
        return;
      }
      x();
      return;
    }
    const z = {
      status: "pending",
      resource: E,
      callback: (j, X) => {
        T(z, j, X);
      }
    };
    f.push(z), c++, d = setTimeout(L, e.rotate), n(E, t, z.callback);
  }
  return setTimeout(L), m;
}
function Do(e) {
  const t = {
    ...ca,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((s) => s().status === "pending");
  }
  function i(s, l, c) {
    const u = ua(
      t,
      s,
      l,
      (d, f) => {
        o(), c && c(d, f);
      }
    );
    return n.push(u), u;
  }
  function r(s) {
    return n.find((l) => s(l)) || null;
  }
  return {
    query: i,
    find: r,
    setIndex: (s) => {
      t.index = s;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function Cn(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Ft = /* @__PURE__ */ Object.create(null), qe = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], wt = [];
for (; qe.length > 0; )
  qe.length === 1 || Math.random() > 0.5 ? wt.push(qe.shift()) : wt.push(qe.pop());
Ft[""] = Cn({
  resources: ["https://api.iconify.design"].concat(wt)
});
function Un(e, t) {
  const n = Cn(t);
  return n === null ? !1 : (Ft[e] = n, !0);
}
function Nt(e) {
  return Ft[e];
}
function da() {
  return Object.keys(Ft);
}
function Wn() {
}
const Ht = /* @__PURE__ */ Object.create(null);
function fa(e) {
  if (!Ht[e]) {
    const t = Nt(e);
    if (!t)
      return;
    const n = Do(t), o = {
      config: t,
      redundancy: n
    };
    Ht[e] = o;
  }
  return Ht[e];
}
function Ro(e, t, n) {
  let o, i;
  if (typeof e == "string") {
    const r = Jt(e);
    if (!r)
      return n(void 0, 424), Wn;
    i = r.send;
    const a = fa(e);
    a && (o = a.redundancy);
  } else {
    const r = Cn(e);
    if (r) {
      o = Do(r);
      const a = e.resources ? e.resources[0] : "", s = Jt(a);
      s && (i = s.send);
    }
  }
  return !o || !i ? (n(void 0, 424), Wn) : o.query(t, i, n)().abort;
}
const _n = "iconify2", ot = "iconify", Po = ot + "-count", Kn = ot + "-version", Vo = 36e5, ha = 168, ma = 50;
function en(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function kn(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function qn(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function tn(e, t) {
  return kn(e, Po, t.toString());
}
function nn(e) {
  return parseInt(en(e, Po)) || 0;
}
const ke = {
  local: !0,
  session: !0
}, Ho = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let Tn = !1;
function pa(e) {
  Tn = e;
}
let ut = typeof window > "u" ? {} : window;
function Bo(e) {
  const t = e + "Storage";
  try {
    if (ut && ut[t] && typeof ut[t].length == "number")
      return ut[t];
  } catch {
  }
  ke[e] = !1;
}
function jo(e, t) {
  const n = Bo(e);
  if (!n)
    return;
  const o = en(n, Kn);
  if (o !== _n) {
    if (o) {
      const s = nn(n);
      for (let l = 0; l < s; l++)
        qn(n, ot + l.toString());
    }
    kn(n, Kn, _n), tn(n, 0);
    return;
  }
  const i = Math.floor(Date.now() / Vo) - ha, r = (s) => {
    const l = ot + s.toString(), c = en(n, l);
    if (typeof c == "string") {
      try {
        const u = JSON.parse(c);
        if (typeof u == "object" && typeof u.cached == "number" && u.cached > i && typeof u.provider == "string" && typeof u.data == "object" && typeof u.data.prefix == "string" && // Valid item: run callback
        t(u, s))
          return !0;
      } catch {
      }
      qn(n, l);
    }
  };
  let a = nn(n);
  for (let s = a - 1; s >= 0; s--)
    r(s) || (s === a - 1 ? (a--, tn(n, a)) : Ho[e].add(s));
}
function Uo() {
  if (!Tn) {
    pa(!0);
    for (const e in ke)
      jo(e, (t) => {
        const n = t.data, o = t.provider, i = n.prefix, r = be(
          o,
          i
        );
        if (!xn(r, n).length)
          return !1;
        const a = n.lastModified || -1;
        return r.lastModifiedCached = r.lastModifiedCached ? Math.min(r.lastModifiedCached, a) : a, !0;
      });
  }
}
function va(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const o in ke)
      jo(o, (i) => {
        const r = i.data;
        return i.provider !== e.provider || r.prefix !== e.prefix || r.lastModified === t;
      });
  return !0;
}
function ba(e, t) {
  Tn || Uo();
  function n(o) {
    let i;
    if (!ke[o] || !(i = Bo(o)))
      return;
    const r = Ho[o];
    let a;
    if (r.size)
      r.delete(a = Array.from(r).shift());
    else if (a = nn(i), a >= ma || !tn(i, a + 1))
      return;
    const s = {
      cached: Math.floor(Date.now() / Vo),
      provider: e.provider,
      data: t
    };
    return kn(
      i,
      ot + a.toString(),
      JSON.stringify(s)
    );
  }
  t.lastModified && !va(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Gn() {
}
function wa(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, aa(e);
  }));
}
function ga(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, i = e.iconsToLoad;
    delete e.iconsToLoad;
    let r;
    if (!i || !(r = Jt(n)))
      return;
    r.prepare(n, o, i).forEach((s) => {
      Ro(n, s, (l) => {
        if (typeof l != "object")
          s.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = xn(
              e,
              l
            );
            if (!c.length)
              return;
            const u = e.pendingIcons;
            u && c.forEach((d) => {
              u.delete(d);
            }), ba(e, l);
          } catch (c) {
            console.error(c);
          }
        wa(e);
      });
    });
  }));
}
const Sn = (e, t) => {
  const n = sa(e, !0, $o()), o = ia(n);
  if (!o.pending.length) {
    let l = !0;
    return t && setTimeout(() => {
      l && t(
        o.loaded,
        o.missing,
        o.pending,
        Gn
      );
    }), () => {
      l = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), r = [];
  let a, s;
  return o.pending.forEach((l) => {
    const { provider: c, prefix: u } = l;
    if (u === s && c === a)
      return;
    a = c, s = u, r.push(be(c, u));
    const d = i[c] || (i[c] = /* @__PURE__ */ Object.create(null));
    d[u] || (d[u] = []);
  }), o.pending.forEach((l) => {
    const { provider: c, prefix: u, name: d } = l, f = be(c, u), h = f.pendingIcons || (f.pendingIcons = /* @__PURE__ */ new Set());
    h.has(d) || (h.add(d), i[c][u].push(d));
  }), r.forEach((l) => {
    const { provider: c, prefix: u } = l;
    i[c][u].length && ga(l, i[c][u]);
  }), t ? la(t, o, r) : Gn;
}, ya = (e) => new Promise((t, n) => {
  const o = typeof e == "string" ? lt(e, !0) : e;
  if (!o) {
    n(e);
    return;
  }
  Sn([o || e], (i) => {
    if (i.length && o) {
      const r = nt(o);
      if (r) {
        t({
          ...rt,
          ...r
        });
        return;
      }
    }
    n(e);
  });
});
function xa(e) {
  try {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (typeof t.body == "string")
      return {
        ...t
      };
  } catch {
  }
}
function Ca(e, t) {
  const n = typeof e == "string" ? lt(e, !0, !0) : null;
  if (!n) {
    const r = xa(e);
    return {
      value: e,
      data: r
    };
  }
  const o = nt(n);
  if (o !== void 0 || !n.prefix)
    return {
      value: e,
      name: n,
      data: o
      // could be 'null' -> icon is missing
    };
  const i = Sn([n], () => t(e, n, nt(n)));
  return {
    value: e,
    name: n,
    loading: i
  };
}
let Wo = !1;
try {
  Wo = navigator.vendor.indexOf("Apple") === 0;
} catch {
}
function ka(e, t) {
  switch (t) {
    case "svg":
    case "bg":
    case "mask":
      return t;
  }
  return t !== "style" && (Wo || e.indexOf("<a") === -1) ? "svg" : e.indexOf("currentColor") === -1 ? "bg" : "mask";
}
const Ta = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Sa = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function on(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(Ta);
  if (o === null || !o.length)
    return e;
  const i = [];
  let r = o.shift(), a = Sa.test(r);
  for (; ; ) {
    if (a) {
      const s = parseFloat(r);
      isNaN(s) ? i.push(r) : i.push(Math.ceil(s * t * n) / n);
    } else
      i.push(r);
    if (r = o.shift(), r === void 0)
      return i.join("");
    a = !a;
  }
}
function Ia(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const i = e.indexOf(">", o), r = e.indexOf("</" + t);
    if (i === -1 || r === -1)
      break;
    const a = e.indexOf(">", r);
    if (a === -1)
      break;
    n += e.slice(i + 1, r).trim(), e = e.slice(0, o).trim() + e.slice(a + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function Aa(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Ea(e, t, n) {
  const o = Ia(e);
  return Aa(o.defs, t + o.content + n);
}
const Ma = (e) => e === "unset" || e === "undefined" || e === "none";
function _o(e, t) {
  const n = {
    ...rt,
    ...e
  }, o = {
    ...Mo,
    ...t
  }, i = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let r = n.body;
  [n, o].forEach((y) => {
    const w = [], m = y.hFlip, x = y.vFlip;
    let C = y.rotate;
    m ? x ? C += 2 : (w.push(
      "translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"
    ), w.push("scale(-1 1)"), i.top = i.left = 0) : x && (w.push(
      "translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"
    ), w.push("scale(1 -1)"), i.top = i.left = 0);
    let T;
    switch (C < 0 && (C -= Math.floor(C / 4) * 4), C = C % 4, C) {
      case 1:
        T = i.height / 2 + i.top, w.unshift(
          "rotate(90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
      case 2:
        w.unshift(
          "rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")"
        );
        break;
      case 3:
        T = i.width / 2 + i.left, w.unshift(
          "rotate(-90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
    }
    C % 2 === 1 && (i.left !== i.top && (T = i.left, i.left = i.top, i.top = T), i.width !== i.height && (T = i.width, i.width = i.height, i.height = T)), w.length && (r = Ea(
      r,
      '<g transform="' + w.join(" ") + '">',
      "</g>"
    ));
  });
  const a = o.width, s = o.height, l = i.width, c = i.height;
  let u, d;
  a === null ? (d = s === null ? "1em" : s === "auto" ? c : s, u = on(d, l / c)) : (u = a === "auto" ? l : a, d = s === null ? on(u, c / l) : s === "auto" ? c : s);
  const f = {}, h = (y, w) => {
    Ma(w) || (f[y] = w.toString());
  };
  h("width", u), h("height", d);
  const v = [i.left, i.top, l, c];
  return f.viewBox = v.join(" "), {
    attributes: f,
    viewBox: v,
    body: r
  };
}
function In(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function za(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Fa(e) {
  return "data:image/svg+xml," + za(e);
}
function Ko(e) {
  return 'url("' + Fa(e) + '")';
}
const Na = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Ct = Na();
function $a(e) {
  Ct = e;
}
function Oa() {
  return Ct;
}
function La(e, t) {
  const n = Nt(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let i = 0;
    n.resources.forEach((a) => {
      i = Math.max(i, a.length);
    });
    const r = t + ".json?icons=";
    o = n.maxURL - i - n.path.length - r.length;
  }
  return o;
}
function Da(e) {
  return e === 404;
}
const Ra = (e, t, n) => {
  const o = [], i = La(e, t), r = "icons";
  let a = {
    type: r,
    provider: e,
    prefix: t,
    icons: []
  }, s = 0;
  return n.forEach((l, c) => {
    s += l.length + 1, s >= i && c > 0 && (o.push(a), a = {
      type: r,
      provider: e,
      prefix: t,
      icons: []
    }, s = l.length), a.icons.push(l);
  }), o.push(a), o;
};
function Pa(e) {
  if (typeof e == "string") {
    const t = Nt(e);
    if (t)
      return t.path;
  }
  return "/";
}
const Va = (e, t, n) => {
  if (!Ct) {
    n("abort", 424);
    return;
  }
  let o = Pa(t.provider);
  switch (t.type) {
    case "icons": {
      const r = t.prefix, s = t.icons.join(","), l = new URLSearchParams({
        icons: s
      });
      o += r + ".json?" + l.toString();
      break;
    }
    case "custom": {
      const r = t.uri;
      o += r.slice(0, 1) === "/" ? r.slice(1) : r;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let i = 503;
  Ct(e + o).then((r) => {
    const a = r.status;
    if (a !== 200) {
      setTimeout(() => {
        n(Da(a) ? "abort" : "next", a);
      });
      return;
    }
    return i = 501, r.json();
  }).then((r) => {
    if (typeof r != "object" || r === null) {
      setTimeout(() => {
        r === 404 ? n("abort", r) : n("next", i);
      });
      return;
    }
    setTimeout(() => {
      n("success", r);
    });
  }).catch(() => {
    n("next", i);
  });
}, Ha = {
  prepare: Ra,
  send: Va
};
function Qn(e, t) {
  switch (e) {
    case "local":
    case "session":
      ke[e] = t;
      break;
    case "all":
      for (const n in ke)
        ke[n] = t;
      break;
  }
}
const Bt = "data-style";
let qo = "";
function Go(e) {
  qo = e;
}
function Yn(e, t) {
  let n = Array.from(e.childNodes).find((o) => o.hasAttribute && o.hasAttribute(Bt));
  n || (n = document.createElement("style"), n.setAttribute(Bt, Bt), e.appendChild(n)), n.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block}" + qo;
}
function Qo() {
  jn("", Ha), $o(!0);
  let e;
  try {
    e = window;
  } catch {
  }
  if (e) {
    if (Uo(), e.IconifyPreload !== void 0) {
      const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
      typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((i) => {
        try {
          // Check if item is an object and not null/array
          (typeof i != "object" || i === null || i instanceof Array || // Check for 'icons' and 'prefix'
          typeof i.icons != "object" || typeof i.prefix != "string" || // Add icon set
          !Hn(i)) && console.error(o);
        } catch {
          console.error(o);
        }
      });
    }
    if (e.IconifyProviders !== void 0) {
      const n = e.IconifyProviders;
      if (typeof n == "object" && n !== null)
        for (const o in n) {
          const i = "IconifyProviders[" + o + "] is invalid.";
          try {
            const r = n[o];
            if (typeof r != "object" || !r || r.resources === void 0)
              continue;
            Un(o, r) || console.error(i);
          } catch {
            console.error(i);
          }
        }
    }
  }
  return {
    enableCache: (n) => Qn(n, !0),
    disableCache: (n) => Qn(n, !1),
    iconLoaded: Bn,
    iconExists: Bn,
    // deprecated, kept to avoid breaking changes
    getIcon: oa,
    listIcons: na,
    addIcon: Oo,
    addCollection: Hn,
    calculateSize: on,
    buildIcon: _o,
    iconToHTML: In,
    svgToURL: Ko,
    loadIcons: Sn,
    loadIcon: ya,
    addAPIProvider: Un,
    appendCustomStyle: Go,
    _api: {
      getAPIConfig: Nt,
      setAPIModule: jn,
      sendAPIQuery: Ro,
      setFetch: $a,
      getFetch: Oa,
      listAPIProviders: da
    }
  };
}
const an = {
  "background-color": "currentColor"
}, Yo = {
  "background-color": "transparent"
}, Xn = {
  image: "var(--svg)",
  repeat: "no-repeat",
  size: "100% 100%"
}, Zn = {
  "-webkit-mask": an,
  mask: an,
  background: Yo
};
for (const e in Zn) {
  const t = Zn[e];
  for (const n in Xn)
    t[e + "-" + n] = Xn[n];
}
function Jn(e) {
  return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
function Ba(e, t, n) {
  const o = document.createElement("span");
  let i = e.body;
  i.indexOf("<a") !== -1 && (i += "<!-- " + Date.now() + " -->");
  const r = e.attributes, a = In(i, {
    ...r,
    width: t.width + "",
    height: t.height + ""
  }), s = Ko(a), l = o.style, c = {
    "--svg": s,
    width: Jn(r.width),
    height: Jn(r.height),
    ...n ? an : Yo
  };
  for (const u in c)
    l.setProperty(u, c[u]);
  return o;
}
let Ze;
function ja() {
  try {
    Ze = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    Ze = null;
  }
}
function Ua(e) {
  return Ze === void 0 && ja(), Ze ? Ze.createHTML(e) : e;
}
function Wa(e) {
  const t = document.createElement("span"), n = e.attributes;
  let o = "";
  n.width || (o = "width: inherit;"), n.height || (o += "height: inherit;"), o && (n.style = o);
  const i = In(e.body, n);
  return t.innerHTML = Ua(i), t.firstChild;
}
function rn(e) {
  return Array.from(e.childNodes).find((t) => {
    const n = t.tagName && t.tagName.toUpperCase();
    return n === "SPAN" || n === "SVG";
  });
}
function eo(e, t) {
  const n = t.icon.data, o = t.customisations, i = _o(n, o);
  o.preserveAspectRatio && (i.attributes.preserveAspectRatio = o.preserveAspectRatio);
  const r = t.renderedMode;
  let a;
  switch (r) {
    case "svg":
      a = Wa(i);
      break;
    default:
      a = Ba(i, {
        ...rt,
        ...n
      }, r === "mask");
  }
  const s = rn(e);
  s ? a.tagName === "SPAN" && s.tagName === a.tagName ? s.setAttribute("style", a.getAttribute("style")) : e.replaceChild(a, s) : e.appendChild(a);
}
function to(e, t, n) {
  const o = n && (n.rendered ? n : n.lastRender);
  return {
    rendered: !1,
    inline: t,
    icon: e,
    lastRender: o
  };
}
function _a(e = "iconify-icon") {
  let t, n;
  try {
    t = window.customElements, n = window.HTMLElement;
  } catch {
    return;
  }
  if (!t || !n)
    return;
  const o = t.get(e);
  if (o)
    return o;
  const i = [
    // Icon
    "icon",
    // Mode
    "mode",
    "inline",
    "noobserver",
    // Customisations
    "width",
    "height",
    "rotate",
    "flip"
  ], r = class extends n {
    /**
     * Constructor
     */
    constructor() {
      super();
      // Root
      pe(this, "_shadowRoot");
      // Initialised
      pe(this, "_initialised", !1);
      // Icon state
      pe(this, "_state");
      // Attributes check queued
      pe(this, "_checkQueued", !1);
      // Connected
      pe(this, "_connected", !1);
      // Observer
      pe(this, "_observer", null);
      pe(this, "_visible", !0);
      const l = this._shadowRoot = this.attachShadow({
        mode: "open"
      }), c = this.hasAttribute("inline");
      Yn(l, c), this._state = to({
        value: ""
      }, c), this._queueCheck();
    }
    /**
     * Connected to DOM
     */
    connectedCallback() {
      this._connected = !0, this.startObserver();
    }
    /**
     * Disconnected from DOM
     */
    disconnectedCallback() {
      this._connected = !1, this.stopObserver();
    }
    /**
     * Observed attributes
     */
    static get observedAttributes() {
      return i.slice(0);
    }
    /**
     * Observed properties that are different from attributes
     *
     * Experimental! Need to test with various frameworks that support it
     */
    /*
    static get properties() {
        return {
            inline: {
                type: Boolean,
                reflect: true,
            },
            // Not listing other attributes because they are strings or combination
            // of string and another type. Cannot have multiple types
        };
    }
    */
    /**
     * Attribute has changed
     */
    attributeChangedCallback(l) {
      switch (l) {
        case "inline": {
          const c = this.hasAttribute("inline"), u = this._state;
          c !== u.inline && (u.inline = c, Yn(this._shadowRoot, c));
          break;
        }
        case "noobserver": {
          this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
          break;
        }
        default:
          this._queueCheck();
      }
    }
    /**
     * Get/set icon
     */
    get icon() {
      const l = this.getAttribute("icon");
      if (l && l.slice(0, 1) === "{")
        try {
          return JSON.parse(l);
        } catch {
        }
      return l;
    }
    set icon(l) {
      typeof l == "object" && (l = JSON.stringify(l)), this.setAttribute("icon", l);
    }
    /**
     * Get/set inline
     */
    get inline() {
      return this.hasAttribute("inline");
    }
    set inline(l) {
      l ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
    }
    /**
     * Get/set observer
     */
    get observer() {
      return this.hasAttribute("observer");
    }
    set observer(l) {
      l ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
    }
    /**
     * Restart animation
     */
    restartAnimation() {
      const l = this._state;
      if (l.rendered) {
        const c = this._shadowRoot;
        if (l.renderedMode === "svg")
          try {
            c.lastChild.setCurrentTime(0);
            return;
          } catch {
          }
        eo(c, l);
      }
    }
    /**
     * Get status
     */
    get status() {
      const l = this._state;
      return l.rendered ? "rendered" : l.icon.data === null ? "failed" : "loading";
    }
    /**
     * Queue attributes re-check
     */
    _queueCheck() {
      this._checkQueued || (this._checkQueued = !0, setTimeout(() => {
        this._check();
      }));
    }
    /**
     * Check for changes
     */
    _check() {
      if (!this._checkQueued)
        return;
      this._checkQueued = !1;
      const l = this._state, c = this.getAttribute("icon");
      if (c !== l.icon.value) {
        this._iconChanged(c);
        return;
      }
      if (!l.rendered || !this._visible)
        return;
      const u = this.getAttribute("mode"), d = Pn(this);
      (l.attrMode !== u || Qi(l.customisations, d) || !rn(this._shadowRoot)) && this._renderIcon(l.icon, d, u);
    }
    /**
     * Icon value has changed
     */
    _iconChanged(l) {
      const c = Ca(l, (u, d, f) => {
        const h = this._state;
        if (h.rendered || this.getAttribute("icon") !== u)
          return;
        const v = {
          value: u,
          name: d,
          data: f
        };
        v.data ? this._gotIconData(v) : h.icon = v;
      });
      c.data ? this._gotIconData(c) : this._state = to(c, this._state.inline, this._state);
    }
    /**
     * Force render icon on state change
     */
    _forceRender() {
      if (!this._visible) {
        const l = rn(this._shadowRoot);
        l && this._shadowRoot.removeChild(l);
        return;
      }
      this._queueCheck();
    }
    /**
     * Got new icon data, icon is ready to (re)render
     */
    _gotIconData(l) {
      this._checkQueued = !1, this._renderIcon(l, Pn(this), this.getAttribute("mode"));
    }
    /**
     * Re-render based on icon data
     */
    _renderIcon(l, c, u) {
      const d = ka(l.data.body, u), f = this._state.inline;
      eo(this._shadowRoot, this._state = {
        rendered: !0,
        icon: l,
        inline: f,
        customisations: c,
        attrMode: u,
        renderedMode: d
      });
    }
    /**
     * Start observer
     */
    startObserver() {
      if (!this._observer && !this.hasAttribute("noobserver"))
        try {
          this._observer = new IntersectionObserver((l) => {
            const c = l.some((u) => u.isIntersecting);
            c !== this._visible && (this._visible = c, this._forceRender());
          }), this._observer.observe(this);
        } catch {
          if (this._observer) {
            try {
              this._observer.disconnect();
            } catch {
            }
            this._observer = null;
          }
        }
    }
    /**
     * Stop observer
     */
    stopObserver() {
      this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
    }
  };
  i.forEach((s) => {
    s in r.prototype || Object.defineProperty(r.prototype, s, {
      get: function() {
        return this.getAttribute(s);
      },
      set: function(l) {
        l !== null ? this.setAttribute(s, l) : this.removeAttribute(s);
      }
    });
  });
  const a = Qo();
  for (const s in a)
    r[s] = r.prototype[s] = a[s];
  return t.define(e, r), r;
}
const Xo = _a() || Qo(), {
  enableCache: Ka,
  disableCache: qa,
  iconLoaded: Ga,
  iconExists: Qa,
  // deprecated, kept to avoid breaking changes
  getIcon: Ya,
  listIcons: Xa,
  addIcon: Za,
  addCollection: Zo,
  calculateSize: Ja,
  buildIcon: er,
  iconToHTML: tr,
  svgToURL: nr,
  loadIcons: or,
  loadIcon: ir,
  addAPIProvider: ar,
  _api: rr
} = Xo, C0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconifyIconComponent: Xo,
  _api: rr,
  addAPIProvider: ar,
  addCollection: Zo,
  addIcon: Za,
  appendCustomStyle: Go,
  buildIcon: er,
  calculateSize: Ja,
  disableCache: qa,
  enableCache: Ka,
  getIcon: Ya,
  iconExists: Qa,
  iconLoaded: Ga,
  iconToHTML: tr,
  listIcons: Xa,
  loadIcon: ir,
  loadIcons: or,
  svgToURL: nr
}, Symbol.toStringTag, { value: "Module" }));
function lr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jo = {}, ei = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, i) {
    return {
      handler: o,
      config: i
    };
  }
  t.withOptions = function(o, i = () => ({})) {
    const r = function(a) {
      return {
        __options: a,
        handler: o(a),
        config: i(a)
      };
    };
    return r.__isOptionsFunction = !0, r.__pluginFunction = o, r.__configFunction = i, r;
  };
  const n = t;
})(ei);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(ei);
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const o = t.default;
})(Jo);
let jt = Jo;
var sr = (jt.__esModule ? jt : { default: jt }).default;
const cr = /* @__PURE__ */ lr(sr), te = {
  white: "#FFFFFF",
  lin: "#F7F6F0",
  charcoal: "#2B2B2B",
  black: "#131313"
}, J = {
  700: "#BA5225",
  600: "#CD4D16",
  500: "#EB512F",
  // Corale
  450: "#F9885E",
  400: "#F5B1A2",
  300: "#FCE2DD",
  200: "#FDEFEC",
  100: "#FEF7F5"
}, G = {
  750: "#1D1D1D",
  700: "#404040",
  600: "#525252",
  500: "#737373",
  400: "#A3A3A3",
  300: "#D4D4D4",
  200: "#E5E5E5",
  150: "#EEEEEE",
  100: "#F5F5F5"
}, Pe = {
  500: "#1C6BB8",
  // Lapis-lazuli
  450: "#528BDD",
  300: "#71B9FF",
  100: "#EAEFF8"
}, dt = {
  700: "#247A5E",
  200: "#EBF8F3"
}, ft = {
  600: "#C83844",
  500: "#EB4452",
  200: "#F8EFF0"
}, ht = {
  800: "#95672B",
  500: "#FBBA66",
  200: "#FFF8F0"
}, ue = {
  500: "#9C3BC9",
  400: "#BF8FE4",
  300: "#D3ADEF",
  100: "#F0DBFF",
  50: "#F8F1FC"
}, ee = {
  "orange-600-25": "#CD4D1640",
  "neutral-800-15": "#17171726",
  "neutral-800-25": "#17171740",
  "lin-25": "#F7F6F040",
  "lavender-300-25": "#D3ADEF40",
  transparent: "#00000000"
}, Ut = {
  DEFAULT: Pe[450],
  focus: Pe[450],
  "focus-inverse": Pe[300]
}, ln = [
  "Circular",
  '"system-ui"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], ur = ["neue-haas-display", ...ln], mt = {
  background: {
    default: G[150],
    surface: te.white,
    "surface-hover": G[100],
    "surface-neutral": G[100],
    fill: te.lin,
    "fill-accent": ue[300],
    "fill-accent-discrete": ue[100],
    "fill-accent-discrete2": ue[50],
    "fill-accent-hover": ue[400],
    "fill-accent-disabled": ee["lavender-300-25"],
    "fill-alt": te.charcoal,
    "fill-alt-hover": G[750],
    "fill-brand": J[100],
    "fill-hover": G[150],
    "fill-hover-primary": J[200],
    "fill-alt-disabled": ee["neutral-800-15"],
    "fill-primary": J[600],
    "fill-primary-disabled": ee["orange-600-25"],
    "fill-primary-hover": J[700],
    "fill-tip": Pe[100],
    "fill-error": ft[200],
    "fill-success": dt[200],
    "fill-caution": ht[200],
    "fill-discrete": G[300],
    "fill-discrete2": G[200],
    "fill-discrete3": G[150],
    "fill-neutral": G[500],
    "fill-neutral-hover": G[700],
    "fill-neutral-alt-hover": G[400],
    "fill-primary-discrete": J[300],
    "fill-primary-discrete2": J[200],
    "fill-primary-discrete1": J[100],
    transparent: ee.transparent
  },
  text: {
    // adding this to make sure there's always a way to access the default color
    "default-color": te.charcoal,
    accent: ue[500],
    "accent-disabled": ee["lavender-300-25"],
    inverse: te.lin,
    "inverse-accent": ue[300],
    "inverse-disabled": te.lin,
    abovePrimary: te.lin,
    "abovePrimary-disabled": ee["lin-25"],
    primary: J[600],
    "primary-disabled": ee["orange-600-25"],
    "primary-discrete": J[400],
    discrete: G[600],
    discrete2: G[500],
    discrete3: G[400],
    disabled: ee["neutral-800-25"],
    success: dt[700],
    error: ft[600],
    caution: ht[800],
    link: J[600],
    "link-inverse": J[450]
  },
  border: {
    default: te.charcoal,
    // adding this to make sure there's always a way to access the default color
    "default-color": te.charcoal,
    accent: ue[500],
    "accent-disabled": ee["lavender-300-25"],
    "inverse-accent": ue[300],
    primary: J[600],
    "primary-disabled": ee["orange-600-25"],
    error: ft[500],
    success: dt[700],
    tip: Pe[500],
    caution: ht[500],
    discrete: G[500],
    discrete2: G[400],
    discrete3: G[300],
    disabled: ee["neutral-800-25"],
    brand: J[400],
    transparent: ee.transparent
  },
  icon: {
    icon: te.charcoal,
    // default
    "icon-accent": ue[500],
    "icon-accent-disabled": ee["lavender-300-25"],
    "icon-inverse-accent": ue[300],
    "icon-inverse": te.lin,
    "icon-primary": J[600],
    "icon-brand": J[500],
    "icon-abovePrimary": te.lin,
    "icon-abovePrimary-disabled": te.lin,
    "icon-primary-disabled": ee["orange-600-25"],
    "icon-discrete": G[600],
    "icon-discrete2": G[500],
    "icon-discrete3": G[400],
    "icon-disabled": ee["neutral-800-25"],
    "icon-success": dt[700],
    "icon-error": ft[600],
    "icon-tip": Pe[500],
    "icon-caution": ht[500]
  }
}, dr = {
  screens: {
    sm: "320px",
    md: "768px",
    lg: "1024px"
  },
  fontFamily: {
    DEFAULT: ln,
    sans: ln,
    title: ur
  },
  fontSize: {
    DEFAULT: "1rem",
    // 16px
    "2xs": "0.75rem",
    // 12px
    xs: "0.8125rem",
    // 13px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.75rem",
    // 28px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem"
    // 60px
  },
  lineHeight: {
    DEFAULT: "1.5rem",
    // 24px
    sm: "1.25rem",
    // 20px
    "3xl": "2rem",
    // 32px
    "4xl": "3rem",
    // 40px
    "5xl": "3.5rem",
    // 64px
    "6xl": "4.5rem"
    // 72px
  },
  fontWeight: {
    DEFAULT: "450",
    normal: "450",
    medium: "500",
    bold: "700",
    black: "900"
  },
  spacing: {
    zero: "0px",
    "4xs": "1px",
    "3xs": "2px",
    "2xs": "4px",
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
    "5xl": "48px",
    "6xl": "64px",
    "7xl": "80px",
    "8xl": "120px",
    "9xl": "150px",
    "10xl": "256px"
  },
  borderRadius: {
    DEFAULT: "4px",
    none: "0",
    xs: "2px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    "3xl": "24px",
    "4xl": "40px",
    full: "9999px"
  },
  boxShadow: {
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    reverse: "0 -10px 15px -3 rgb(0 0 0 / 0.05)"
  },
  color: {
    transparent: "transparent",
    black: te.black,
    white: te.white
  },
  borderColor: {
    ...mt.border
  },
  outlineColor: () => Ut,
  ringColor: () => Ut,
  ringOffsetColor: () => Ut,
  backgroundColor: {
    ...mt.background
  },
  textColor: {
    ...mt.text,
    ...mt.icon
  },
  transitionTimingFunction: {
    "slow-down": "cubic-bezier(0, 0.35, 0, 1)",
    smooth: "cubic-bezier(0.35, 0.1, 0, 1)"
  }
}, fr = {
  theme: {
    ...dr
  }
}, k0 = cr(
  function({ addBase: e, addComponents: t, theme: n }) {
    const o = {
      fontSize: n("fontSize.6xl"),
      fontFamily: n("fontFamily.title"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.6xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.5xl"),
        lineHeight: n("lineHeight.5xl")
      }
    }, i = {
      fontSize: n("fontSize.5xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.5xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.4xl"),
        lineHeight: n("lineHeight.4xl")
      }
    }, r = {
      fontSize: n("fontSize.4xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      lineHeight: n("lineHeight.4xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.3xl"),
        lineHeight: n("lineHeight.3xl")
      }
    }, a = {
      fontSize: n("fontSize.3xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.3xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.2xl"),
        lineHeight: n("lineHeight.2xl")
      }
    }, s = {
      fontSize: n("fontSize.2xl"),
      lineHeight: n("lineHeight.3xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.xl"),
        lineHeight: n("lineHeight.xl")
      }
    }, l = {
      fontSize: n("fontSize.xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.DEFAULT"),
      fontFamily: n("fontFamily.title")
    };
    t({
      ".text-h1": o,
      ".text-h2": i,
      ".text-h3": r,
      ".text-h4": a,
      ".text-h5": s,
      ".text-h6": l,
      ".text-body": {
        fontSize: n("fontSize.DEFAULT"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-lg": {
        fontSize: n("fontSize.lg"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-sm": {
        fontSize: n("fontSize.sm"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-body-xs": {
        fontSize: n("fontSize.xs"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-form-error": {
        color: n("textColor.error"),
        fontSize: n("fontSize.sm"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-heading-uppercase": {
        fontSize: n("fontSize.2xs"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm"),
        textTransform: "uppercase"
      }
    });
  },
  {
    theme: {
      ...fr.theme
    }
  }
), hr = ["icon", "aria-label"], mr = {}, B = /* @__PURE__ */ U({
  ...mr,
  __name: "UIIcon",
  props: {
    name: {},
    size: { default: "base" }
  },
  setup(e) {
    let t;
    ((i) => {
      i.sm = "16", i.base = "20", i.lg = "24", i.xl = "32", i["2xl"] = "40";
    })(t || (t = {}));
    const n = e, o = _({
      height: `${t[n.size]}px`,
      width: `${t[n.size]}px`,
      style: {
        height: `${t[n.size]}px`,
        width: `${t[n.size]}px`
      },
      class: "tw-inline-block",
      role: "img",
      "data-allow-mismatch": !0
    });
    return (i, r) => (g(), I("iconify-icon", ve({ icon: i.name }, o.value, { "aria-label": i.name }), null, 16, hr));
  }
}), pr = ["disabled", "checked"], vr = ["disabled"], ti = /* @__PURE__ */ U({
  __name: "BaseChip",
  props: /* @__PURE__ */ ie({
    color: { default: "default" },
    component: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue"), i = k(() => ({
      "tw-flex tw-w-fit tw-items-center tw-gap-2xs tw-rounded-full tw-transition-all": !0
    })), r = k(() => ({
      "tw-cursor-not-allowed": e.disabled,
      "tw-bg-fill-discrete3": e.color === "default",
      "hover:tw-bg-fill-discrete2": e.color === "default" && !e.disabled,
      "tw-bg-fill-alt": e.color === "alt",
      "tw-bg-fill-success": e.color === "success",
      "tw-bg-fill-caution": e.color === "warning",
      "tw-bg-fill-error": e.color === "error",
      "tw-bg-surface": e.color === "dashed",
      "hover:tw-bg-surface-hover": e.color === "dashed" && !e.disabled
    })), a = k(() => ({
      "tw-border-dashed tw-border tw-border-discrete3": e.color === "dashed",
      "tw-border-transparent tw-border": e.color !== "dashed",
      "focus-visible:tw-outline": !e.disabled && e.component !== "input",
      "focus-within:tw-outline": !e.disabled && e.component === "input"
    })), s = k(() => ({
      "tw-px-sm tw-py-xs": e.size === "sm",
      "tw-px-md tw-py-sm": e.size === "base"
    })), l = k(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-success": e.color === "success",
      "tw-text-caution": e.color === "warning",
      "tw-text-error": e.color === "error",
      // size
      "tw-text-body-xs": e.size === "sm",
      "tw-text-body-sm": e.size === "base"
    })), c = k(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-icon-success": e.color === "success",
      "tw-text-icon-caution": e.color === "warning",
      "tw-text-icon-error": e.color === "error"
    }));
    return (u, d) => u.component === "input" ? (g(), I("label", {
      key: 0,
      class: F([
        i.value,
        r.value,
        s.value,
        a.value
      ]),
      onClick: d[1] || (d[1] = (f) => n("click")),
      onKeypress: d[2] || (d[2] = gt((f) => n("click"), ["space"]))
    }, [
      R("input", {
        type: "checkbox",
        class: "tw-sr-only",
        disabled: u.disabled,
        checked: o.value,
        onClick: d[0] || (d[0] = Qt(() => {
        }, ["stop"]))
      }, null, 8, pr),
      u.iconLeftName ? (g(), P(B, {
        key: 0,
        name: u.iconLeftName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      u.text ? (g(), I("span", {
        key: 1,
        "data-test-id": "chip-text",
        class: F(["tw-px-3xs", [l.value]])
      }, Q(u.text), 3)) : A("", !0),
      u.iconRightName ? (g(), P(B, {
        key: 2,
        name: u.iconRightName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 34)) : (g(), I("button", {
      key: 1,
      type: "button",
      class: F([
        i.value,
        r.value,
        s.value,
        a.value
      ]),
      disabled: u.disabled,
      onClick: d[3] || (d[3] = (f) => n("click"))
    }, [
      u.iconLeftName ? (g(), P(B, {
        key: 0,
        name: u.iconLeftName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      u.text ? (g(), I("span", {
        key: 1,
        "data-test-id": "chip-text",
        class: F(["tw-px-3xs", [l.value]])
      }, Q(u.text), 3)) : A("", !0),
      u.iconRightName ? (g(), P(B, {
        key: 2,
        name: u.iconRightName,
        size: "sm",
        class: F(c.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 10, vr));
  }
});
function An() {
  const e = Ei("NuxtLink"), t = k(() => e === "NuxtLink" ? "a" : e);
  function n(i) {
    return i.startsWith("http");
  }
  function o(i) {
    return i;
  }
  return typeof useLocalePath == "function" && (o = useLocalePath()), {
    isExternalLink: n,
    linkComponent: t,
    localePath: o
  };
}
function $t(e) {
  return go() ? (yo(e), !0) : !1;
}
const Wt = /* @__PURE__ */ new WeakMap(), br = (...e) => {
  var t;
  const n = e[0], o = (t = wn()) == null ? void 0 : t.proxy;
  if (o == null && !xo())
    throw new Error("injectLocal must be called in setup");
  return o && Wt.has(o) && n in Wt.get(o) ? Wt.get(o)[n] : Fi(...e);
}, En = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const wr = (e) => e != null, gr = Object.prototype.toString, ni = (e) => gr.call(e) === "[object Object]", xe = () => {
}, sn = /* @__PURE__ */ yr();
function yr() {
  var e, t;
  return En && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function no(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function xr(e) {
  return wn();
}
function Te(e) {
  return Array.isArray(e) ? e : [e];
}
function Cr(...e) {
  if (e.length !== 1)
    return gn(...e);
  const t = e[0];
  return typeof t == "function" ? Ni($i(() => ({ get: t, set: xe }))) : _(t);
}
function kr(e, t = !0, n) {
  xr() ? bn(e, n) : t ? e() : zi(e);
}
function Tr(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: o = !1
  } = t, i = Mi(e), r = _(e);
  function a(s) {
    if (arguments.length)
      return r.value = s, r.value;
    {
      const l = q(n);
      return r.value = r.value === l ? q(o) : l, r.value;
    }
  }
  return i ? a : [r, a];
}
function oi(e, t, n) {
  return le(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const Mn = En ? window : void 0;
function ii(e) {
  var t;
  const n = q(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function cn(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, o = (s, l, c, u) => (s.addEventListener(l, c, u), () => s.removeEventListener(l, c, u)), i = k(() => {
    const s = Te(q(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), r = oi(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((c) => ii(c))) != null ? l : [Mn].filter((c) => c != null),
        Te(q(i.value ? e[1] : e[0])),
        Te(M(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        q(i.value ? e[3] : e[2])
      ];
    },
    ([s, l, c, u]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const d = ni(u) ? { ...u } : u;
      t.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => c.map((v) => o(f, h, v, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), n();
  };
  return $t(n), a;
}
function Sr() {
  const e = Ie(!1), t = wn();
  return t && bn(() => {
    e.value = !0;
  }, t), e;
}
function Ir(e) {
  const t = Sr();
  return k(() => (t.value, !!e()));
}
const Ar = Symbol("vueuse-ssr-width");
function Er() {
  const e = xo() ? br(Ar, null) : null;
  return typeof e == "number" ? e : void 0;
}
function Mr(e, t = {}) {
  const { window: n = Mn, ssrWidth: o = Er() } = t, i = Ir(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), r = _(typeof o == "number"), a = Ie(), s = Ie(!1), l = (c) => {
    s.value = c.matches;
  };
  return Oi(() => {
    if (r.value) {
      r.value = !i.value;
      const c = q(e).split(",");
      s.value = c.some((u) => {
        const d = u.includes("not all"), f = u.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = u.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let v = !!(f || h);
        return f && v && (v = o >= no(f[1])), h && v && (v = o <= no(h[1])), d ? !v : v;
      });
      return;
    }
    i.value && (a.value = n.matchMedia(q(e)), s.value = a.value.matches);
  }), cn(a, "change", l, { passive: !0 }), k(() => s.value);
}
function zr(e = {}) {
  const {
    window: t = Mn,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: r = !0,
    type: a = "inner"
  } = e, s = _(n), l = _(o), c = () => {
    if (t)
      if (a === "outer")
        s.value = t.outerWidth, l.value = t.outerHeight;
      else if (a === "visual" && t.visualViewport) {
        const { width: d, height: f, scale: h } = t.visualViewport;
        s.value = Math.round(d * h), l.value = Math.round(f * h);
      } else r ? (s.value = t.innerWidth, l.value = t.innerHeight) : (s.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight);
  };
  c(), kr(c);
  const u = { passive: !0 };
  if (cn("resize", c, u), t && a === "visual" && t.visualViewport && cn(t.visualViewport, "resize", c, u), i) {
    const d = Mr("(orientation: portrait)");
    le(d, () => c());
  }
  return { width: s, height: l };
}
var Qe = /* @__PURE__ */ ((e) => (e[e.sm = 320] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e))(Qe || {});
function Fr() {
  const { width: e } = zr(), t = k(() => e.value < Qe.md), n = k(
    () => e.value >= Qe.md && e.value < Qe.lg
  ), o = k(() => e.value >= Qe.lg);
  return {
    isSm: t,
    isMd: n,
    isLg: o
  };
}
function ai(e) {
  const { isSm: t } = Fr(), n = k(() => {
    const i = q(e);
    return i === "large" && t.value ? "medium" : i === "medium" && t.value ? "small" : i;
  }), o = k(
    () => n.value === "large" ? "lg" : "base"
  );
  return {
    scaledButtonSize: n,
    scaledIconSize: o
  };
}
const Nr = { class: "tw-flex tw-items-center tw-justify-center tw-gap-x-2xs" }, $r = {
  key: 1,
  class: "tw-whitespace-nowrap"
}, Or = {}, oo = /* @__PURE__ */ U({
  ...Or,
  __name: "UIButton",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    size: { default: "medium" },
    text: { default: null },
    to: { default: void 0 },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = yn(), { linkComponent: r, localePath: a, isExternalLink: s } = An(), { scaledButtonSize: l, scaledIconSize: c } = ai(
      gn(() => n.size)
    ), u = "tw-p-3xs tw-text-sm tw-leading-sm tw-h-2xl", d = "tw-p-sm tw-text-sm tw-leading-sm tw-h-[36px]", f = "tw-p-md tw-text-base tw-leading tw-h-5xl", h = "tw-p-lg tw-text-lg tw-leading tw-h-[56px]", v = "tw-text-abovePrimary tw-bg-fill-primary tw-border-primary disabled:tw-bg-fill-primary-disabled hover:tw-bg-fill-primary-hover hover:tw-shadow-md", y = "tw-bg-fill-alt tw-text-inverse disabled:tw-bg-fill-alt-disabled hover:tw-bg-fill-alt-hover hover:tw-shadow-md", w = "tw-text-default-color tw-bg-fill-accent disabled:tw-bg-fill-accent-disabled hover:tw-bg-fill-accent-hover hover:tw-shadow-md disabled:tw-text-disabled", m = "tw-border tw-border-primary tw-text-primary disabled:tw-border-primary-disabled disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", x = "tw-border tw-text disabled:tw-border-disabled disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", C = "tw-border tw-border-accent tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", T = "tw-border tw-border-inverse-accent tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", L = "tw-text-primary disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", E = "tw-text tw-text-defaut-color disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", z = "tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", j = "tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", X = k(() => [
      n.variant === "primary" && n.color === "default" && v,
      n.variant === "primary" && n.color === "neutral" && y,
      n.variant === "primary" && n.color === "accent" && w,
      n.variant === "outlined" && n.color === "default" && m,
      n.variant === "outlined" && n.color === "neutral" && x,
      n.variant === "outlined" && n.color === "accent" && C,
      n.variant === "outlined" && n.color === "alt-accent" && T,
      n.variant === "transparent" && n.color === "default" && L,
      n.variant === "transparent" && n.color === "neutral" && E,
      n.variant === "transparent" && n.color === "accent" && z,
      n.variant === "transparent" && n.color === "alt-accent" && j
    ].join(" ").replaceAll("false", "")), W = k(() => [
      l.value === "xsmall" && u,
      l.value === "small" && d,
      l.value === "medium" && f,
      l.value === "large" && h
    ].join(" ").replaceAll("false", "")), oe = k(() => n.to || i.href ? r.value : "button"), D = k(() => {
      const p = n.to ?? i.href ?? "";
      return oe.value === "button" ? {
        type: n.type
      } : { href: s(p) ? p : a(p) };
    });
    return (p, b) => (g(), P(at(oe.value), ve({
      class: ["tw-font-base tw-ease-linear tw-inline-block tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus disabled:tw-pointer-events-none", [X.value, W.value]],
      "data-allow-mismatch": "class"
    }, D.value, {
      onClick: b[0] || (b[0] = (S) => o("click"))
    }), {
      default: Y(() => [
        R("span", Nr, [
          p.iconLeftName ? (g(), P(B, {
            key: 0,
            name: p.iconLeftName,
            size: M(c)
          }, null, 8, ["name", "size"])) : A("", !0),
          p.text ? (g(), I("span", $r, Q(p.text), 1)) : A("", !0),
          p.iconRightName ? (g(), P(B, {
            key: 2,
            name: p.iconRightName,
            size: M(c)
          }, null, 8, ["name", "size"])) : A("", !0)
        ])
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
function ne(e, t = {}) {
  return !Lr(e, t);
}
function Lr(e, t = {}) {
  return Dr(e == null ? void 0 : e(t));
}
function Dr(e) {
  return !e || Rr(e).every(
    (t) => {
      var n, o;
      return t.type === Li || t.type === Di && !((n = t.children) != null && n.length) || t.type === et && !((o = t.children) != null && o.length);
    }
  );
}
function Rr(e) {
  return Array.isArray(e) ? e : e !== null ? [e] : [];
}
const Pr = { class: "tw-flex tw-flex-grow tw-flex-col tw-gap-3xs" }, Vr = {
  key: 1,
  class: "tw-flex-grow tw-gap-3xs"
}, Hr = {
  key: 2,
  class: "tw-flex tw-h-xl"
}, Br = /* @__PURE__ */ U({
  __name: "UIBanner",
  props: {
    state: { default: "brand" },
    customIconName: { default: "" },
    isDismissible: { type: Boolean, default: !1 },
    isSplitInTwoLines: { type: Boolean, default: !0 },
    link: { default: "" },
    target: { default: "_blank" },
    ctaText: { default: "" },
    ctaHref: { default: "" },
    ctaTarget: { default: "_blank" }
  },
  emits: ["dismiss", "previous", "next", "click", "ctaClick"],
  setup(e, { emit: t }) {
    const n = t, o = Ue(), i = k(() => ne(o.paginationText)), r = k(() => {
      if (e.customIconName) return e.customIconName;
      const d = {
        success: "mdi:check-circle",
        caution: "mdi:information-slab-circle",
        error: "mdi:alert-circle",
        brand: "groover:logo",
        tip: "mdi:lightbulb-on",
        accent: "groover:groover-plus-logo"
      };
      return d[e.state] || d.brand;
    }), a = k(() => {
      const d = {
        success: "tw-text-icon-success",
        caution: "tw-text-icon-caution",
        error: "tw-text-icon-error",
        brand: "tw-text-icon-brand",
        tip: "tw-text-icon-tip",
        accent: "tw-text-icon-accent"
      };
      return d[e.state] || d.brand;
    }), s = k(() => {
      const d = {
        success: "tw-bg-fill-success tw-border-success",
        caution: "tw-bg-fill-caution tw-border-caution",
        error: "tw-bg-fill-error tw-border-error",
        brand: "tw-bg-fill-brand tw-border-brand",
        tip: "tw-bg-fill-tip tw-border-tip",
        accent: "tw-bg-fill-accent-discrete2 tw-border-inverse-accent"
      };
      return d[e.state] || d.brand;
    }), l = k(() => {
      const d = {
        success: "tw-text-success",
        caution: "tw-text-caution",
        error: "tw-text-error",
        brand: "tw-text-primary",
        tip: "tw-text-black",
        accent: "tw-text-accent"
      };
      return "tw-font-bold " + (d[e.state] || d.brand);
    }), c = k(
      () => e.link ? {
        href: e.link,
        target: e.target,
        rel: "noopener"
      } : {}
    ), u = k(() => {
      const d = {
        success: "neutral",
        caution: "neutral",
        error: "neutral",
        brand: "default",
        tip: "neutral",
        accent: "accent"
      }, f = {
        success: "outlined",
        caution: "outlined",
        error: "outlined",
        brand: "outlined",
        tip: "outlined",
        accent: "primary"
      };
      return {
        color: d[e.state] || d.brand,
        variant: f[e.state] || f.brand,
        text: e.ctaText,
        to: e.ctaHref,
        target: e.ctaHref && e.ctaTarget ? e.ctaTarget : void 0
      };
    });
    return (d, f) => (g(), P(at(d.link ? "a" : "div"), ve(c.value, {
      onClick: f[5] || (f[5] = (h) => n("click", h))
    }), {
      default: Y(() => [
        R("div", {
          role: "note",
          class: F(["tw-text-body-sm tw-flex tw-gap-sm tw-rounded-sm tw-border-2 tw-p-md tw-text-sm tw-leading-sm", s.value])
        }, [
          ae(B, {
            name: r.value,
            class: F(a.value)
          }, null, 8, ["name", "class"]),
          d.isSplitInTwoLines ? (g(), I("div", {
            key: 0,
            class: F(["tw-flex tw-flex-grow tw-flex-col tw-gap-xs", [
              i.value ? "lg:tw-flex-col" : "lg:tw-flex-row lg:tw-items-center"
            ]])
          }, [
            R("div", Pr, [
              M(ne)(o.title) ? (g(), I("p", {
                key: 0,
                class: F(l.value)
              }, [
                H(d.$slots, "title")
              ], 2)) : A("", !0),
              R("p", null, [
                H(d.$slots, "content")
              ])
            ]),
            d.ctaText ? (g(), P(oo, ve({ key: 0 }, u.value, {
              class: "tw-w-fit",
              size: "small",
              onClick: f[0] || (f[0] = (h) => n("ctaClick"))
            }), null, 16)) : A("", !0)
          ], 2)) : (g(), I("div", Vr, [
            R("p", null, [
              M(ne)(o.title) ? (g(), I(et, { key: 0 }, [
                R("span", {
                  class: F(l.value)
                }, [
                  H(d.$slots, "title")
                ], 2),
                f[6] || (f[6] = Co(" "))
              ], 64)) : A("", !0),
              H(d.$slots, "content")
            ]),
            d.ctaText ? (g(), P(oo, ve({ key: 0 }, u.value, {
              class: "tw-mt-xs tw-w-fit",
              size: "small",
              onClick: f[1] || (f[1] = (h) => n("ctaClick"))
            }), null, 16)) : A("", !0)
          ])),
          i.value ? (g(), I("div", Hr, [
            R("button", {
              type: "button",
              "aria-label": "previous-arrow",
              class: "tw-text-icon-discrete",
              onClick: f[2] || (f[2] = Qt((h) => n("previous"), ["stop"]))
            }, [
              ae(B, { name: "mdi:chevron-left" })
            ]),
            H(d.$slots, "paginationText"),
            R("button", {
              type: "button",
              class: "tw-text-icon-discrete",
              "aria-label": "next-arrow",
              onClick: f[3] || (f[3] = Qt((h) => n("next"), ["stop"]))
            }, [
              ae(B, { name: "mdi:chevron-right" })
            ])
          ])) : A("", !0),
          d.isDismissible ? (g(), I("button", {
            key: 3,
            type: "button",
            class: "tw-font-semibold tw-mb-auto tw-ml-auto tw-h-xl tw-cursor-pointer tw-text-sm tw-text-icon-discrete",
            onClick: f[4] || (f[4] = (h) => n("dismiss"))
          }, [
            ae(B, { name: "mdi:close" })
          ])) : A("", !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
}), T0 = /* @__PURE__ */ U({
  __name: "UIBannerMulti",
  props: {
    config: {},
    pageSeparatorText: { default: "-" },
    isDismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Ue(), n = _(0), o = k(() => e.config[n.value]);
    function i() {
      n.value === e.config.length - 1 ? n.value = 0 : n.value++;
    }
    function r() {
      n.value === 0 ? n.value = e.config.length - 1 : n.value--;
    }
    return e.config.length < 1 && console.error("UIBannerMulti requires at least one UIBanner component"), e.config.length !== Object.keys(t).filter((a) => a.startsWith("content")).length && console.error(
      "UIBannerMulti requires the same number of content slots and single UIBanner configs"
    ), (a, s) => (g(), P(Br, ve(o.value, {
      "is-dismissible": a.isDismissible,
      onNext: i,
      onPrevious: r
    }), {
      paginationText: Y(() => [
        Co(Q(n.value + 1) + " " + Q(a.pageSeparatorText) + " " + Q(a.config.length), 1)
      ]),
      title: Y(() => [
        H(a.$slots, `title${n.value + 1}`)
      ]),
      content: Y(() => [
        H(a.$slots, `content${n.value + 1}`)
      ]),
      _: 3
    }, 16, ["is-dismissible"]));
  }
}), jr = { class: "tw-relative" }, Ur = { class: "link-text tw-inline-block tw-w-full tw-transform tw-transition-transform tw-duration-[650ms] tw-ease-smooth" }, Wr = {}, _r = /* @__PURE__ */ U({
  ...Wr,
  __name: "UIButtonLink",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    to: {},
    size: { default: "medium" },
    isExternal: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { linkComponent: n, localePath: o, isExternalLink: i } = An(), r = yn(), { scaledButtonSize: a, scaledIconSize: s } = ai(
      gn(() => t.size)
    ), l = "tw-text-sm tw-leading-sm", c = "tw-text-base tw-leading", u = "tw-text-base tw-leading", d = "tw-text-primary tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary", f = "tw-bg-gradient-to-r tw-from-bg-fill-alt", h = "tw-text-primary-disabled tw-pointer-events-none", v = "tw-text-disabled tw-pointer-events-none", y = k(() => [
      t.color === "default" && d,
      t.color === "neutral" && f,
      r.disabled !== void 0 && t.color === "default" && h,
      r.disabled !== void 0 && t.color === "neutral" && v
    ].join(" ").replaceAll("false", "")), w = k(() => [
      a.value === "small" && l,
      a.value === "medium" && c,
      a.value === "large" && u
    ].join(" ").replaceAll("false", ""));
    return (m, x) => (g(), P(at(M(n)), {
      class: F(["link tw-ease-linear tw-flex tw-w-fit tw-items-center tw-gap-x-2xs tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus", [y.value, w.value]]),
      href: m.isExternal || M(i)(m.to) ? m.to : M(o)(m.to),
      external: m.isExternal === !0 ? !0 : void 0,
      "data-allow-mismatch": "class"
    }, {
      default: Y(() => [
        m.iconLeftName ? (g(), P(B, {
          key: 0,
          name: m.iconLeftName,
          size: M(s)
        }, null, 8, ["name", "size"])) : A("", !0),
        R("span", jr, [
          R("span", Ur, [
            H(m.$slots, "default", {}, void 0, !0)
          ]),
          x[0] || (x[0] = R("span", { class: "link-underline tw-absolute tw-bottom-zero tw-left-zero tw-h-4xs tw-w-full tw-ease-slow-down motion-safe:tw-transform motion-safe:tw-transition-transform motion-safe:tw-duration-[650ms]" }, null, -1))
        ]),
        m.iconRightName ? (g(), P(B, {
          key: 1,
          name: m.iconRightName,
          size: M(s)
        }, null, 8, ["name", "size"])) : A("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "external"]));
  }
}), ri = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, S0 = /* @__PURE__ */ ri(_r, [["__scopeId", "data-v-9063abc5"]]), Kr = {}, I0 = /* @__PURE__ */ U({
  ...Kr,
  __name: "UIChipButton",
  props: {
    text: {},
    iconLeftName: {},
    iconRightName: {},
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, i) => (g(), P(ti, {
      component: "button",
      text: o.text,
      "icon-left-name": o.iconLeftName,
      "icon-right-name": o.iconRightName,
      disabled: o.disabled,
      onClick: i[0] || (i[0] = (r) => n("click"))
    }, null, 8, ["text", "icon-left-name", "icon-right-name", "disabled"]));
  }
}), qr = {}, A0 = /* @__PURE__ */ U({
  ...qr,
  __name: "UIChipSelection",
  props: /* @__PURE__ */ ie({
    text: {},
    disabled: { type: Boolean },
    size: {},
    iconLeftName: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue");
    function i() {
      e.disabled || (o.value = !o.value, n("click"));
    }
    return (r, a) => (g(), P(ti, {
      modelValue: o.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => o.value = s),
      component: "input",
      text: r.text,
      "icon-left-name": r.iconLeftName,
      "icon-right-name": o.value ? "mdi:check" : "mdi:plus",
      disabled: r.disabled,
      size: r.size,
      color: o.value ? "alt" : "dashed",
      onClick: i
    }, null, 8, ["modelValue", "text", "icon-left-name", "icon-right-name", "disabled", "size", "color"]));
  }
}), Gr = ["top", "right", "bottom", "left"], He = Math.min, Se = Math.max, kt = Math.round, pt = Math.floor, we = (e) => ({
  x: e,
  y: e
}), Qr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Yr = {
  start: "end",
  end: "start"
};
function un(e, t, n) {
  return Se(e, He(t, n));
}
function We(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ee(e) {
  return e.split("-")[0];
}
function st(e) {
  return e.split("-")[1];
}
function li(e) {
  return e === "x" ? "y" : "x";
}
function zn(e) {
  return e === "y" ? "height" : "width";
}
function Be(e) {
  return ["top", "bottom"].includes(Ee(e)) ? "y" : "x";
}
function Fn(e) {
  return li(Be(e));
}
function Xr(e, t, n) {
  n === void 0 && (n = !1);
  const o = st(e), i = Fn(e), r = zn(i);
  let a = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (a = Tt(a)), [a, Tt(a)];
}
function Zr(e) {
  const t = Tt(e);
  return [dn(e), t, dn(t)];
}
function dn(e) {
  return e.replace(/start|end/g, (t) => Yr[t]);
}
function Jr(e, t, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : o : t ? o : i;
    case "left":
    case "right":
      return t ? r : a;
    default:
      return [];
  }
}
function el(e, t, n, o) {
  const i = st(e);
  let r = Jr(Ee(e), n === "start", o);
  return i && (r = r.map((a) => a + "-" + i), t && (r = r.concat(r.map(dn)))), r;
}
function Tt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Qr[t]);
}
function tl(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function si(e) {
  return typeof e != "number" ? tl(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function St(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function io(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const r = Be(t), a = Fn(t), s = zn(a), l = Ee(t), c = r === "y", u = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, f = o[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: o.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (st(t)) {
    case "start":
      h[a] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[a] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const nl = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: a
  } = n, s = r.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: d
  } = io(c, o, l), f = o, h = {}, v = 0;
  for (let y = 0; y < s.length; y++) {
    const {
      name: w,
      fn: m
    } = s[y], {
      x,
      y: C,
      data: T,
      reset: L
    } = await m({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = x ?? u, d = C ?? d, h = {
      ...h,
      [w]: {
        ...h[w],
        ...T
      }
    }, L && v <= 50 && (v++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (c = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : L.rects), {
      x: u,
      y: d
    } = io(c, f, l)), y = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function It(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = We(t, e), v = si(h), w = s[f ? d === "floating" ? "reference" : "floating" : d], m = St(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(w))) == null || n ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: o,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), T = await (r.isElement == null ? void 0 : r.isElement(C)) ? await (r.getScale == null ? void 0 : r.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, L = St(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: x,
    offsetParent: C,
    strategy: l
  }) : x);
  return {
    top: (m.top - L.top + v.top) / T.y,
    bottom: (L.bottom - m.bottom + v.bottom) / T.y,
    left: (m.left - L.left + v.left) / T.x,
    right: (L.right - m.right + v.right) / T.x
  };
}
const ol = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = We(e, t) || {};
    if (c == null)
      return {};
    const d = si(u), f = {
      x: n,
      y: o
    }, h = Fn(i), v = zn(h), y = await a.getDimensions(c), w = h === "y", m = w ? "top" : "left", x = w ? "bottom" : "right", C = w ? "clientHeight" : "clientWidth", T = r.reference[v] + r.reference[h] - f[h] - r.floating[v], L = f[h] - r.reference[h], E = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let z = E ? E[C] : 0;
    (!z || !await (a.isElement == null ? void 0 : a.isElement(E))) && (z = s.floating[C] || r.floating[v]);
    const j = T / 2 - L / 2, X = z / 2 - y[v] / 2 - 1, W = He(d[m], X), oe = He(d[x], X), D = W, p = z - y[v] - oe, b = z / 2 - y[v] / 2 + j, S = un(D, b, p), $ = !l.arrow && st(i) != null && b !== S && r.reference[v] / 2 - (b < D ? W : oe) - y[v] / 2 < 0, O = $ ? b < D ? b - D : b - p : 0;
    return {
      [h]: f[h] + O,
      data: {
        [h]: S,
        centerOffset: b - S - O,
        ...$ && {
          alignmentOffset: O
        }
      },
      reset: $
    };
  }
}), il = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: y = !0,
        ...w
      } = We(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const m = Ee(i), x = Be(s), C = Ee(s) === s, T = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), L = f || (C || !y ? [Tt(s)] : Zr(s)), E = v !== "none";
      !f && E && L.push(...el(s, y, v, T));
      const z = [s, ...L], j = await It(t, w), X = [];
      let W = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (u && X.push(j[m]), d) {
        const b = Xr(i, a, T);
        X.push(j[b[0]], j[b[1]]);
      }
      if (W = [...W, {
        placement: i,
        overflows: X
      }], !X.every((b) => b <= 0)) {
        var oe, D;
        const b = (((oe = r.flip) == null ? void 0 : oe.index) || 0) + 1, S = z[b];
        if (S)
          return {
            data: {
              index: b,
              overflows: W
            },
            reset: {
              placement: S
            }
          };
        let $ = (D = W.filter((O) => O.overflows[0] <= 0).sort((O, V) => O.overflows[1] - V.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var p;
              const O = (p = W.filter((V) => {
                if (E) {
                  const N = Be(V.placement);
                  return N === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((N) => N > 0).reduce((N, K) => N + K, 0)]).sort((V, N) => V[1] - N[1])[0]) == null ? void 0 : p[0];
              O && ($ = O);
              break;
            }
            case "initialPlacement":
              $ = s;
              break;
          }
        if (i !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function ao(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ro(e) {
  return Gr.some((t) => e[t] >= 0);
}
const al = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = We(e, t);
      switch (o) {
        case "referenceHidden": {
          const r = await It(t, {
            ...i,
            elementContext: "reference"
          }), a = ao(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: ro(a)
            }
          };
        }
        case "escaped": {
          const r = await It(t, {
            ...i,
            altBoundary: !0
          }), a = ao(r, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: ro(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function rl(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), a = Ee(n), s = st(n), l = Be(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, u = r && l ? -1 : 1, d = We(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof v == "number" && (h = s === "end" ? v * -1 : v), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const ll = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: a,
        middlewareData: s
      } = t, l = await rl(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: i + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, sl = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i
      } = t, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: m,
              y: x
            } = w;
            return {
              x: m,
              y: x
            };
          }
        },
        ...l
      } = We(e, t), c = {
        x: n,
        y: o
      }, u = await It(t, l), d = Be(Ee(i)), f = li(d);
      let h = c[f], v = c[d];
      if (r) {
        const w = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", x = h + u[w], C = h - u[m];
        h = un(x, h, C);
      }
      if (a) {
        const w = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", x = v + u[w], C = v - u[m];
        v = un(x, v, C);
      }
      const y = s.fn({
        ...t,
        [f]: h,
        [d]: v
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o,
          enabled: {
            [f]: r,
            [d]: a
          }
        }
      };
    }
  };
};
function Ot() {
  return typeof window < "u";
}
function Ne(e) {
  return Nn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function re(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function he(e) {
  var t;
  return (t = (Nn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Nn(e) {
  return Ot() ? e instanceof Node || e instanceof re(e).Node : !1;
}
function se(e) {
  return Ot() ? e instanceof Element || e instanceof re(e).Element : !1;
}
function de(e) {
  return Ot() ? e instanceof HTMLElement || e instanceof re(e).HTMLElement : !1;
}
function lo(e) {
  return !Ot() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof re(e).ShadowRoot;
}
function ct(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(i);
}
function cl(e) {
  return ["table", "td", "th"].includes(Ne(e));
}
function Lt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function $n(e) {
  const t = On(), n = se(e) ? ce(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function ul(e) {
  let t = ge(e);
  for (; de(t) && !je(t); ) {
    if ($n(t))
      return t;
    if (Lt(t))
      return null;
    t = ge(t);
  }
  return null;
}
function On() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function je(e) {
  return ["html", "body", "#document"].includes(Ne(e));
}
function ce(e) {
  return re(e).getComputedStyle(e);
}
function Dt(e) {
  return se(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ge(e) {
  if (Ne(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    lo(e) && e.host || // Fallback.
    he(e)
  );
  return lo(t) ? t.host : t;
}
function ci(e) {
  const t = ge(e);
  return je(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : de(t) && ct(t) ? t : ci(t);
}
function it(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = ci(e), r = i === ((o = e.ownerDocument) == null ? void 0 : o.body), a = re(i);
  if (r) {
    const s = fn(a);
    return t.concat(a, a.visualViewport || [], ct(i) ? i : [], s && n ? it(s) : []);
  }
  return t.concat(i, it(i, [], n));
}
function fn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ui(e) {
  const t = ce(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = de(e), r = i ? e.offsetWidth : n, a = i ? e.offsetHeight : o, s = kt(n) !== r || kt(o) !== a;
  return s && (n = r, o = a), {
    width: n,
    height: o,
    $: s
  };
}
function Ln(e) {
  return se(e) ? e : e.contextElement;
}
function Ve(e) {
  const t = Ln(e);
  if (!de(t))
    return we(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = ui(t);
  let a = (r ? kt(n.width) : n.width) / o, s = (r ? kt(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const dl = /* @__PURE__ */ we(0);
function di(e) {
  const t = re(e);
  return !On() || !t.visualViewport ? dl : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function fl(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== re(e) ? !1 : t;
}
function Me(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), r = Ln(e);
  let a = we(1);
  t && (o ? se(o) && (a = Ve(o)) : a = Ve(e));
  const s = fl(r, n, o) ? di(r) : we(0);
  let l = (i.left + s.x) / a.x, c = (i.top + s.y) / a.y, u = i.width / a.x, d = i.height / a.y;
  if (r) {
    const f = re(r), h = o && se(o) ? re(o) : o;
    let v = f, y = fn(v);
    for (; y && o && h !== v; ) {
      const w = Ve(y), m = y.getBoundingClientRect(), x = ce(y), C = m.left + (y.clientLeft + parseFloat(x.paddingLeft)) * w.x, T = m.top + (y.clientTop + parseFloat(x.paddingTop)) * w.y;
      l *= w.x, c *= w.y, u *= w.x, d *= w.y, l += C, c += T, v = re(y), y = fn(v);
    }
  }
  return St({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function hl(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const r = i === "fixed", a = he(o), s = t ? Lt(t.floating) : !1;
  if (o === a || s && r)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = we(1);
  const u = we(0), d = de(o);
  if ((d || !d && !r) && ((Ne(o) !== "body" || ct(a)) && (l = Dt(o)), de(o))) {
    const f = Me(o);
    c = Ve(o), u.x = f.x + o.clientLeft, u.y = f.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function ml(e) {
  return Array.from(e.getClientRects());
}
function hn(e, t) {
  const n = Dt(e).scrollLeft;
  return t ? t.left + n : Me(he(e)).left + n;
}
function pl(e) {
  const t = he(e), n = Dt(e), o = e.ownerDocument.body, i = Se(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = Se(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -n.scrollLeft + hn(e);
  const s = -n.scrollTop;
  return ce(o).direction === "rtl" && (a += Se(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: a,
    y: s
  };
}
function vl(e, t) {
  const n = re(e), o = he(e), i = n.visualViewport;
  let r = o.clientWidth, a = o.clientHeight, s = 0, l = 0;
  if (i) {
    r = i.width, a = i.height;
    const c = On();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: s,
    y: l
  };
}
function bl(e, t) {
  const n = Me(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, r = de(e) ? Ve(e) : we(1), a = e.clientWidth * r.x, s = e.clientHeight * r.y, l = i * r.x, c = o * r.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function so(e, t, n) {
  let o;
  if (t === "viewport")
    o = vl(e, n);
  else if (t === "document")
    o = pl(he(e));
  else if (se(t))
    o = bl(t, n);
  else {
    const i = di(e);
    o = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return St(o);
}
function fi(e, t) {
  const n = ge(e);
  return n === t || !se(n) || je(n) ? !1 : ce(n).position === "fixed" || fi(n, t);
}
function wl(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = it(e, [], !1).filter((s) => se(s) && Ne(s) !== "body"), i = null;
  const r = ce(e).position === "fixed";
  let a = r ? ge(e) : e;
  for (; se(a) && !je(a); ) {
    const s = ce(a), l = $n(a);
    !l && s.position === "fixed" && (i = null), (r ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ct(a) && !l && fi(e, a)) ? o = o.filter((u) => u !== a) : i = s, a = ge(a);
  }
  return t.set(e, o), o;
}
function gl(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? Lt(t) ? [] : wl(t, this._c) : [].concat(n), o], s = a[0], l = a.reduce((c, u) => {
    const d = so(t, u, i);
    return c.top = Se(d.top, c.top), c.right = He(d.right, c.right), c.bottom = He(d.bottom, c.bottom), c.left = Se(d.left, c.left), c;
  }, so(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function yl(e) {
  const {
    width: t,
    height: n
  } = ui(e);
  return {
    width: t,
    height: n
  };
}
function xl(e, t, n) {
  const o = de(t), i = he(t), r = n === "fixed", a = Me(e, !0, r, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = we(0);
  if (o || !o && !r)
    if ((Ne(t) !== "body" || ct(i)) && (s = Dt(t)), o) {
      const h = Me(t, !0, r, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else i && (l.x = hn(i));
  let c = 0, u = 0;
  if (i && !o && !r) {
    const h = i.getBoundingClientRect();
    u = h.top + s.scrollTop, c = h.left + s.scrollLeft - // RTL <body> scrollbar.
    hn(i, h);
  }
  const d = a.left + s.scrollLeft - l.x - c, f = a.top + s.scrollTop - l.y - u;
  return {
    x: d,
    y: f,
    width: a.width,
    height: a.height
  };
}
function _t(e) {
  return ce(e).position === "static";
}
function co(e, t) {
  if (!de(e) || ce(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return he(e) === n && (n = n.ownerDocument.body), n;
}
function hi(e, t) {
  const n = re(e);
  if (Lt(e))
    return n;
  if (!de(e)) {
    let i = ge(e);
    for (; i && !je(i); ) {
      if (se(i) && !_t(i))
        return i;
      i = ge(i);
    }
    return n;
  }
  let o = co(e, t);
  for (; o && cl(o) && _t(o); )
    o = co(o, t);
  return o && je(o) && _t(o) && !$n(o) ? n : o || ul(e) || n;
}
const Cl = async function(e) {
  const t = this.getOffsetParent || hi, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: xl(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function kl(e) {
  return ce(e).direction === "rtl";
}
const Tl = {
  convertOffsetParentRelativeRectToViewportRelativeRect: hl,
  getDocumentElement: he,
  getClippingRect: gl,
  getOffsetParent: hi,
  getElementRects: Cl,
  getClientRects: ml,
  getDimensions: yl,
  getScale: Ve,
  isElement: se,
  isRTL: kl
};
function Sl(e, t) {
  let n = null, o;
  const i = he(e);
  function r() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), r();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !d || !f)
      return;
    const h = pt(u), v = pt(i.clientWidth - (c + d)), y = pt(i.clientHeight - (u + f)), w = pt(c), x = {
      rootMargin: -h + "px " + -v + "px " + -y + "px " + -w + "px",
      threshold: Se(0, He(1, l)) || 1
    };
    let C = !0;
    function T(L) {
      const E = L[0].intersectionRatio;
      if (E !== l) {
        if (!C)
          return a();
        E ? a(!1, E) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, x);
    }
    n.observe(e);
  }
  return a(!0), r;
}
function Il(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = Ln(e), u = i || r ? [...c ? it(c) : [], ...it(t)] : [];
  u.forEach((m) => {
    i && m.addEventListener("scroll", n, {
      passive: !0
    }), r && m.addEventListener("resize", n);
  });
  const d = c && s ? Sl(c, n) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((m) => {
    let [x] = m;
    x && x.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = h) == null || C.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let v, y = l ? Me(e) : null;
  l && w();
  function w() {
    const m = Me(e);
    y && (m.x !== y.x || m.y !== y.y || m.width !== y.width || m.height !== y.height) && n(), y = m, v = requestAnimationFrame(w);
  }
  return n(), () => {
    var m;
    u.forEach((x) => {
      i && x.removeEventListener("scroll", n), r && x.removeEventListener("resize", n);
    }), d == null || d(), (m = h) == null || m.disconnect(), h = null, l && cancelAnimationFrame(v);
  };
}
const Al = ll, El = sl, Ml = il, zl = al, Fl = ol, Nl = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: Tl,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return nl(e, t, {
    ...i,
    platform: r
  });
};
function $l(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function mn(e) {
  if ($l(e)) {
    const t = e.$el;
    return Nn(t) && Ne(t) === "#comment" ? null : t;
  }
  return e;
}
function Le(e) {
  return typeof e == "function" ? e() : M(e);
}
function Ol(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = mn(Le(e.element));
      return n == null ? {} : Fl({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function mi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uo(e, t) {
  const n = mi(e);
  return Math.round(t * n) / n;
}
function Ll(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = k(() => {
    var z;
    return (z = Le(n.open)) != null ? z : !0;
  }), r = k(() => Le(n.middleware)), a = k(() => {
    var z;
    return (z = Le(n.placement)) != null ? z : "bottom";
  }), s = k(() => {
    var z;
    return (z = Le(n.strategy)) != null ? z : "absolute";
  }), l = k(() => {
    var z;
    return (z = Le(n.transform)) != null ? z : !0;
  }), c = k(() => mn(e.value)), u = k(() => mn(t.value)), d = _(0), f = _(0), h = _(s.value), v = _(a.value), y = Ie({}), w = _(!1), m = k(() => {
    const z = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return z;
    const j = uo(u.value, d.value), X = uo(u.value, f.value);
    return l.value ? {
      ...z,
      transform: "translate(" + j + "px, " + X + "px)",
      ...mi(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: j + "px",
      top: X + "px"
    };
  });
  let x;
  function C() {
    if (c.value == null || u.value == null)
      return;
    const z = i.value;
    Nl(c.value, u.value, {
      middleware: r.value,
      placement: a.value,
      strategy: s.value
    }).then((j) => {
      d.value = j.x, f.value = j.y, h.value = j.strategy, v.value = j.placement, y.value = j.middlewareData, w.value = z !== !1;
    });
  }
  function T() {
    typeof x == "function" && (x(), x = void 0);
  }
  function L() {
    if (T(), o === void 0) {
      C();
      return;
    }
    if (c.value != null && u.value != null) {
      x = o(c.value, u.value, C);
      return;
    }
  }
  function E() {
    i.value || (w.value = !1);
  }
  return le([r, a, s, i], C, {
    flush: "sync"
  }), le([c, u], L, {
    flush: "sync"
  }), le(i, E, {
    flush: "sync"
  }), go() && yo(T), {
    x: $e(d),
    y: $e(f),
    strategy: $e(h),
    placement: $e(v),
    middlewareData: $e(y),
    isPositioned: $e(w),
    floatingStyles: m,
    update: C
  };
}
const pi = En ? window : void 0;
function Ye(e) {
  var t;
  const n = q(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function De(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, o = (s, l, c, u) => (s.addEventListener(l, c, u), () => s.removeEventListener(l, c, u)), i = k(() => {
    const s = Te(q(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), r = oi(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((c) => Ye(c))) != null ? l : [pi].filter((c) => c != null),
        Te(q(i.value ? e[1] : e[0])),
        Te(M(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        q(i.value ? e[3] : e[2])
      ];
    },
    ([s, l, c, u]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const d = ni(u) ? { ...u } : u;
      t.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => c.map((v) => o(f, h, v, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), n();
  };
  return $t(n), a;
}
let fo = !1;
function ho(e, t, n = {}) {
  const { window: o = pi, ignore: i = [], capture: r = !0, detectIframe: a = !1, controls: s = !1 } = n;
  if (!o)
    return s ? { stop: xe, cancel: xe, trigger: xe } : xe;
  if (sn && !fo) {
    fo = !0;
    const w = { passive: !0 };
    Array.from(o.document.body.children).forEach((m) => De(m, "click", xe, w)), De(o.document.documentElement, "click", xe, w);
  }
  let l = !0;
  const c = (w) => q(i).some((m) => {
    if (typeof m == "string")
      return Array.from(o.document.querySelectorAll(m)).some((x) => x === w.target || w.composedPath().includes(x));
    {
      const x = Ye(m);
      return x && (w.target === x || w.composedPath().includes(x));
    }
  });
  function u(w) {
    const m = q(w);
    return m && m.$.subTree.shapeFlag === 16;
  }
  function d(w, m) {
    const x = q(w), C = x.$.subTree && x.$.subTree.children;
    return C == null || !Array.isArray(C) ? !1 : C.some((T) => T.el === m.target || m.composedPath().includes(T.el));
  }
  const f = (w) => {
    const m = Ye(e);
    if (w.target != null && !(!(m instanceof Element) && u(e) && d(e, w)) && !(!m || m === w.target || w.composedPath().includes(m))) {
      if ("detail" in w && w.detail === 0 && (l = !c(w)), !l) {
        l = !0;
        return;
      }
      t(w);
    }
  };
  let h = !1;
  const v = [
    De(o, "click", (w) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), f(w));
    }, { passive: !0, capture: r }),
    De(o, "pointerdown", (w) => {
      const m = Ye(e);
      l = !c(w) && !!(m && !w.composedPath().includes(m));
    }, { passive: !0 }),
    a && De(o, "blur", (w) => {
      setTimeout(() => {
        var m;
        const x = Ye(e);
        ((m = o.document.activeElement) == null ? void 0 : m.tagName) === "IFRAME" && !(x != null && x.contains(o.document.activeElement)) && t(w);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), y = () => v.forEach((w) => w());
  return s ? {
    stop: y,
    cancel: () => {
      l = !1;
    },
    trigger: (w) => {
      l = !0, f(w), l = !1;
    }
  } : y;
}
const Dl = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = ho(e, t.value, { capture: n });
    else {
      const [o, i] = t.value;
      e.__onClickOutside_stop = ho(e, o, Object.assign({ capture: n }, i));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function Kt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function vi(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : vi(n);
  }
}
function Rl(e) {
  const t = e || window.event, n = t.target;
  return vi(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const qt = /* @__PURE__ */ new WeakMap();
function Pl(e, t = !1) {
  const n = _(t);
  let o = null, i = "";
  le(Cr(e), (s) => {
    const l = Kt(q(s));
    if (l) {
      const c = l;
      if (qt.get(c) || qt.set(c, c.style.overflow), c.style.overflow !== "hidden" && (i = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const s = Kt(q(e));
    !s || n.value || (sn && (o = De(
      s,
      "touchmove",
      (l) => {
        Rl(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", n.value = !0);
  }, a = () => {
    const s = Kt(q(e));
    !s || !n.value || (sn && (o == null || o()), s.style.overflow = i, qt.delete(s), n.value = !1);
  };
  return $t(a), k({
    get() {
      return n.value;
    },
    set(s) {
      s ? r() : a();
    }
  });
}
function Vl() {
  let e = !1;
  const t = Ie(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const i = Pl(n, o.value);
    le(t, (r) => i.value = r);
  };
}
Vl();
const Hl = { class: "tw-w-fit" }, Bl = {
  ref: "referenceEl",
  class: "tw-w-fit"
}, jl = {}, bi = /* @__PURE__ */ U({
  ...jl,
  __name: "BaseFloating",
  props: {
    forceShowFloatingEl: { type: Boolean, default: void 0 },
    hasArrow: { type: Boolean, default: !1 },
    isStatic: { type: Boolean, default: !1 },
    offset: { default: 8 },
    placement: { default: "bottom-start" }
  },
  emits: ["click-outside", "show-floating", "hide-floating"],
  setup(e, { emit: t }) {
    const n = e, o = t, [i, r] = Tr(!1), a = Re("referenceEl"), s = Re("floatingEl"), l = Re("floatingArrowEl"), c = 8, u = n.isStatic ? [] : [
      Ml({ padding: c }),
      El({ padding: c })
    ], d = [
      Al(n.offset),
      ...u,
      Ol({
        element: l,
        // the distance in px the arrow can show up against the side of the floating element itself.
        // Use to avoid overlapping rounded corners
        padding: 8
      }),
      zl()
    ], {
      floatingStyles: f,
      middlewareData: h,
      placement: v
    } = Ll(a, s, {
      middleware: d,
      /**
       * Update the floating element's position when the reference element's size or scroll position changes.
       *
       * @param referenceEl - The reference element.
       * @param floatingEl - The floating element.
       * @param update - The update function.
       * @returns - The cleanup function.
       */
      whileElementsMounted(m, x, C) {
        return Il(m, x, C, {
          ancestorScroll: !0,
          elementResize: !0
        });
      },
      placement: n.placement,
      strategy: "fixed"
    }), y = k(() => {
      var E;
      const { x: m, y: x } = ((E = h.value) == null ? void 0 : E.arrow) ?? {}, C = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[v.value.split("-")[0]], L = typeof n.offset == "number" ? n.offset : 8;
      return {
        left: m != null ? `${m}px` : "",
        top: x != null ? `${x}px` : "",
        right: "",
        bottom: "",
        [C]: `-${L / 2}px`
      };
    });
    le(i, (m) => {
      o(m ? "show-floating" : "hide-floating");
    }), le(
      () => n.forceShowFloatingEl,
      (m) => {
        m !== void 0 && r(m);
      },
      { immediate: !0 }
    );
    function w() {
      o("click-outside"), n.forceShowFloatingEl !== !0 && r(!1);
    }
    return (m, x) => Ae((g(), I("div", Hl, [
      R("div", Bl, [
        H(m.$slots, "reference", {
          isFloatingElDisplayed: M(i),
          toggleContentDisplay: M(r)
        })
      ], 512),
      ae(ko, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: Y(() => {
          var C;
          return [
            M(i) ? (g(), I("div", {
              key: 0,
              ref: "floatingEl",
              style: Rn({
                ...M(f),
                visibility: (C = M(h).hide) != null && C.referenceHidden ? "hidden" : "visible"
              }),
              class: "tw-z-[999999]"
            }, [
              m.hasArrow ? (g(), I("span", {
                key: 0,
                ref: "floatingArrowEl",
                "data-testid": "floating-arrow",
                class: "tw-absolute tw-size-sm tw-rotate-45 tw-transform tw-bg-fill-alt",
                style: Rn(y.value)
              }, null, 4)) : A("", !0),
              H(m.$slots, "floating", { toggleContentDisplay: M(r) })
            ], 4)) : A("", !0)
          ];
        }),
        _: 3
      })
    ])), [
      [M(Dl), w]
    ]);
  }
}), Ul = ["aria-controlledby", "onMouseleave", "onClick"], Wl = {}, E0 = /* @__PURE__ */ U({
  ...Wl,
  __name: "UIDropdownMenu",
  props: {
    displayMenuOnHover: { type: Boolean, default: !1 },
    hideDelay: { default: 500 },
    referenceComponent: {},
    referenceComponentAttrs: { default: () => ({}) }
  },
  setup(e) {
    const t = e, n = Ue(), o = _(), i = Fe();
    function r(l) {
      t.displayMenuOnHover && (clearTimeout(o.value), o.value = setTimeout(() => l(!1), t.hideDelay));
    }
    function a() {
      clearTimeout(o.value);
    }
    function s(l) {
      t.displayMenuOnHover && (clearTimeout(o.value), l(!0));
    }
    return ne(n.menuLists) || console.error('UIDropdownMenu requires a slot named "menuLists"'), (l, c) => (g(), P(bi, null, {
      reference: Y(({ toggleContentDisplay: u, isFloatingElDisplayed: d }) => [
        l.referenceComponent ? (g(), P(at(l.referenceComponent), ve({ key: 0 }, l.referenceComponentAttrs, {
          id: M(i),
          "aria-expanded": d,
          onClick: (f) => u(),
          onMouseover: (f) => s(u),
          onMouseleave: (f) => r(u)
        }), {
          default: Y(() => [
            H(l.$slots, "referenceText")
          ]),
          _: 2
        }, 1040, ["id", "aria-expanded", "onClick", "onMouseover", "onMouseleave"])) : A("", !0)
      ]),
      floating: Y(({ toggleContentDisplay: u }) => [
        M(ne)(n.menuLists) ? (g(), I("div", {
          key: 0,
          class: "tw-flex tw-min-w-[160px] tw-flex-col tw-gap-y-3xs tw-rounded-lg tw-bg-surface tw-p-2xs tw-shadow-lg",
          "aria-controlledby": M(i),
          onMouseover: a,
          onMouseleave: (d) => r(u),
          onClick: (d) => u(!1)
        }, [
          H(l.$slots, "menuLists")
        ], 40, Ul)) : A("", !0)
      ]),
      _: 3
    }));
  }
}), _l = {
  key: 0,
  class: "tw-text-body tw-rounded tw-px-md tw-py-sm tw-text-discrete"
}, Kl = {}, M0 = /* @__PURE__ */ U({
  ...Kl,
  __name: "UIDropdownMenuList",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, n) => (g(), I("ul", null, [
      t.title ? (g(), I("li", _l, Q(t.title), 1)) : A("", !0),
      H(t.$slots, "default")
    ]));
  }
}), ql = { class: "tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-y-3xs" }, Gl = { class: "tw-text-body" }, Ql = {
  key: 0,
  class: "tw-text-body-xs tw-text-discrete"
}, Yl = {
  key: 1,
  class: "tw-text-body tw-text-discrete"
}, Xl = {}, z0 = /* @__PURE__ */ U({
  ...Xl,
  inheritAttrs: !1,
  __name: "UIDropdownMenuListItem",
  props: {
    href: { default: "" },
    isActive: { type: Boolean, default: !1 },
    leftIconName: { default: "" },
    rightIconName: { default: "" },
    rightSideText: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    text: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = yn(), { linkComponent: r } = An(), a = k(() => n.href || i.to ? r.value : "button"), s = k(() => n.href || i.to ? {
      href: n.href || i.to,
      "aria-current": n.isActive ? "page" : void 0,
      ...i
    } : {
      type: "button",
      "aria-checked": n.isActive ? n.isActive : void 0,
      ...i
    });
    return (l, c) => (g(), I("li", null, [
      (g(), P(at(a.value), ve(s.value, {
        class: ["tw-flex tw-w-full tw-min-w-[160px] tw-items-center tw-gap-x-md tw-rounded tw-px-md hover:tw-bg-surface-hover", [
          {
            "tw-bg-fill-discrete3": l.isActive
          },
          l.size === "lg" ? "tw-py-md" : "tw-py-sm"
        ]],
        onClick: c[0] || (c[0] = (u) => o("click"))
      }), {
        default: Y(() => [
          l.leftIconName ? (g(), P(B, {
            key: 0,
            name: l.leftIconName,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])) : A("", !0),
          R("span", ql, [
            R("span", Gl, Q(l.text), 1),
            l.subText ? (g(), I("span", Ql, Q(l.subText), 1)) : A("", !0)
          ]),
          l.rightSideText ? (g(), I("span", Yl, Q(l.rightSideText), 1)) : A("", !0),
          l.rightIconName && l.isActive ? (g(), P(B, {
            key: 2,
            name: l.rightIconName,
            class: "tw-text-icon"
          }, null, 8, ["name"])) : A("", !0)
        ]),
        _: 1
      }, 16, ["class"]))
    ]));
  }
}), Zl = ["id", "name", "checked", "disabled", "valid", "readonly"], Jl = ["for"], es = {}, ts = /* @__PURE__ */ U({
  ...es,
  __name: "UIInputCheckbox",
  props: /* @__PURE__ */ ie({
    isDisabled: { type: Boolean, default: !1 },
    isIndeterminate: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Fe(), n = fe(e, "modelValue");
    return (o, i) => (g(), I("span", {
      class: F(["tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-md", {
        "tw-pointer-events-none": o.isDisabled
      }])
    }, [
      R("span", {
        class: F(["tw-relative tw-flex tw-h-xl tw-w-xl tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-discrete2 tw-bg-surface hover:tw-border-default-color disabled:tw-pointer-events-none", {
          "!tw-border-default-color !tw-bg-fill-alt": n.value && !o.isDisabled,
          "tw-border-2 !tw-border-error": o.hasError && !o.isDisabled,
          "!tw-bg-fill-error": o.hasError && !n.value && !o.isDisabled,
          "!tw-border-disabled !tw-bg-fill-alt-disabled": o.isDisabled
        }])
      }, [
        Ae(R("input", {
          id: M(t),
          "onUpdate:modelValue": i[0] || (i[0] = (r) => n.value = r),
          type: "checkbox",
          name: M(t),
          checked: n.value,
          disabled: o.isDisabled,
          valid: o.hasError ? !1 : void 0,
          readonly: o.isDisabled,
          class: "tw-absolute tw-flex tw-h-full tw-w-full tw-appearance-none tw-rounded focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus"
        }, null, 8, Zl), [
          [To, n.value]
        ]),
        n.value ? (g(), P(B, {
          key: 0,
          name: o.isIndeterminate ? "material-symbols:remove" : "material-symbols:check",
          size: "sm",
          class: F(["tw-text-inverse", {
            "!tw-text-disabled": o.isDisabled
          }])
        }, null, 8, ["name", "class"])) : A("", !0)
      ], 2),
      M(ne)(o.$slots.label) ? (g(), I("label", {
        key: 0,
        for: M(t),
        class: "tw-flex-1 tw-items-center tw-justify-center"
      }, [
        H(o.$slots, "label")
      ], 8, Jl)) : A("", !0)
    ], 2));
  }
}), ns = ["for"], os = {
  key: 0,
  class: "tw-ml-sm tw-font-normal tw-text-discrete2"
}, is = {}, wi = /* @__PURE__ */ U({
  ...is,
  __name: "UIInputLabel",
  props: {
    htmlFor: {},
    optionalText: { default: "" }
  },
  setup(e) {
    return (t, n) => (g(), I("label", {
      for: t.htmlFor,
      class: "tw-block tw-text-base tw-font-bold"
    }, [
      H(t.$slots, "default"),
      t.optionalText ? (g(), I("span", os, Q(t.optionalText), 1)) : A("", !0)
    ], 8, ns));
  }
}), as = ["id", "type", "placeholder", "name", "disabled"], rs = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, ls = {}, gi = /* @__PURE__ */ U({
  ...ls,
  __name: "BaseInput",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    iconLeftName: { default: null },
    type: { default: "text" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, i = Fe(), r = fe(e, "modelValue"), a = k(() => [
      n.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      n.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled",
      n.inputSize === "large" ? "tw-h-5xl tw-py-md" : "tw-h-4xl tw-py-sm"
    ].join(" ").replaceAll("false", "")), s = k(() => r.value && n.type === "password" ? "tw-text-success" : "tw-text-discrete2");
    return (l, c) => (g(), I("div", null, [
      M(ne)(l.$slots.label) ? (g(), P(wi, {
        key: 0,
        "optional-text": l.optionalLabelText,
        "html-for": M(i),
        class: "tw-mb-2xs"
      }, {
        default: Y(() => [
          H(l.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"])) : A("", !0),
      R("div", {
        class: F(["tw-bg tw-relative tw-flex tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-px-md focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", a.value])
      }, [
        l.iconLeftName ? (g(), P(B, {
          key: 0,
          name: l.iconLeftName,
          size: "lg",
          class: "tw-text-icon-discrete2"
        }, null, 8, ["name"])) : A("", !0),
        Ae(R("input", {
          id: M(i),
          "onUpdate:modelValue": c[0] || (c[0] = (u) => r.value = u),
          type: l.type,
          placeholder: l.placeholder,
          name: l.name,
          disabled: l.isDisabled,
          class: "tw-h-2xl tw-w-full tw-rounded tw-bg-transparent tw-outline-none placeholder:tw-text-discrete2",
          onFocus: c[1] || (c[1] = (u) => o("focus")),
          onBlur: c[2] || (c[2] = (u) => o("blur"))
        }, null, 40, as), [
          [So, r.value]
        ]),
        H(l.$slots, "icon-button-right")
      ], 2),
      l.errorText ? (g(), I("span", rs, Q(l.errorText), 1)) : l.helperText ? (g(), I("span", {
        key: 2,
        class: F(["tw-mt-2xs tw-inline-block tw-text-sm", s.value])
      }, Q(l.helperText), 3)) : A("", !0)
    ]));
  }
}), ss = ["aria-label"], cs = {}, F0 = /* @__PURE__ */ U({
  ...cs,
  __name: "UIInputPassword",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: { default: "password" },
    placeholder: { default: "" },
    toggleVisibilityAriaText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = _("material-symbols:visibility-outline"), o = _("password");
    function i() {
      o.value === "password" ? (n.value = "material-symbols:visibility-off-outline", o.value = "text") : (n.value = "material-symbols:visibility-outline", o.value = "password");
    }
    return (r, a) => (g(), P(gi, {
      modelValue: t.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => t.value = s),
      "icon-left-name": "material-symbols:lock-outline",
      type: o.value,
      placeholder: r.placeholder,
      name: r.name,
      "helper-text": r.helperText,
      "error-text": r.errorText,
      "input-size": r.inputSize,
      "is-disabled": r.isDisabled
    }, Io({
      "icon-button-right": Y(() => [
        R("button", {
          class: "tw-h-xl",
          type: "button",
          "aria-label": r.toggleVisibilityAriaText,
          onClick: i
        }, [
          ae(B, {
            name: n.value,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])
        ], 8, ss)
      ]),
      _: 2
    }, [
      M(ne)(r.$slots.label) ? {
        name: "label",
        fn: Y(() => [
          H(r.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "is-disabled"]));
  }
}), us = ["aria-label"], ds = {}, N0 = /* @__PURE__ */ U({
  ...ds,
  __name: "UIInputText",
  props: /* @__PURE__ */ ie({
    clearInputAriaText: { default: "" },
    errorText: { default: "" },
    helperText: { default: "" },
    iconLeftName: { default: null },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    isIconRightVisible: { type: Boolean, default: !0 },
    isValidating: { type: Boolean, default: !1 },
    name: {},
    optionalLabelText: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = fe(e, "modelValue"), o = _(!1), i = _(!1), r = k(() => o.value || i.value), a = k(() => !!(t.isIconRightVisible && r.value && n.value && s.value !== "eos-icons:loading" || t.errorText && !t.isValidating)), s = k(() => t.isValidating ? "eos-icons:loading" : t.errorText || a.value ? "mdi:close" : n.value && !t.errorText ? "material-symbols:check" : ""), l = k(() => n.value && !t.errorText && !a.value && !t.isValidating ? "tw-text-icon-success" : "tw-text-icon-discrete2"), c = k(() => t.isIconRightVisible && !a.value && s.value);
    le(s, () => {
    });
    function u() {
      n.value = "";
    }
    function d() {
      setTimeout(() => {
        o.value = !1;
      }, 10);
    }
    return (f, h) => (g(), P(gi, {
      ref: "input",
      modelValue: n.value,
      "onUpdate:modelValue": h[2] || (h[2] = (v) => n.value = v),
      "icon-left-name": f.iconLeftName,
      type: f.type,
      placeholder: f.placeholder,
      name: f.name,
      "helper-text": f.helperText,
      "error-text": f.errorText,
      "input-size": f.inputSize,
      "optional-label-text": f.optionalLabelText,
      "is-disabled": f.isDisabled,
      onFocus: h[3] || (h[3] = (v) => o.value = !0),
      onBlur: d
    }, Io({
      "icon-button-right": Y(() => [
        a.value && !f.isDisabled ? (g(), I("button", {
          key: 0,
          type: "button",
          class: "tw-h-xl",
          "aria-label": f.clearInputAriaText,
          onClick: u,
          onFocus: h[0] || (h[0] = (v) => i.value = !0),
          onBlur: h[1] || (h[1] = (v) => i.value = !1)
        }, [
          ae(B, {
            name: s.value,
            class: F(l.value)
          }, null, 8, ["name", "class"])
        ], 40, us)) : c.value && !f.isDisabled ? (g(), P(B, {
          key: 1,
          name: s.value,
          class: F(l.value)
        }, null, 8, ["name", "class"])) : A("", !0)
      ]),
      _: 2
    }, [
      M(ne)(f.$slots.label) ? {
        name: "label",
        fn: Y(() => [
          H(f.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "icon-left-name", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "optional-label-text", "is-disabled"]));
  }
}), fs = {
  key: 0,
  class: "tw-mb-2xl tw-mt-sm"
}, hs = ["id", "placeholder", "name", "disabled"], ms = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, ps = {
  key: 2,
  class: "tw-mt-2xs tw-inline-block tw-text-sm tw-text-discrete2"
}, $0 = /* @__PURE__ */ U({
  __name: "UIInputTextarea",
  props: /* @__PURE__ */ ie({
    errorText: { default: "" },
    helperText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = Fe(), o = fe(e, "modelValue"), i = k(() => [
      t.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      t.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled"
    ].join(" ").replaceAll("false", ""));
    return (r, a) => (g(), I("div", null, [
      ae(wi, {
        "optional-text": r.optionalLabelText,
        "html-for": M(n)
      }, {
        default: Y(() => [
          H(r.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"]),
      M(ne)(r.$slots.tip) ? (g(), I("div", fs, [
        H(r.$slots, "tip")
      ])) : A("", !0),
      Ae(R("textarea", {
        id: M(n),
        "onUpdate:modelValue": a[0] || (a[0] = (s) => o.value = s),
        class: F(["tw-text-body tw-relative tw-flex tw-max-h-[50vh] tw-min-h-[88px] tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-bg-transparent tw-p-md placeholder:tw-text-discrete2 focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", i.value]),
        placeholder: r.placeholder,
        name: r.name,
        disabled: r.isDisabled
      }, null, 10, hs), [
        [So, o.value]
      ]),
      r.errorText ? (g(), I("span", ms, Q(r.errorText), 1)) : r.helperText ? (g(), I("span", ps, Q(r.helperText), 1)) : A("", !0)
    ]));
  }
}), vs = ["id", "name", "checked", "disabled", "readonly", "valid"], bs = {}, O0 = /* @__PURE__ */ U({
  ...bs,
  __name: "UIInputToggleCheckbox",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconName: { default: "mdi:check" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = Fe(), o = k(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), i = k(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), r = k(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), a = k(() => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? t.value ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-hover" : t.value ? "tw-bg-surface hover:tw-bg-surface-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-alt-hover"), s = k(() => e.theme === "light" ? e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-surface" : e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-fill-alt"), l = k(() => e.disabled ? "tw-text-icon-disabled" : e.theme === "light" ? "tw-text-icon" : "tw-text-icon-inverse");
    return (c, u) => (g(), I("label", {
      class: F(["tw-relative tw-inline-flex tw-items-center", [
        c.disabled ? "tw-pointer-events-none tw-cursor-not-allowed" : "tw-cursor-pointer"
      ]])
    }, [
      Ae(R("input", {
        id: M(n),
        "onUpdate:modelValue": u[0] || (u[0] = (d) => t.value = d),
        type: "checkbox",
        name: M(n),
        class: "tw-sr-only tw-appearance-none",
        checked: t.value,
        disabled: c.disabled,
        readonly: c.disabled,
        valid: c.hasError ? !1 : void 0
      }, null, 8, vs), [
        [To, t.value]
      ]),
      R("div", {
        class: F(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [a.value]: !0,
          [o.value]: !0,
          "tw-border-2 tw-border-error": c.hasError && !c.disabled
        }])
      }, [
        R("div", {
          class: F(["tw-rounded-full tw-transition-all tw-duration-200", {
            [s.value]: !t.value,
            [r.value]: !0
          }])
        }, null, 2),
        R("div", {
          class: F(["tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            [s.value]: t.value,
            [i.value]: !0,
            [r.value]: !0
          }])
        }, [
          Ae(ae(B, {
            name: c.iconName,
            size: c.size,
            class: F(l.value)
          }, null, 8, ["name", "size", "class"]), [
            [Ao, t.value]
          ])
        ], 2)
      ], 2)
    ], 2));
  }
}), ws = { class: "tw-inline-flex tw-items-center" }, gs = ["aria-invalid"], ys = ["for", "aria-label"], xs = ["id", "readonly", "checked", "value", "disabled", "valid", "onClick"], L0 = /* @__PURE__ */ U({
  __name: "UIInputToggleRadio",
  props: /* @__PURE__ */ ie({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 },
    options: {}
  }, {
    modelValue: void 0,
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ie(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(
      e,
      "modelValue",
      void 0
    ), i = Fe(), r = k(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), a = k(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), s = k(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), l = k(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-surface hover:tw-bg-surface-hover"
    ), c = k(
      () => e.size === "sm" ? "tw-text-body-sm tw-px-2xs tw-gap-x-2xs" : e.size === "lg" ? "tw-text-body-lg tw-px-sm tw-gap-x-sm" : "tw-text-body tw-px-xs tw-gap-x-xs"
    ), u = k(
      () => e.disabled ? "tw-bg-fill-alt-disabled" : e.theme === "light" ? "tw-bg-surface tw-text-icon" : "tw-bg-fill-alt tw-text-icon-inverse"
    ), d = k(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "dark" ? "tw-text-icon" : "tw-text-icon-inverse"
    ), f = k(
      () => e.theme === "light" ? "tw-text-icon-discrete2" : "tw-text-icon-disabled"
    );
    function h(y) {
      return o.value === y;
    }
    function v(y, w) {
      e.disabled || w || h(y) || (o.value = y, n("update:modelValue", y));
    }
    return (y, w) => (g(), I("div", ws, [
      R("div", {
        class: F(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [l.value]: !0,
          [r.value]: !0,
          "tw-border-2 tw-border-error": y.hasError && !y.disabled
        }]),
        role: "radiogroup",
        "aria-invalid": y.hasError
      }, [
        (g(!0), I(et, null, Yt(y.options, ({
          value: m,
          label: x,
          iconName: C,
          disabled: T = !1
        }) => (g(), I("label", {
          key: `${M(i)}-${m}`,
          class: F(["tw-flex tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            "tw-cursor-pointer": !y.disabled && !T,
            "tw-cursor-not-allowed": y.disabled || T,
            [r.value]: !0,
            [s.value]: !0,
            [a.value]: !0,
            [u.value]: h(m),
            [d.value]: !h(m) && !T,
            [f.value]: T || y.disabled
          }]),
          for: `${M(i)}-${m}`,
          "aria-label": x
        }, [
          R("input", {
            id: `${M(i)}-${m}`,
            readonly: y.disabled || T,
            type: "radio",
            class: "tw-sr-only tw-appearance-none",
            checked: h(m),
            value: m,
            disabled: y.disabled || T,
            valid: y.hasError ? !1 : void 0,
            onClick: (L) => v(m, T)
          }, null, 8, xs),
          R("div", {
            class: F(["tw-flex tw-items-center", [c.value]])
          }, [
            C ? (g(), P(B, {
              key: 0,
              name: C,
              size: y.size
            }, null, 8, ["name", "size"])) : A("", !0),
            R("span", null, Q(x), 1)
          ], 2)
        ], 10, ys))), 128))
      ], 10, gs)
    ]));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var yi = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], At = /* @__PURE__ */ yi.join(","), xi = typeof Element > "u", ze = xi ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Et = !xi && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Mt = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), r = i === "" || i === "true", a = r || n && t && e(t.parentNode);
  return a;
}, Cs = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, Ci = function(t, n, o) {
  if (Mt(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(At));
  return n && ze.call(t, At) && i.unshift(t), i = i.filter(o), i;
}, ki = function e(t, n, o) {
  for (var i = [], r = Array.from(t); r.length; ) {
    var a = r.shift();
    if (!Mt(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = e(l, !0, o);
        o.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var u = ze.call(a, At);
        u && o.filter(a) && (n || !t.includes(a)) && i.push(a);
        var d = a.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(a), f = !Mt(d, !1) && (!o.shadowRootFilter || o.shadowRootFilter(a));
        if (d && f) {
          var h = e(d === !0 ? a.children : d.children, !0, o);
          o.flatten ? i.push.apply(i, h) : i.push({
            scopeParent: a,
            candidates: h
          });
        } else
          r.unshift.apply(r, a.children);
      }
  }
  return i;
}, Ti = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Ce = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Cs(t)) && !Ti(t) ? 0 : t.tabIndex;
}, ks = function(t, n) {
  var o = Ce(t);
  return o < 0 && n && !Ti(t) ? 0 : o;
}, Ts = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Si = function(t) {
  return t.tagName === "INPUT";
}, Ss = function(t) {
  return Si(t) && t.type === "hidden";
}, Is = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, As = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, Es = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Et(t), o = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = o(window.CSS.escape(t.name));
  else
    try {
      i = o(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var r = As(i, t.form);
  return !r || r === t;
}, Ms = function(t) {
  return Si(t) && t.type === "radio";
}, zs = function(t) {
  return Ms(t) && !Es(t);
}, Fs = function(t) {
  var n, o = t && Et(t), i = (n = o) === null || n === void 0 ? void 0 : n.host, r = !1;
  if (o && o !== t) {
    var a, s, l;
    for (r = !!((a = i) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !r && i; ) {
      var c, u, d;
      o = Et(i), i = (c = o) === null || c === void 0 ? void 0 : c.host, r = !!((u = i) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return r;
}, mo = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, i = n.height;
  return o === 0 && i === 0;
}, Ns = function(t, n) {
  var o = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var r = ze.call(t, "details>summary:first-of-type"), a = r ? t.parentElement : t;
  if (ze.call(a, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = Et(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return mo(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (Fs(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return mo(t);
  return !1;
}, $s = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var i = n.children.item(o);
          if (i.tagName === "LEGEND")
            return ze.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, zt = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Mt(n) || Ss(n) || Ns(n, t) || // For a details element with a summary, the summary element gets the focus
  Is(n) || $s(n));
}, pn = function(t, n) {
  return !(zs(n) || Ce(n) < 0 || !zt(t, n));
}, Os = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ls = function e(t) {
  var n = [], o = [];
  return t.forEach(function(i, r) {
    var a = !!i.scopeParent, s = a ? i.scopeParent : i, l = ks(s, a), c = a ? e(i.candidates) : s;
    l === 0 ? a ? n.push.apply(n, c) : n.push(s) : o.push({
      documentOrder: r,
      tabIndex: l,
      item: i,
      isScope: a,
      content: c
    });
  }), o.sort(Ts).reduce(function(i, r) {
    return r.isScope ? i.push.apply(i, r.content) : i.push(r.content), i;
  }, []).concat(n);
}, Ds = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ki([t], n.includeContainer, {
    filter: pn.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Os
  }) : o = Ci(t, n.includeContainer, pn.bind(null, n)), Ls(o);
}, Rs = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = ki([t], n.includeContainer, {
    filter: zt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = Ci(t, n.includeContainer, zt.bind(null, n)), o;
}, Oe = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ze.call(t, At) === !1 ? !1 : pn(n, t);
}, Ps = /* @__PURE__ */ yi.concat("iframe").join(","), Gt = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ze.call(t, Ps) === !1 ? !1 : zt(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function vn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Vs(e) {
  if (Array.isArray(e)) return vn(e);
}
function Hs(e, t, n) {
  return (t = _s(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Bs(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function js() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function po(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? po(Object(n), !0).forEach(function(o) {
      Hs(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : po(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Us(e) {
  return Vs(e) || Bs(e) || Ks(e) || js();
}
function Ws(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _s(e) {
  var t = Ws(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ks(e, t) {
  if (e) {
    if (typeof e == "string") return vn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? vn(e, t) : void 0;
  }
}
var bo = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, qs = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Gs = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Je = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, Qs = function(t) {
  return Je(t) && !t.shiftKey;
}, Ys = function(t) {
  return Je(t) && t.shiftKey;
}, wo = function(t) {
  return setTimeout(t, 0);
}, Ge = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, vt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Xs = [], Zs = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || Xs, r = vo({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Qs,
    isKeyBackward: Ys
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(p, b, S) {
    return p && p[b] !== void 0 ? p[b] : r[S || b];
  }, c = function(p, b) {
    var S = typeof (b == null ? void 0 : b.composedPath) == "function" ? b.composedPath() : void 0;
    return a.containerGroups.findIndex(function($) {
      var O = $.container, V = $.tabbableNodes;
      return O.contains(p) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (S == null ? void 0 : S.includes(O)) || V.find(function(N) {
        return N === p;
      });
    });
  }, u = function(p) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, S = b.hasFallback, $ = S === void 0 ? !1 : S, O = b.params, V = O === void 0 ? [] : O, N = r[p];
    if (typeof N == "function" && (N = N.apply(void 0, Us(V))), N === !0 && (N = void 0), !N) {
      if (N === void 0 || N === !1)
        return N;
      throw new Error("`".concat(p, "` was specified but was not a node, or did not return a node"));
    }
    var K = N;
    if (typeof N == "string") {
      try {
        K = o.querySelector(N);
      } catch (Z) {
        throw new Error("`".concat(p, '` appears to be an invalid selector; error="').concat(Z.message, '"'));
      }
      if (!K && !$)
        throw new Error("`".concat(p, "` as selector refers to no known node"));
    }
    return K;
  }, d = function() {
    var p = u("initialFocus", {
      hasFallback: !0
    });
    if (p === !1)
      return !1;
    if (p === void 0 || p && !Gt(p, r.tabbableOptions))
      if (c(o.activeElement) >= 0)
        p = o.activeElement;
      else {
        var b = a.tabbableGroups[0], S = b && b.firstTabbableNode;
        p = S || u("fallbackFocus");
      }
    else p === null && (p = u("fallbackFocus"));
    if (!p)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return p;
  }, f = function() {
    if (a.containerGroups = a.containers.map(function(p) {
      var b = Ds(p, r.tabbableOptions), S = Rs(p, r.tabbableOptions), $ = b.length > 0 ? b[0] : void 0, O = b.length > 0 ? b[b.length - 1] : void 0, V = S.find(function(Z) {
        return Oe(Z);
      }), N = S.slice().reverse().find(function(Z) {
        return Oe(Z);
      }), K = !!b.find(function(Z) {
        return Ce(Z) > 0;
      });
      return {
        container: p,
        tabbableNodes: b,
        focusableNodes: S,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: K,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: $,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: O,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: V,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: N,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ye) {
          var _e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, me = b.indexOf(ye);
          return me < 0 ? _e ? S.slice(S.indexOf(ye) + 1).find(function(Ke) {
            return Oe(Ke);
          }) : S.slice(0, S.indexOf(ye)).reverse().find(function(Ke) {
            return Oe(Ke);
          }) : b[me + (_e ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(p) {
      return p.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(p) {
      return p.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(p) {
    var b = p.activeElement;
    if (b)
      return b.shadowRoot && b.shadowRoot.activeElement !== null ? h(b.shadowRoot) : b;
  }, v = function(p) {
    if (p !== !1 && p !== h(document)) {
      if (!p || !p.focus) {
        v(d());
        return;
      }
      p.focus({
        preventScroll: !!r.preventScroll
      }), a.mostRecentlyFocusedNode = p, qs(p) && p.select();
    }
  }, y = function(p) {
    var b = u("setReturnFocus", {
      params: [p]
    });
    return b || (b === !1 ? !1 : p);
  }, w = function(p) {
    var b = p.target, S = p.event, $ = p.isBackward, O = $ === void 0 ? !1 : $;
    b = b || vt(S), f();
    var V = null;
    if (a.tabbableGroups.length > 0) {
      var N = c(b, S), K = N >= 0 ? a.containerGroups[N] : void 0;
      if (N < 0)
        O ? V = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : V = a.tabbableGroups[0].firstTabbableNode;
      else if (O) {
        var Z = a.tabbableGroups.findIndex(function(Rt) {
          var Pt = Rt.firstTabbableNode;
          return b === Pt;
        });
        if (Z < 0 && (K.container === b || Gt(b, r.tabbableOptions) && !Oe(b, r.tabbableOptions) && !K.nextTabbableNode(b, !1)) && (Z = N), Z >= 0) {
          var ye = Z === 0 ? a.tabbableGroups.length - 1 : Z - 1, _e = a.tabbableGroups[ye];
          V = Ce(b) >= 0 ? _e.lastTabbableNode : _e.lastDomTabbableNode;
        } else Je(S) || (V = K.nextTabbableNode(b, !1));
      } else {
        var me = a.tabbableGroups.findIndex(function(Rt) {
          var Pt = Rt.lastTabbableNode;
          return b === Pt;
        });
        if (me < 0 && (K.container === b || Gt(b, r.tabbableOptions) && !Oe(b, r.tabbableOptions) && !K.nextTabbableNode(b)) && (me = N), me >= 0) {
          var Ke = me === a.tabbableGroups.length - 1 ? 0 : me + 1, Dn = a.tabbableGroups[Ke];
          V = Ce(b) >= 0 ? Dn.firstTabbableNode : Dn.firstDomTabbableNode;
        } else Je(S) || (V = K.nextTabbableNode(b));
      }
    } else
      V = u("fallbackFocus");
    return V;
  }, m = function(p) {
    var b = vt(p);
    if (!(c(b, p) >= 0)) {
      if (Ge(r.clickOutsideDeactivates, p)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: r.returnFocusOnDeactivate
        });
        return;
      }
      Ge(r.allowOutsideClick, p) || p.preventDefault();
    }
  }, x = function(p) {
    var b = vt(p), S = c(b, p) >= 0;
    if (S || b instanceof Document)
      S && (a.mostRecentlyFocusedNode = b);
    else {
      p.stopImmediatePropagation();
      var $, O = !0;
      if (a.mostRecentlyFocusedNode)
        if (Ce(a.mostRecentlyFocusedNode) > 0) {
          var V = c(a.mostRecentlyFocusedNode), N = a.containerGroups[V].tabbableNodes;
          if (N.length > 0) {
            var K = N.findIndex(function(Z) {
              return Z === a.mostRecentlyFocusedNode;
            });
            K >= 0 && (r.isKeyForward(a.recentNavEvent) ? K + 1 < N.length && ($ = N[K + 1], O = !1) : K - 1 >= 0 && ($ = N[K - 1], O = !1));
          }
        } else
          a.containerGroups.some(function(Z) {
            return Z.tabbableNodes.some(function(ye) {
              return Ce(ye) > 0;
            });
          }) || (O = !1);
      else
        O = !1;
      O && ($ = w({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: r.isKeyBackward(a.recentNavEvent)
      })), v($ || a.mostRecentlyFocusedNode || d());
    }
    a.recentNavEvent = void 0;
  }, C = function(p) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = p;
    var S = w({
      event: p,
      isBackward: b
    });
    S && (Je(p) && p.preventDefault(), v(S));
  }, T = function(p) {
    (r.isKeyForward(p) || r.isKeyBackward(p)) && C(p, r.isKeyBackward(p));
  }, L = function(p) {
    Gs(p) && Ge(r.escapeDeactivates, p) !== !1 && (p.preventDefault(), s.deactivate());
  }, E = function(p) {
    var b = vt(p);
    c(b, p) >= 0 || Ge(r.clickOutsideDeactivates, p) || Ge(r.allowOutsideClick, p) || (p.preventDefault(), p.stopImmediatePropagation());
  }, z = function() {
    if (a.active)
      return bo.activateTrap(i, s), a.delayInitialFocusTimer = r.delayInitialFocus ? wo(function() {
        v(d());
      }) : v(d()), o.addEventListener("focusin", x, !0), o.addEventListener("mousedown", m, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", m, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", E, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", L), s;
  }, j = function() {
    if (a.active)
      return o.removeEventListener("focusin", x, !0), o.removeEventListener("mousedown", m, !0), o.removeEventListener("touchstart", m, !0), o.removeEventListener("click", E, !0), o.removeEventListener("keydown", T, !0), o.removeEventListener("keydown", L), s;
  }, X = function(p) {
    var b = p.some(function(S) {
      var $ = Array.from(S.removedNodes);
      return $.some(function(O) {
        return O === a.mostRecentlyFocusedNode;
      });
    });
    b && v(d());
  }, W = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(X) : void 0, oe = function() {
    W && (W.disconnect(), a.active && !a.paused && a.containers.map(function(p) {
      W.observe(p, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(p) {
      if (a.active)
        return this;
      var b = l(p, "onActivate"), S = l(p, "onPostActivate"), $ = l(p, "checkCanFocusTrap");
      $ || f(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = o.activeElement, b == null || b();
      var O = function() {
        $ && f(), z(), oe(), S == null || S();
      };
      return $ ? ($(a.containers.concat()).then(O, O), this) : (O(), this);
    },
    deactivate: function(p) {
      if (!a.active)
        return this;
      var b = vo({
        onDeactivate: r.onDeactivate,
        onPostDeactivate: r.onPostDeactivate,
        checkCanReturnFocus: r.checkCanReturnFocus
      }, p);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, j(), a.active = !1, a.paused = !1, oe(), bo.deactivateTrap(i, s);
      var S = l(b, "onDeactivate"), $ = l(b, "onPostDeactivate"), O = l(b, "checkCanReturnFocus"), V = l(b, "returnFocus", "returnFocusOnDeactivate");
      S == null || S();
      var N = function() {
        wo(function() {
          V && v(y(a.nodeFocusedBeforeActivation)), $ == null || $();
        });
      };
      return V && O ? (O(y(a.nodeFocusedBeforeActivation)).then(N, N), this) : (N(), this);
    },
    pause: function(p) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, p)) : this;
    },
    unpause: function(p) {
      return a.active ? (a.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, p)) : this;
    },
    updateContainerElements: function(p) {
      var b = [].concat(p).filter(Boolean);
      return a.containers = b.map(function(S) {
        return typeof S == "string" ? o.querySelector(S) : S;
      }), a.active && f(), oe(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(p, b) {
        if (a.paused === p)
          return this;
        if (a.paused = p, p) {
          var S = l(b, "onPause"), $ = l(b, "onPostPause");
          S == null || S(), j(), oe(), $ == null || $();
        } else {
          var O = l(b, "onUnpause"), V = l(b, "onPostUnpause");
          O == null || O(), f(), z(), oe(), V == null || V();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function Js(e, t = {}) {
  let n;
  const { immediate: o, ...i } = t, r = Ie(!1), a = Ie(!1), s = (f) => n && n.activate(f), l = (f) => n && n.deactivate(f), c = () => {
    n && (n.pause(), a.value = !0);
  }, u = () => {
    n && (n.unpause(), a.value = !1);
  }, d = k(() => {
    const f = q(e);
    return Te(f).map((h) => {
      const v = q(h);
      return typeof v == "string" ? v : ii(v);
    }).filter(wr);
  });
  return le(
    d,
    (f) => {
      f.length && (n = Zs(f, {
        ...i,
        onActivate() {
          r.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          r.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && s());
    },
    { flush: "post" }
  ), $t(() => l()), {
    hasFocus: r,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: c,
    unpause: u
  };
}
const e0 = {
  key: 0,
  class: "tw-fixed tw-bottom-zero tw-left-zero tw-right-zero tw-top-zero tw-z-[999999] tw-flex tw-h-full tw-items-end tw-bg-fill-alt tw-bg-opacity-70 md:tw-items-center md:tw-justify-center"
}, t0 = {
  key: 1,
  id: "modalTitle"
}, n0 = { key: 3 }, o0 = {
  key: 0,
  id: "modalContent",
  class: "tw-overflow-y-auto tw-p-lg"
}, i0 = {
  key: 1,
  class: "tw-w-full tw-p-lg"
}, a0 = {}, D0 = /* @__PURE__ */ U({
  ...a0,
  __name: "UIModal",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    isDismissable: { type: Boolean, default: !0 },
    size: { default: "base" }
  },
  emits: ["close", "previous"],
  setup(e, { emit: t }) {
    const n = t, o = Ue(), i = Re("modal"), { activate: r, deactivate: a } = Js(i, { immediate: !0 }), s = _(!1);
    bn(() => {
      s.value = !0, r(), l();
    }), Ri(() => {
      s.value = !1, a(), c();
    });
    function l() {
      document && document.body && (document.body.style.overflow = "hidden");
    }
    function c() {
      document && document.body && (document.body.style.overflow = "auto");
    }
    return (u, d) => (g(), P(Pi, { to: "body" }, [
      ae(ko, {
        name: "fade",
        mode: "out-in"
      }, {
        default: Y(() => [
          s.value ? (g(), I("div", e0, [
            R("article", {
              ref: "modal",
              "aria-modal": "",
              role: "dialog",
              "aria-labelledby": "modalTitle",
              "aria-describedby": "modalContent",
              class: F(["tw-flex tw-max-h-[90%] tw-w-full tw-flex-col tw-rounded-t-xl tw-bg-surface tw-p-sm md:tw-rounded-md", {
                "md:tw-w-[400px]": u.size === "sm",
                "md:tw-w-[640px]": u.size === "base",
                "md:tw-w-[800px]": u.size === "lg",
                "md:tw-w-[1024px]": u.size === "xl"
              }]),
              onKeydown: d[2] || (d[2] = gt((f) => u.isDismissable && n("close"), ["escape"]))
            }, [
              R("div", {
                class: F(["tw-p-lg", {
                  "tw-flex tw-items-center tw-justify-between": u.hasBackButton || u.isDismissable,
                  "tw-text-center md:tw-text-left": !u.hasBackButton && !u.isDismissable
                }])
              }, [
                u.hasBackButton ? (g(), I("button", {
                  key: 0,
                  type: "button",
                  class: "tw-flex tw-size-2xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: d[0] || (d[0] = (f) => n("previous"))
                }, [
                  ae(B, {
                    name: "famicons:chevron-back-sharp",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : A("", !0),
                M(ne)(o.title) ? (g(), I("header", t0, [
                  H(u.$slots, "title")
                ])) : A("", !0),
                u.isDismissable ? (g(), I("button", {
                  key: 2,
                  type: "button",
                  class: "tw-flex tw-size-xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: d[1] || (d[1] = (f) => n("close"))
                }, [
                  ae(B, {
                    name: "material-symbols:close",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : (g(), I("span", n0))
              ], 2),
              M(ne)(o.content) ? (g(), I("section", o0, [
                H(u.$slots, "content")
              ])) : A("", !0),
              M(ne)(o.cta) ? (g(), I("footer", i0, [
                H(u.$slots, "cta")
              ])) : A("", !0)
            ], 34)
          ])) : A("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), r0 = /* @__PURE__ */ U({
  __name: "UITag",
  props: {
    color: { default: "default" },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e;
    t.variant === "transparent" && t.color === "alt" && console.error("Variant `transparent` cannot be used with color `alt`");
    const n = k(() => t.variant === "transparent" ? { "tw-bg-fill-transparent": t.variant === "transparent" } : {
      "tw-bg-fill-discrete3": t.color === "default" || t.color === "disabled",
      "tw-bg-fill-primary-discrete2": t.color === "primary",
      "tw-bg-fill-alt": t.color === "alt",
      "tw-bg-fill-success": t.color === "success",
      "tw-bg-fill-caution": t.color === "warning",
      "tw-bg-fill-error": t.color === "error",
      "tw-bg-fill-accent-discrete": t.color === "accent"
    }), o = k(() => ({
      "tw-p-2xs": t.size === "base",
      "tw-py-3xs tw-px-2xs": t.size === "sm"
    })), i = k(() => [
      {
        // color
        "tw-text-discrete": t.color === "default",
        "tw-text-discrete3": t.color === "disabled",
        "tw-text-primary": t.color === "primary",
        "tw-text-inverse": t.color === "alt",
        "tw-text-success": t.color === "success",
        "tw-text-caution": t.color === "warning",
        "tw-text-error": t.color === "error",
        "tw-text-accent": t.color === "accent",
        // size
        "tw-text-body-xs": t.size === "sm",
        "tw-text-body-sm": t.size === "base"
      }
    ]), r = k(() => ({
      "tw-text-icon-discrete": t.color === "default",
      "tw-text-icon-discrete3": t.color === "disabled",
      "tw-text-icon-primary": t.color === "primary",
      "tw-text-icon-inverse": t.color === "alt",
      "tw-text-icon-success": t.color === "success",
      "tw-text-icon-caution": t.color === "warning",
      "tw-text-icon-error": t.color === "error",
      "tw-text-icon-accent": t.color === "accent"
    }));
    return (a, s) => (g(), I("span", {
      class: F(["tw-flex tw-w-fit tw-items-center tw-rounded-lg", [n.value, o.value]])
    }, [
      a.iconLeftName ? (g(), P(B, {
        key: 0,
        name: a.iconLeftName,
        size: "sm",
        class: F(r.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      a.text ? (g(), I("span", {
        key: 1,
        class: F(["tw-px-3xs", i.value])
      }, Q(a.text), 3)) : A("", !0),
      a.iconRightName ? (g(), P(B, {
        key: 2,
        name: a.iconRightName,
        size: "sm",
        class: F(r.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 2));
  }
}), l0 = { class: "tw-flex tw-w-full tw-items-center tw-gap-x-md" }, s0 = { class: "tw-flex tw-flex-1 tw-items-center tw-gap-x-2xs" }, c0 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-y-3xs" }, u0 = {
  key: 0,
  class: "tw-text-body tw-font-medium"
}, d0 = {}, R0 = /* @__PURE__ */ U({
  ...d0,
  __name: "UISelectionCard",
  props: /* @__PURE__ */ ie({
    displayCheckbox: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    iconName: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    tagText: { default: "" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue");
    return (n, o) => (g(), I("label", {
      class: F(["tw-flex tw-w-full tw-min-w-[176px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-md tw-rounded-lg tw-border tw-border-discrete2 tw-bg-surface focus-within:tw-outline hover:tw-bg-fill-hover", [
        {
          "!tw-border-default tw-shadow-[inset_0px_0px_0px_1px] tw-shadow-text-default-color": t.value && !n.isDisabled,
          "tw-pointer-events-none tw-text-discrete3": n.isDisabled,
          "!tw-border-error": n.hasError
        },
        n.size === "sm" ? "tw-p-sm tw-pl-md" : "tw-p-lg"
      ]])
    }, [
      R("span", l0, [
        ae(ts, {
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
          "has-error": n.hasError,
          "is-disabled": n.isDisabled,
          class: F(["tw-pointer-events-none", {
            "tw-sr-only": !n.displayCheckbox
          }])
        }, null, 8, ["modelValue", "has-error", "is-disabled", "class"]),
        R("span", s0, [
          R("span", c0, [
            n.text ? (g(), I("span", u0, Q(n.text), 1)) : A("", !0),
            n.subText ? (g(), I("span", {
              key: 1,
              class: F(n.text ? "tw-text-body-sm" : "tw-text-body")
            }, Q(n.subText), 3)) : A("", !0)
          ]),
          n.tagText ? (g(), P(r0, {
            key: 0,
            text: n.tagText,
            color: n.isDisabled ? "disabled" : "default",
            class: F({
              "!tw-bg-fill-discrete2": t.value
            })
          }, null, 8, ["text", "color", "class"])) : A("", !0)
        ]),
        n.iconName ? (g(), P(B, {
          key: 0,
          name: n.iconName,
          size: n.size === "sm" ? "xl" : "2xl",
          class: "tw-text-icon"
        }, null, 8, ["name", "size"])) : A("", !0)
      ])
    ], 2));
  }
}), f0 = { class: "tabs" }, h0 = {
  role: "tablist",
  class: "tw-flex tw-gap-x-2xl"
}, m0 = ["aria-selected", "aria-controls", "disabled", "tabindex", "onClick", "onKeydown"], p0 = ["id", "aria-labelledby"], v0 = {}, P0 = /* @__PURE__ */ U({
  ...v0,
  __name: "UITab",
  props: {
    tabsTitles: {},
    disabledTabsTitles: { default: () => [] },
    isTextColorInverse: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = Ue(), i = t, r = _(0), a = Re("tabRefs"), s = Object.keys(o), l = k(() => n.tabsTitles.map((d, f) => s.includes(`tab-${f}`) ? f : null).filter((d) => d !== null));
    function c(d) {
      n.disabledTabsTitles.includes(n.tabsTitles[d]) || (r.value = d, i("click"));
    }
    function u(d, f) {
      var h, v;
      if (a.value) {
        if (f.key === "ArrowRight") {
          const y = d === n.tabsTitles.length - 1 ? d : d + 1;
          (h = a.value[y]) == null || h.focus();
        } else if (f.key === "ArrowLeft") {
          const y = d === 0 ? d : d - 1;
          (v = a.value[y]) == null || v.focus();
        }
      }
    }
    return (d, f) => (g(), I("div", f0, [
      R("div", h0, [
        (g(!0), I(et, null, Yt(d.tabsTitles, (h, v) => (g(), I("button", {
          key: h,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: a,
          role: "tab",
          "aria-selected": r.value === v,
          "aria-controls": `tab-${v}`,
          disabled: d.disabledTabsTitles.includes(h),
          tabindex: r.value === v ? 0 : -1,
          class: F(["tw-border-b-4 tw-border-b-transparent tw-pb-sm tw-font-bold", {
            "!tw-border-b-primary": r.value === v,
            "tw-text-inverse": d.isTextColorInverse,
            "!tw-text-discrete3": d.disabledTabsTitles.includes(h),
            "hover:!tw-border-b-discrete3": !d.disabledTabsTitles.includes(h)
          }]),
          onClick: (y) => c(v),
          onKeydown: (y) => u(v, y)
        }, Q(h), 43, m0))), 128))
      ]),
      (g(!0), I(et, null, Yt(l.value, (h) => Ae((g(), I("section", {
        id: `tab-${h}`,
        key: h,
        role: "tabpanel",
        "aria-labelledby": d.tabsTitles[h]
      }, [
        H(d.$slots, `tab-${h}`)
      ], 8, p0)), [
        [Ao, r.value === h]
      ])), 128))
    ]));
  }
}), b0 = ["aria-controlledby", "onMouseleave", "onKeydown"], w0 = {}, g0 = /* @__PURE__ */ U({
  ...w0,
  __name: "UITooltip",
  props: {
    forceHidden: { type: Boolean, default: !1 },
    forceShown: { type: Boolean, default: !1 },
    hideArrow: { type: Boolean, default: !1 },
    hideDelay: { default: 0 },
    placement: { default: "bottom" },
    showWhenClicked: { type: Boolean, default: !1 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = Ue(), r = _(), a = Fe(), s = `${a}-tooltip-content`, l = Re("tooltipContentRef"), c = _(!1), u = k(() => c.value ? "" : n.placement.includes("top") ? "emptyHoverAreaBottom" : n.placement.includes("bottom") ? "emptyHoverAreaTop" : n.placement.includes("left") ? "emptyHoverAreaRight" : n.placement.includes("right") ? "emptyHoverAreaLeft" : "");
    function d(m, x = !0) {
      !x || c.value || n.forceShown || (clearTimeout(r.value), r.value = setTimeout(() => m(!1), n.hideDelay));
    }
    function f() {
      clearTimeout(r.value);
    }
    function h(m) {
      var x;
      n.forceHidden || n.forceShown || (clearTimeout(r.value), m(!0), (x = l.value) == null || x.focus());
    }
    function v(m, x) {
      var C;
      if (!(!n.showWhenClicked || n.forceHidden || n.forceShown)) {
        if (!c.value) {
          c.value = !0, m(!0), (C = l.value) == null || C.focus();
          return;
        }
        c.value = !c.value, x && m(!1);
      }
    }
    function y(m) {
      m(!1), c.value = !1;
    }
    function w() {
      c.value = !1;
    }
    return (m, x) => (g(), P(bi, {
      placement: m.placement,
      "has-arrow": !m.hideArrow,
      "force-show-floating-el": m.forceShown,
      onClickOutside: w,
      onHideFloating: x[0] || (x[0] = (C) => o("hide")),
      onShowFloating: x[1] || (x[1] = (C) => o("show"))
    }, {
      reference: Y(({ toggleContentDisplay: C, isFloatingElDisplayed: T }) => [
        M(ne)(i.referenceEl) ? H(m.$slots, "referenceEl", {
          key: 0,
          id: M(a),
          ariaDescribedby: s,
          ariaExpanded: T,
          onClick: (L) => v(C, T),
          onMouseenter: (L) => h(C),
          onMouseleave: (L) => d(C, T),
          onKeydown: gt((L) => y(C), ["escape"])
        }, void 0, !0) : A("", !0)
      ]),
      floating: Y(({ toggleContentDisplay: C }) => [
        M(ne)(i.tooltipContent) ? (g(), I("div", {
          key: 0,
          id: s,
          ref: "tooltipContentRef",
          class: F(["tw-text-body-xs tw-relative tw-z-[999999] tw-flex tw-max-w-[224px] tw-flex-col tw-gap-y-sm tw-rounded-sm tw-bg-fill-alt tw-p-sm tw-text-inverse focus:tw-outline-none", u.value]),
          "aria-controlledby": M(a),
          tabindex: "-1",
          role: "tooltip",
          onMouseenter: f,
          onMouseleave: (T) => d(C),
          onKeydown: gt((T) => y(C), ["escape"])
        }, [
          H(m.$slots, "tooltipContent", {}, void 0, !0)
        ], 42, b0)) : A("", !0)
      ]),
      _: 3
    }, 8, ["placement", "has-arrow", "force-show-floating-el"]));
  }
}), V0 = /* @__PURE__ */ ri(g0, [["__scopeId", "data-v-5ddfca42"]]);
Zo(Wi);
export {
  C0 as Iconify,
  Br as UIBanner,
  T0 as UIBannerMulti,
  oo as UIButton,
  S0 as UIButtonLink,
  ti as UIChip,
  I0 as UIChipButton,
  A0 as UIChipSelection,
  E0 as UIDropdownMenu,
  M0 as UIDropdownMenuList,
  z0 as UIDropdownMenuListItem,
  B as UIIcon,
  ts as UIInputCheckbox,
  F0 as UIInputPassword,
  N0 as UIInputText,
  $0 as UIInputTextarea,
  O0 as UIInputToggleCheckbox,
  L0 as UIInputToggleRadio,
  D0 as UIModal,
  R0 as UISelectionCard,
  P0 as UITab,
  r0 as UITag,
  V0 as UITooltip,
  k0 as grooverUITailwindPlugin
};
